<template>
<div class="container-fluid px-2 bg-danger">
  <div class="row bg-warning">
    <div class="col bg-light border p-2">
        <table id="myLabPrintTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
            <thead class="text-white" style="background:Navy">
            <tr>
                <th title="รับชำระเงิน">Paid</th>
                <th>สถานะ</th>
                <!-- <th>ชื่อสาขา</th> -->
                <th>เลขที่ใบตรวจ</th>
                <th>วันที่</th>
                <th>ชื่อ-สกุล คนไข้</th>
                <th>คลินิก</th>
                <th>เพศ</th>
                <th style="width:130px;" hidden>Covid</th>
                <th>ALGY</th>
                <th><i class="fa fa-print"></i></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in datalists" :key="item.ROID" @click="viewResultRO($event, item)"
              v-bind:data-id="item.ROID">
                <td class="">{{ arrPaid[item.Paid] }}</td>
                <td class="">{{ arrDocStatus[item.Status] }}</td>
                <!-- <td class="text-start">{{ item.BranchName }}</td> -->
                <td class="text-start" :title=' "สิ่งส่งตรวจ : "+item.Specimen'>{{ item.RONo }}</td>
                <td class="text-start">{{ item.DocDate }}</td>
                <td class="text-start">{{ item.PatName }} {{ item.PatLName}}</td>
                <td class="text-start">{{ item.ReqClinicName }}</td>
                <td class="">{{ arrSex[item.Sex] }}</td>
                <td class="text-center" hidden>
                  <!-- แสดงปุ่มพิมพ์ถ้าอนุมัติแล้ว Status=3 -->
                  <!-- <button id="PrintAuto" type="button" v-if="item.Status == 3" title="พิมพ์ใบรับรองผลตรวจ"
                    class="btn btn-info btm-sm py-0" @click="printRODoc(item.ROID, GetCaptionRTPCR_ATK(item.Test))">
                    {{GetCaptionRTPCR_ATK(item.Test)}}
                  </button> -->
                  <button id="PrintAuto" type="button" v-if="item.Status == 3" title="พิมพ์ใบรับรองผลตรวจ ATK"
                    class="btn btn-outline-info btm-sm py-0" @click="printRODoc(item.ROID, 'ATK')">
                    <i class="fa fa-ticket"></i>
                  </button>
                  <button id="PrintAuto" type="button" v-if="item.Status == 3" title="พิมพ์ใบรับรองผลตรวจ RT-PCR"
                    class="btn btn-outline-warning btm-sm py-0 ms-1" @click="printRODoc(item.ROID, 'RT-PCR')">
                    <i class="fa fa-file"></i>
                  </button>
                  <!-- ================================================ -->
                  <!-- เพิ่มปุ่มพิมพ์ผล โควิด แบบอื่นๆ -->
                  <div class="btn-group ms-1" role="group">
                    <!-- แสดงปุ่มพิมพ์ถ้าอนุมัติแล้ว Status=3 -->
                    <button id="Print" type="button"
                      class="btn btn-outline-info btm-sm dropdown-toggle py-0" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="fa fa-print"></i>
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <li><a class="dropdown-item" @click="printRODoc(item.ROID, 'ATK-4')">ฟอร์มโควิค ATK #NO-4</a></li>
                      <li><a class="dropdown-item" @click="printRODoc(item.ROID, 'PCR-5')">ฟอร์มโควิค PCR #NO-5</a></li>
                      <li><a class="dropdown-item" @click="printRODoc(item.ROID, 'ATK-6')">ฟอร์มโควิค ATK #NO-6</a></li>
                      <li><a class="dropdown-item" @click="printRODoc(item.ROID, 'ATK-7')">ฟอร์มโควิค ATK #NO-7</a></li>
                    </ul>
                  </div>
                  <!-- ================================================ -->
                </td>
                <!-- ฟอร์มภูมิแพ้อาหาร -->
                <td>
                  <div class="btn-group" role="group">
                    <!-- แสดงปุ่มพิมพ์ถ้าอนุมัติแล้ว Status=3 -->
                    <button id="Print" type="button" hidden
                      class="btn btn-primary btm-sm dropdown-toggle py-0" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="fa fa-print"></i>
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <li><a class="dropdown-item" @click="printAlgyForm(item, 'ALGY-1')">ฟอร์มภูมิแพ้อาหาร-1</a></li>
                    </ul>
                  </div>
                </td>
                <!-- ปุ่มพิมพ์ A5, A4 : ฟอร์มรายงานผลมาตราฐาน -->
                <td>
                  <!-- ********************************************************************** -->
                  <!-- ***************  w3schools.css : เมนูกรณี BT5 มีปัญหา ******************* -->
                  <!-- ********************************************************************** -->
                  <div hidden>
                    <!-- ============ Paper A5 ============ -->
                    <div class="w3-dropdown-hover">
                      <button class="w3-button w3-grey p-0 px-1 me-1">A5</button>
                      <div class="w3-dropdown-content w3-bar-block w3-card-4 w3-left-align" style="font-size:85%;  width: 300px !important; background-color: WhiteSmoke;">
                        <a class="dropdown-item" @click="printRODocA5(item, 'A5-1')">A5 Method / Specimen / Ref.<i class="fa fa-list-alt float-end"></i></a>
                        <a class="dropdown-item" @click="printRODocA5(item, 'A5-2')">A5 Ref.<i class="fa fa-list-alt float-end"></i></a>
                        <a class="dropdown-item" @click="printRODocA5(item, 'A5-3-smFooter')">A5 Ref.(A5-แนวนอน)<i class="fa fa-list-alt float-end" title="พิมพ์แนวนอน"></i></a>
                        <a class="dropdown-item" @click="printRODocA5(item, 'A5-3P-smFooter')">A5 Ref.(A5-แนวตั้ง) <i class="fa fa-file-text-o float-end me-4" title="พิมพ์แนวตั้ง"></i></a>
                      </div>
                    </div>
                    <!-- ============ Paper A4 ============ -->
                    <div class="w3-dropdown-hover">
                      <button class="w3-button w3-grey p-0 px-1 me-1">A4</button>
                      <div class="w3-dropdown-content w3-bar-block w3-card-4 w3-left-align" style="font-size:85%;  width: 300px !important; background-color: WhiteSmoke;">
                        <a class="dropdown-item" @click="printRODocA5(item, 'A4-1')">A4 Ref.<i class="fa fa-file-text-o float-end me-4"></i></a>
                        <a class="dropdown-item" @click="printRODocA5(item, 'A4-2')">A4 Method / Ref.<i class="fa fa-file-text-o float-end me-4"></i></a>
                        <a class="dropdown-item" @click="printRODocA5(item, 'A4-3')" title="คอลัมส์ Result กว้างพิเศษ (เหมาะกับผลแล็บแบบ #ข้อความ ที่มีข้อความผลแล็บยาว)">A4 Wide RESULT/ Ref.,Method<i class="fa fa-file-text-o float-end me-4"></i></a>
                      </div>
                    </div>
                      <!-- ============ Paper Envelop ============ -->
                    <div class="w3-dropdown-hover">
                      <button class="w3-button w3-grey p-0 px-1 me-1"><i class="fa fa-envelope"></i></button>
                      <div class="w3-dropdown-content w3-bar-block w3-card-4 w3-left-align" style="font-size:85%;  width: 300px !important; background-color: WhiteSmoke;">
                        <a class="dropdown-item" @click="printEnvelopeLogoOnly(item)"><i class="fa fa-envelope"></i> พิมพ์หน้าซองจดหมายเฉพาะโลโก้คลินิก</a>
                        <a class="dropdown-item" @click="printEnvelope(item)"><i class="fa fa-envelope"></i> พิมพ์หน้าซองจดหมายเฉพาะข้อมูลคนไข้</a>
                        <a class="dropdown-item" @click="printEnvelopeWithLogo(item)"><i class="fa fa-envelope"></i> พิมพ์หน้าซองจดหมายแบบมีโลโก้ชื่อและที่อยู่</a>
                      </div>
                    </div>
                  </div>
                  <!-- ************************************************* -->
                  <!-- ***************  เมนูเดิมใช้ BT5 ******************* -->
                  <!-- ************************************************* -->
                  <div class="btn-group" role="group">
                    <!-- ============ Paper A5 ============ -->
                    <div class="btn-group me-1" role="group">
                      <!-- แสดงปุ่มพิมพ์ถ้าอนุมัติแล้ว Status=3 -->
                      <div class="dropdown dropstart text-end">
                        <button id="Print" type="button" v-if="item.Status==3"
                          class="btn btn-primary btn-sm dropdown-toggle py-0" data-bs-toggle="dropdown" aria-expanded="false">
                          A5
                        </button>
                        <ul class="dropdown-menu p-1 border-1 border-dark" aria-labelledby="btnGroupDrop1" style="font-size:85%;  width: 300px !important; background-color: WhiteSmoke;">
                          <li><a class="dropdown-item" @click="printRODocA5(item, 'A5-1New')"><span class="badge bg-info">NEW</span> A5 Method / Specimen / Ref.<i class="fa fa-list-alt float-end"></i></a></li>
                          <li><a class="dropdown-item" @click="printRODocA5(item, 'A5-2New')"><span class="badge bg-info">NEW</span> A5 Ref.<i class="fa fa-list-alt float-end"></i></a></li>
                          <li title="เพิ่มพื้นที่พิมพ์"><a class="dropdown-item" @click="printRODocA5(item, 'A5-3New')"><span class="badge bg-info">NEW</span> A5 Ref.(A5-แนวนอน)<i class="fa fa-list-alt float-end" title="พิมพ์แนวนอน"></i></a></li>
                          <li title="เพิ่มพื้นที่พิมพ์"><a class="dropdown-item" @click="printRODocA5(item, 'A5-4PNew')"><span class="badge bg-info">NEW</span> A5 Ref.(A5-แนวตั้ง) <i class="fa fa-file-text-o float-end me-4" title="พิมพ์แนวตั้ง"></i> </a></li>
                          <div class="dropdown-divider"></div>
                          <li><a class="dropdown-item" @click="printRODocA5(item, 'A5-1')">A5 Method / Specimen / Ref.<i class="fa fa-list-alt float-end"></i></a></li>
                          <li><a class="dropdown-item" @click="printRODocA5(item, 'A5-2')">A5 Ref.<i class="fa fa-list-alt float-end"></i></a></li>
                          <li title="เพิ่มพื้นที่พิมพ์"><a class="dropdown-item" @click="printRODocA5(item, 'A5-3-smFooter')">A5 Ref.(A5-แนวนอน)<i class="fa fa-list-alt float-end" title="พิมพ์แนวนอน"></i></a></li>
                          <li title="เพิ่มพื้นที่พิมพ์"><a class="dropdown-item" @click="printRODocA5(item, 'A5-3P-smFooter')">A5 Ref.(A5-แนวตั้ง) <i class="fa fa-file-text-o float-end me-4" title="พิมพ์แนวตั้ง"></i> </a></li>
                        </ul>
                      </div>
                    </div>
                    <!-- ============ Paper A4 ============ -->
                    <div class="btn-group me-1" role="group">
                      <!-- แสดงปุ่มพิมพ์ถ้าอนุมัติแล้ว Status=3 -->
                      <button id="Print" type="button" v-if="item.Status==3"
                        class="btn btn-primary btn-sm dropdown-toggle py-0" data-bs-toggle="dropdown" aria-expanded="false">
                        A4
                      </button>
                      <ul class="dropdown-menu p-1 border-1 border-dark" aria-labelledby="btnGroupDrop1" style="font-size:85%;  width: 330px !important;">
                        <li><a class="dropdown-item" @click="printRODocA5(item, 'A4-1New')"><span class="badge bg-info">NEW</span> A4 Ref. <i class="fa fa-file-text-o float-end me-4"></i></a></li>
                        <li><a class="dropdown-item" @click="printRODocA5(item, 'A4-2New')"><span class="badge bg-info">NEW</span> A4 Method / Ref. <i class="fa fa-file-text-o float-end me-4"></i></a></li>
                        <li><a class="dropdown-item" @click="printRODocA5(item, 'A4-3New')" title="คอลัมส์ Result กว้างพิเศษ (เหมาะกับผลแล็บแบบ #ข้อความ ที่มีข้อความผลแล็บยาว)"><span class="badge bg-info">NEW</span> A4 Wide RESULT/ Ref., Method <i class="fa fa-file-text-o float-end me-4"></i></a></li>
                        <div class="dropdown-divider"></div>
                        <li><a class="dropdown-item" @click="printRODocA5(item, 'A4-1')">A4 Ref.<i class="fa fa-file-text-o float-end me-4"></i></a></li>
                        <li><a class="dropdown-item" @click="printRODocA5(item, 'A4-2')">A4 Method / Ref.<i class="fa fa-file-text-o float-end me-4"></i></a></li>
                        <li><a class="dropdown-item" @click="printRODocA5(item, 'A4-3')" title="คอลัมส์ Result กว้างพิเศษ (เหมาะกับผลแล็บแบบ #ข้อความ ที่มีข้อความผลแล็บยาว)">A4 Wide RESULT/ Ref.,Method<i class="fa fa-file-text-o float-end me-4"></i></a></li>
                        <!-- <div class="dropdown-divider"></div> -->
                        <!-- <li title="ทดสอบ"><a class="dropdown-item" @click="printRODocA5(item, 'A5-3PBold-smFooter')">A5 Ref.(A5-แนวตั้ง ตัวหนา) <i class="fa fa-file-text-o float-end me-4" title="พิมพ์แนวตั้ง"></i> </a></li> -->
                      </ul>
                    </div>
                    <!-- ============ Paper Envelop ============ -->
                    <div class="btn-group" role="group">
                      <!-- แสดงปุ่มพิมพ์ถ้าอนุมัติแล้ว Status=3 -->
                      <button id="Print" type="button" v-if="item.Status==3"
                        class="btn btn-secondary btn-sm dropdown-toggle py-0" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="fa fa-envelope"></i>
                      </button>
                      <ul class="dropdown-menu p-1 border-1 border-dark" aria-labelledby="btnGroupDrop1" style="font-size:85%;">
                        <li><a class="dropdown-item" @click="printEnvelopeLogoOnly(item)"><i class="fa fa-envelope"></i> พิมพ์หน้าซองจดหมายเฉพาะโลโก้คลินิก</a></li>
                        <li><a class="dropdown-item" @click="printEnvelope(item)"><i class="fa fa-envelope"></i> พิมพ์หน้าซองจดหมายเฉพาะข้อมูลคนไข้</a></li>
                        <li><a class="dropdown-item" @click="printEnvelopeWithLogo(item)"><i class="fa fa-envelope"></i> พิมพ์หน้าซองจดหมายแบบมีโลโก้ชื่อและที่อยู่</a></li>
                      </ul>
                    </div>
                  </div>
                  <!-- ********************************** -->
                </td>
            </tr>
            </tbody>
        </table>
    </div>
  </div>
</div>

<img id="imageid" ref="imageid" hidden crossorigin="anonymous" v-bind:src="require('../assets/' +  globalCorpInfo.logoFile ) + '?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'">

<!-- COLS: Test + Result : แสดง Style ของชุดตรวจด้วย อาทิ สีพื้น, เพิ่มบรรทัดว่าง-->
<div id="divToPrint_2Col" hidden>
  <table style="width:100%" data-pdfmake="{&quot;headerRows&quot;: 1,&quot;layout&quot;:&quot;lightHorizontalLines&quot;}">
    <thead>
      <tr>
        <th>Test</th>
        <th></th>
        <th>Result</th>
      </tr>
    </thead>
    <tr v-for="item in reportDtl" :key="item.ROID">
      <!-- (1) เปลี่ยนสีพื้นหลังตามที่ระบุในชุดตรวจ (2) เพิ่มบรรทัดว่างตามจำนวนที่กำหนดสูงสุด 5 บรรทัด -->
      <td style="width:370px;"  :data-pdfmake="'{&quot;fillColor&quot;:&quot;' + item.BgColor + '&quot;}'">
        <span v-if="nameTestsuitIdx==0"> &nbsp;  {{item.ItemTestName}} </span>
        <span v-else>  &nbsp;  {{item.ItemTestName2}} </span>
        <!-- <br :v-if="parseInt(item.LinesBreak)>0"><br :v-if="parseInt(item.LinesBreak)>1"><br :v-if="parseInt(item.LinesBreak)>2"><br :v-if="parseInt(item.LinesBreak)>3"><br :v-if="parseInt(item.LinesBreak)>4"> -->
        <span v-for="(n, index) in parseInt(item.LinesBreak)" :key="index"> <br> </span>
      </td>
      <td style="width:10px;" > {{arrRepeatChk[item.RepeatChecked]}} </td>
      <td style="width:280px;" v-if="(item.ValueType==1)" data-pdfmake="{&quot;bold&quot;:&quot;true&quot;}">{{item.PrefixResult}} {{item.ResultText}}</td>
      <td style="width:280px;" v-else data-pdfmake="{&quot;bold&quot;:&quot;true&quot;}">{{item.PrefixResult}} {{item.Result}}</td>
    </tr>
  </table>
  <br>
</div>

<!-- ไม่แสดงตามคุณสมบัติของชุดตรวจด้วย | NO COLOR/LinesBreak อาทิ สีพื้น, เพิ่มบรรทัดว่าง-->
<div id="divToPrint" hidden>
  <table style="width:100%" data-pdfmake="{&quot;headerRows&quot;: 1,&quot;layout&quot;:&quot;lightHorizontalLines&quot;}">
    <thead>
      <tr>
        <th>Test</th>
        <th></th>
        <th>Result</th>
        <th>Unit</th>
        <th>Method</th>
        <th>Specimen</th>
        <th>Normal Range</th>
      </tr>
    </thead>
    <tr v-for="item in reportDtl" :key="item.ROID">
      <td style="width:150px;">{{item.ItemTestName}}
          <span v-if="nameTestsuitIdx==0"> &nbsp;  {{item.ItemTestName}} </span>
          <span v-else>  &nbsp;  {{item.ItemTestName2}} </span>
      </td>
      <td style="width:10px;" > {{arrRepeatChk[item.RepeatChecked]}} </td>
      <td style="width:150px;" v-if="(item.ValueType==1)">{{item.PrefixResult}} {{item.ResultText}}</td>
      <td style="width:150px;" v-else>{{item.PrefixResult}} {{  FormatNumResult(item) }}</td>
      <td style="width:60px;"> {{item.Unit}} </td>
      <td style="width:60px;" >{{item.Method}}  </td>
      <td style="width:80px;" > {{item.Specimen}}</td>
      <td style="width:80px;" >{{item.NormalValue}}</td>
    </tr>
  </table>
  <br>
</div>
<!-- formA5Idx= 'A5-1'  -->
<!-- COLS : Test Result Unit Method  Specimen Normal -->
<!-- ตารางใบสั่งตรวจแบบ Master-Detail แต่ละชุดตรวจมีเทสตั้งแต่หนึ่งเทสขึ้นไป -->
<div id="divToPrint_MasterDtl" hidden>
  <!-- <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}"> -->
  <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'headerLineOnly'}">
    <thead>
      <tr class="text-start">
        <th>Test</th>
        <th></th>
        <th>Result</th>
        <th></th>
        <th>Unit</th>
        <th>Method</th>
        <th>Specimen</th>
        <th>Ref. range</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(item1,index) in A5GroupTest" :key="item1.TestID">
        <!-- ====================== HEADER ===================== -->
        <!-- A.CHECK : แสดงชื่อห้องตรวจ ? -->
        <template v-if="optRoomShow">
            <!-- 1.CHECK : NEW PAGE ? -->
            <template v-if="item1.RoomNewPage">
              <!-- CHECK optRoomSplit = True : ถ้าระบุแปลว่าให้พิมพ์ แยกห้อง-แยกหน้า -->
              <template v-if="optRoomSplit">
                <!-- เป็นชุดตรวจแรกของห้อง : ขึ้นหน้าใหม่ + พิมพ์ชื่อห้อง-->
                <tr class="text-center">
                  <td colspan="8" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                </tr>
              </template>
              <template v-else>
                <!-- เป็นชุดตรวจแรกของห้อง : ไม่ขึ้นหน้าใหม่ + พิมพ์ชื่อห้อง-->
                <tr class="text-center" v-if="optRoomShow">
                  <td colspan="8" data-pdfmake="{&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                </tr>
              </template>
            </template>
            <!-- เป็นรายการแรก? -->
            <template v-else-if="index==0">
              <!-- เป็นรายการแรก ไม่ขึ้นหน้าใหม่ + พิมพ์ชื่อห้อง -->
              <tr class="text-center" v-if="optRoomShow">
                <td colspan="8" data-pdfmake="{&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
              </tr>
            </template>
        </template>
        <!-- B.CHECK : ไม่แสดงชื่อห้องตรวจ -->
        <template v-else>
            <!-- 1.CHECK : NEW PAGE ? -->
            <template v-if="item1.RoomNewPage">
              <!-- CHECK optRoomSplit = True : ถ้าระบุแปลว่าให้พิมพ์ แยกห้อง-แยกหน้า -->
              <template v-if="optRoomSplit">
                <!-- เป็นชุดตรวจแรกของห้อง : ขึ้นหน้าใหม่ + ไม่พิมพ์ชื่อห้อง-->
                <tr class="text-center">
                  <td colspan="8" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;center&quot;}"></td>
                </tr>
              </template>
            </template>
        </template>
        <!-- 2.CHECK : เป็นชุดตรวจใหญ่ หรือ ชุดตรวจเดี่ยว ? -->
        <template v-if="item1.CountItemTest>1">
          <!-- เป็นชุดตรวจใหญ่มีหลายเทสย่อย : พิมพชื่อชุดตรวจ -->
          <tr>
            <td colspan="7" ><b>{{item1.TestName}}</b></td>
            <td>{{item1.Specimen}}</td>
          </tr>
        </template>
        <template v-else>
          <!-- เป็นชุดตรวจเดี่ยว มีหนึ่งเทสย่อย : ไม่ต้องพิมพ์ชื่อชุดตรวจ -->
          <tr>
            <!-- 14.01.2566 : เป็นชุดตรวจที่มี่ 1 เทสและสั่งให้ขึ้นหน้าใหม่ NEW PAGE ไม่ต้องพิมพ์ชื่อชุดตรวจ (พิมพ์เฉพาะชื่อเทสย่อย) -->
            <td colspan="8"></td>
          </tr>
        </template>

        <!-- ====================== DETAIL ===================== -->
        <!-- รายการเทส ที่อยู่ในชุดตรวจ (Detail) -->
        <!-- <tr class="text-start" v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID"> -->
        <template v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID">
          <tr class="text-start"  v-if="!optResultedOnly || item2.Result!=='' || item2.ResultText!=='' || item2.PrintUL=='1'">
            <td style="width:145px;" v-if="(item2.PrintUL==0)">
                <span v-if="nameTestsuitIdx==0"> <span v-if="item1.CountItemTest>1">&nbsp;</span> {{item2.ItemTestName}} </span>
                <span v-else> <span v-if="item1.CountItemTest>1">&nbsp;</span> {{item2.ItemTestName2}} </span>
            </td>
            <td style="width:145px;" v-else> <b>{{item2.ItemTestName}}</b></td>
            <td style="width:5px; text-align:right;" > : </td>
            <!-- ------- Beg RESULT COL : ValueType : 0-ตัวเลข 1-ข้อความ 2-รายการเลือก (ตัวเข้มถ้าเป็น detected/positive) -->
            <td style="width:140px;" v-if="(item2.ValueType==1)">
              <span v-if="arrBoldResults.includes(item2.ResultText.toLowerCase().trim())"> <b> {{item2.PrefixResult}} {{item2.ResultText}}</b> </span>
              <span v-else style="white-space: pre-line">{{item2.PrefixResult}}{{item2.ResultText}} </span>
            </td>
            <td style="width:140px;" v-else-if="(item2.ValueType==2)">
              <span v-if="arrBoldResults.includes(item2.Result.toLowerCase().trim())"> <b> {{item2.PrefixResult}}{{item2.Result}}</b> </span>
              <span v-else>{{item2.PrefixResult}}{{item2.Result}} </span>
            </td>
            <td style="width:140px;" v-else>{{item2.PrefixResult}}{{ FormatNumResult(item2) }}</td>
            <!-- ------- End RESULT COL ------- -->
            <td style="width:22px; text-align:right;" >
              <span v-if="arrBoldResults.includes(_lowerCase(arrRepeatChk[item2.RepeatChecked]))"><b>{{arrRepeatChk[item2.RepeatChecked]}}</b></span>
              <span v-if="arrBoldResults.includes( _lowerCase(_getHighLowSign(item2)) )"><b>{{ _getHighLowSign(item2) }}</b></span>
            </td>
            <td style="width:60px;"> {{item2.Unit}}</td>
            <td style="width:50px;">{{item2.Method}}  </td>
            <!-- Check : พิมพ์ specimen ที่บรรทัดแรกบรรทัดเดียว -->
            <td style="width:80px;" v-if="item1.CountItemTest>1"> </td>
            <td style="width:80px;" v-else> {{item2.Specimen}}</td>
            <!-- ------------------- -->
            <td style="width:92px;" >{{ getNormalValueBySex(item2) }} {{ getStageDescByResult(item2) }}</td>
          </tr>
        </template>
      </template>
      <tr>
        <td colspan="8"> <span v-if="A5reportHd.Remark"> <br> <strong> Remark :</strong></span> <span style="white-space: pre-line"> {{A5reportHd.Remark}}</span> </td>
      </tr>
    </tbody>
  </table>
  <!-- 30.12.2565 เพิ่มคำแนะนำเมื่อค่าสูงหรือต่ำ -->
  <br>
  <div class="container">
    <span v-if="_adviceText.length>0">คำแนะนำ :: <br></span>
    <div class="alert alert-warning mb-1" v-for="(item, index) in _adviceText" :key="index">
      <strong>{{index+1}}.</strong> {{item}}
    </div>
  </div>
</div>

<!-- formA5Idx= 'A5-2' -->
<!-- COLS : Test Result Unit Normal -->
<!-- ตารางใบสั่งตรวจแบบ Master-Detail แต่ละชุดตรวจมีเทสตั้งแต่หนึ่งเทสขึ้นไป -->
<div id="divToPrint_MasterDtl1" hidden>
  <!-- <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'headerLineOnly'}"> -->
  <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}">
    <thead>
      <tr class="text-start">
        <th>Test</th>
        <th></th>
        <th>Result</th>
        <th>Unit</th>
        <th>Ref. range</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(item1,index) in A5GroupTest" :key="item1.TestID">
        <!-- <tr class="text-start" v-if="item1.CountItemTest>1">
            <td colspan="5" v-if="item1.NewPage>0 || item1.NewPagePropack > 0" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}" style="text-decoration: underline;"><b>{{item1.TestName}}</b><span v-if="item1.Specimen">&nbsp;&nbsp; ( {{item1.Specimen}} )</span></td>
            <td colspan="5" v-else style="text-decoration: underline;"><b>{{item1.TestName}}</b> <span v-if="item1.Specimen">&nbsp;&nbsp; ( {{item1.Specimen}} )</span></td>
        </tr>
        <tr v-else-if="item1.NewPage>0 || item1.NewPagePropack > 0">
            <td colspan="5" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}"></td>
        </tr> -->
        <!-- ====================== HEADER ===================== -->
        <!-- A.CHECK : แสดงชื่อห้องตรวจ ? -->
        <template v-if="optRoomShow">
            <!-- 1.CHECK : NEW PAGE ? -->
            <template v-if="item1.RoomNewPage">
              <!-- CHECK optRoomSplit = True : ถ้าระบุแปลว่าให้พิมพ์ แยกห้อง-แยกหน้า -->
              <template v-if="optRoomSplit">
                <!-- เป็นชุดตรวจแรกของห้อง : ขึ้นหน้าใหม่ + พิมพ์ชื่อห้อง-->
                <tr class="text-center">
                  <td colspan="5" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                </tr>
              </template>
              <template v-else>
                <!-- เป็นชุดตรวจแรกของห้อง : ไม่ขึ้นหน้าใหม่ + พิมพ์ชื่อห้อง-->
                <tr class="text-center"  v-if="optRoomShow">
                  <td colspan="5" data-pdfmake="{&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                </tr>
              </template>
            </template>
            <!-- เป็นรายการแรก -->
            <template v-else-if="index==0">
              <!-- เป็นรายการแรก ไม่ขึ้นหน้าใหม่ + พิมพ์ชื่อห้อง -->
              <tr class="text-center" v-if="optRoomShow">
                <td colspan="5" data-pdfmake="{&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
              </tr>
            </template>
        </template>
        <!-- B.CHECK : ไม่แสดงชื่อห้องตรวจ -->
        <template v-else>
            <!-- 1.CHECK : NEW PAGE ? -->
            <template v-if="item1.RoomNewPage">
              <!-- CHECK optRoomSplit = True : ถ้าระบุแปลว่าให้พิมพ์ แยกห้อง-แยกหน้า -->
              <template v-if="optRoomSplit">
                <!-- เป็นชุดตรวจแรกของห้อง : ขึ้นหน้าใหม่ + ไม่พิมพ์ชื่อห้อง-->
                <tr class="text-center">
                  <td colspan="5" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;center&quot;}"></td>
                </tr>
              </template>
            </template>
        </template>
        <!-- 2.CHECK : เป็นชุดตรวจใหญ่ หรือ ชุดตรวจเดี่ยว ? -->
        <template v-if="item1.CountItemTest>1">
          <!-- เป็นชุดตรวจใหญ่มีหลายเทสย่อย : พิมพชื่อชุดตรวจ -->
          <tr>
            <td colspan="4" ><b>{{item1.TestName}}</b></td>
            <td>{{item1.Specimen}}</td>
          </tr>
        </template>
        <template v-else>
          <!-- เป็นชุดตรวจเดี่ยว มีหนึ่งเทสย่อย : ไม่ต้องพิมพ์ชื่อชุดตรวจ -->
          <!-- 14.01.2566 : เป็นชุดตรวจที่มี่ 1 เทสและสั่งให้ขึ้นหน้าใหม่ NEW PAGE ไม่ต้องพิมพ์ชื่อชุดตรวจ (พิมพ์เฉพาะชื่อเทสย่อย) -->
          <!-- <tr>
            <td colspan="5"></td>
          </tr> -->
        </template>

        <!-- ====================== DETAIL ===================== -->
        <!-- รายการเทส ที่อยู่ในชุดตรวจ (Detail) -->
        <template v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID">
          <tr class="text-start" v-if="!optResultedOnly || item2.Result!=='' || item2.ResultText!=='' || item2.PrintUL=='1'">
            <td style="width:210px;" v-if="(item2.PrintUL==0)">
              <span v-if="nameTestsuitIdx==0"> <span v-if="item1.CountItemTest>1">&nbsp;</span>  {{item2.ItemTestName}} </span>
              <span v-else>  <span v-if="item1.CountItemTest>1">&nbsp;</span>  {{item2.ItemTestName2}} </span>
            </td>
            <td style="width:210px;" v-else> <b>{{item2.ItemTestName}}</b> </td>
            <td style="width:22px; text-align:right;" >
              <span v-if="arrBoldResults.includes(_lowerCase(arrRepeatChk[item2.RepeatChecked]))"><b>{{arrRepeatChk[item2.RepeatChecked]}}</b></span>
              <span v-if="arrBoldResults.includes( _lowerCase(_getHighLowSign(item2)) )"><b>{{ _getHighLowSign(item2) }}</b></span>
            </td>
            <!-- ------- Beg RESULT COL : ValueType : 0-ตัวเลข 1-ข้อความ 2-รายการเลือก (ตัวเข้มถ้าเป็น detected/positive) -->
            <td style="width:140px;" v-if="(item2.ValueType==1)">
              <span v-if="arrBoldResults.includes(item2.ResultText.toLowerCase().trim())"> <b> {{item2.PrefixResult}}{{item2.ResultText}}</b> </span>
              <span v-else style="white-space: pre-line">{{item2.PrefixResult}}{{item2.ResultText}} </span>
            </td>
            <td style="width:140px;" v-else-if="(item2.ValueType==2)">
              <span v-if="arrBoldResults.includes(item2.Result.toLowerCase().trim())"> <b> {{item2.PrefixResult}}{{item2.Result}}</b> </span>
              <span v-else>{{item2.PrefixResult}}{{item2.Result}} </span>
            </td>
            <td style="width:140px;" v-else>{{item2.PrefixResult}}{{ FormatNumResult(item2) }}</td>
            <!-- ------- End RESULT COL ------- -->
            <td style="width:120px;"> {{item2.Unit}}</td>
            <td style="width:164px;">{{ getNormalValueBySex(item2) }} {{ getStageDescByResult(item2) }}</td>
          </tr>
        </template>
      </template>
      <tr>
        <td colspan="5"> <span v-if="A5reportHd.Remark"> <br> <strong> Remark :</strong></span> <span style="white-space: pre-line"> {{A5reportHd.Remark}}</span> </td>
      </tr>
    </tbody>
  </table>
  <!-- 30.12.2565 เพิ่มคำแนะนำเมื่อค่าสูงหรือต่ำ -->
  <br>
  <div class="container">
    <span v-if="_adviceText.length>0">คำแนะนำ :: <br></span>
    <div class="alert alert-warning mb-1" v-for="(item, index) in _adviceText" :key="index">
      <strong>{{index+1}}.</strong> {{item}}
    </div>
  </div>
</div>

<!-- ===================================================== -->
<!-- 09.05.2567 NEW A5 : อยากรวมทุกฟอร์ม A5 ไว้ใน div เดียวกัน  -->
<!--  ต้นแบบ divToPrint_MasterDtlA5L_smFooter A5-3L :      -->
<!-- ===================================================== -->
<div id="divToPrint_MasterDtlA5_1New" hidden>
  <!-- <table style="width:100%" data-pdfmake="{'headerRows': 2, 'layout':'headerLineOnly'}"> -->
  <!-- <table style="width:100%" data-pdfmake="{'headerRows': 2, 'layout':'noBorders'}"> -->
  <table style="width:100%" :data-pdfmake="arrPdfOption[Number(optHLineTable)]">
    <!-- ============================= -->
    <!-- A5 ฟอร์มที่ 1 : A5 Method / Specimen / Ref. -->
    <!-- ============================= -->
    <template v-if="formA4A5=='A5-1New'">
      <thead>
        <tr class="text-start">
          <th style="width:210px;">Test</th>
          <th style="width:5px;"></th>
          <th style="width:130px;">Result</th>
          <th style="width:22px;"></th>
          <th style="width:120px;">Unit</th>
          <th style="width:140px;">Ref. range</th>
        </tr>
      </thead>
    </template>
    <!-- ============================= -->
    <!-- A5 ฟอร์มที่ 2 : A5 Ref. -->
    <!-- ============================= -->
    <template v-if="formA4A5=='A5-2New'">
      <thead>
      <tr class="text-start">
        <th style="width:235px;">Test</th>
        <th style="width:5px;"></th>
        <th style="width:120px;">Result</th>
        <th style="width:22px;"></th>
        <th style="width:100px;">Unit</th>
        <th style="width:145px;">Ref. range</th>
      </tr>
      </thead>
    </template>
    <!-- ============================= -->
    <!-- A5 ฟอร์มที่ 3 : A5 Ref. แนวนอน sm-footer -->
    <!-- ============================= -->
    <template v-if="formA4A5=='A5-3New'">
    <thead>
      <tr class="text-start">
        <th style="width:235px;">Test</th>
        <th style="width:5px;"></th>
        <th style="width:120px;">Result</th>
        <th style="width:22px;"></th>
        <th style="width:100px;">Unit</th>
        <th style="width:145px;">Ref. range</th>
      </tr>
    </thead>
    </template>
    <!-- ============================= -->
    <!-- A5 ฟอร์มที่ 4 : A5 Ref. แนวตั้ง sm-footer -->
    <!-- ============================= -->
    <template v-if="formA4A5=='A5-4PNew'">
    <thead>
      <tr class="text-start">
        <th style="width:120px;">Test</th>
        <th style="width:5px;"></th>
        <th style="width:80px;">Result</th>
        <th style="width:22px;"></th>
        <th style="width:60px;">Unit</th>
        <th style="width:120px;">Ref. range</th>
      </tr>
    </thead>
    </template>
    <tbody>
      <template v-for="(item1,index) in A5GroupTest" :key="item1.TestID">
        <!-- ====================== HEADER SPLIT TEST ===================== -->
        <!--
          - Check ขึ้นหน้าใหม่?
          - Check เป็นชุดตรวจแรก? : index == 0
          - Check พิมพ์ชื่อห้องตรวจ? : optRoomShow == true
          - if Check ห้องตรวจใหม่ให้แยกหน้าใหม่? : RoomNewPage == true (assign จาก chkbox "optRoomSplit")
            -- Check เป็นชุดตรวจกลุ่มหรือเดี่ยว? : ชุดตรวจกลุ่ม -> item1.CountItemTest>1
          - else Check ชุดตรวจใหม่ให้แยกหน้าใหม่? : NewPage == true (assign จาก chkbox "optTSSplit")
            -- Check เป็นชุดตรวจกลุ่มหรือเดี่ยว? : ชุดตรวจกลุ่ม -> item1.CountItemTest>1
         -->
        <!-- * ขึ้นหน้าใหม่/ขึ้นแผ่นใหม่ * -->
        <!-- <template v-if="optRoomSplit || optTSSplit || item1.NewPage>0 || item1.RoomNewPage"> -->
        <template v-if="index===0 || item1.NewPage>0 || item1.RoomNewPage">
            <!-- เป็นรายการแรก ถือเป็นหน้าใหม่อยู่แล้ว : พิมพ์เลย! -->
            <template v-if="index===0">
                <!-- แสดง [ชื่อห้องตรวจ] -->
                <template v-if="optRoomShow">
                    <!-- เป็นชุดตรวจแบบกลุ่ม เช่น CBC -->
                    <template v-if="item1.CountItemTest>1">
                        <!-- ไม่ขึ้นหน้าใหม่ / พิมพ์ [ชื่อห้อง] / พิมพ์ [ชื่อชุดตรวจ] -->
                        <tr class="text-center">
                          <td colspan="6" data-pdfmake="{&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                        </tr>
                        <tr class="text-start">
                          <td colspan="5" ><b>{{item1.TestName}}</b></td>
                          <td>{{item1.Specimen}}</td>
                        </tr>
                    </template>
                    <!-- เป็นชุดตรวจเดี่ยว เช่น FBS -->
                    <template v-else>
                        <!-- ไม่ขึ้นหน้าใหม่ / พิมพ์ [ชื่อห้อง] - (ไม่พิมพ์ "ชื่อชุดตรวจ") -->
                        <tr class="text-center">
                          <td colspan="6" data-pdfmake="{&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}] </b></td>
                        </tr>
                    </template>
                </template>
                <!-- ไม่แสดง [ชื่อห้องตรวจ] -->
                <template v-else>
                    <!-- เป็นชุดตรวจแบบกลุ่ม เช่น CBC -->
                    <template v-if="item1.CountItemTest>1">
                        <!-- ไม่ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] / พิมพ์ [ชื่อชุดตรวจ] -->
                        <tr class="text-start">
                          <td colspan="5"><b>{{item1.TestName}}</b></td>
                          <td>{{item1.Specimen}}</td>
                        </tr>
                    </template>
                    <!-- เป็นชุดตรวจเดี่ยว เช่น FBS -->
                    <template v-else>
                        <!-- ไม่ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] - (ไม่พิมพ์ "ชื่อชุดตรวจ") -->
                        <tr class="text-start">
                          <td colspan="6"></td>
                        </tr>
                    </template>
                </template>
            </template>
            <!-- เป็นรายการชุดตรวจที่ 2,3,.. -->
            <template v-else>
                <!-- แสดง [ชื่อห้องตรวจ] -->
                <template v-if="optRoomShow">
                    <!-- เป็นชุดตรวจแบบกลุ่ม เช่น CBC -->
                    <template v-if="item1.CountItemTest>1">
                        <!-- ขึ้นหน้าใหม่ / พิมพ์ [ชื่อห้อง] / พิมพ์ [ชื่อชุดตรวจ] -->
                        <tr class="text-center">
                          <td colspan="6" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                        </tr>
                        <tr class="text-start">
                          <td colspan="5" ><b>{{item1.TestName}}</b></td>
                          <td>{{item1.Specimen}}</td>
                        </tr>
                    </template>
                    <!-- เป็นชุดตรวจเดี่ยว เช่น FBS -->
                    <template v-else>
                        <!-- ขึ้นหน้าใหม่ / พิมพ์ [ชื่อห้อง] - (ไม่พิมพ์ "ชื่อชุดตรวจ") -->
                        <tr class="text-center">
                          <td colspan="6" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                        </tr>
                    </template>
                </template>
                <!-- ไม่แสดง [ชื่อห้องตรวจ] -->
                <template v-else>
                    <!-- เป็นชุดตรวจแบบกลุ่ม เช่น CBC -->
                    <template v-if="item1.CountItemTest>1">
                        <!-- ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] / พิมพ์ [ชื่อชุดตรวจ] -->
                        <tr class="text-start">
                          <td colspan="5" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;left&quot;}"><b>{{item1.TestName}}</b></td>
                          <td>{{item1.Specimen}}</td>
                        </tr>
                    </template>
                    <!-- เป็นชุดตรวจเดี่ยว เช่น FBS -->
                    <template v-else>
                        <!-- ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] - (ไม่พิมพ์ "ชื่อชุดตรวจ") -->
                        <tr class="text-start">
                          <td colspan="6" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;left&quot;}"></td>
                        </tr>
                    </template>
                </template>
            </template>
        </template>
        <!-- * ไม่ขึ้นหน้าใหม่/ไม่ขึ้นแผ่นใหม่ *  -->
        <template v-else>
            <!-- แสดง [ชื่อห้องตรวจ] -->
            <template v-if="optRoomShow">
                <!-- ถ้าเป็นชุดตรวจแรกของห้อง พิมพ์ [ชื่อห้องตรวจ] -->
                <template v-if="item1.RoomFirstTS">
                    <!-- เป็นชุดตรวจแบบกลุ่ม เช่น CBC -->
                    <template v-if="item1.CountItemTest>1">
                        <!-- ไม่ขึ้นหน้าใหม่ / พิมพ์ [ชื่อห้อง] / พิมพ์ [ชื่อชุดตรวจ] -->
                        <tr class="text-center">
                          <td colspan="6" data-pdfmake="{&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                        </tr>
                        <tr class="text-start">
                          <td colspan="5" ><b>{{item1.TestName}}</b></td>
                          <td>{{item1.Specimen}}</td>
                        </tr>
                    </template>
                    <!-- เป็นชุดตรวจเดี่ยว เช่น FBS -->
                    <template v-else>
                        <!-- ไม่ขึ้นหน้าใหม่ / พิมพ์ [ชื่อห้อง] - (ไม่พิมพ์ "ชื่อชุดตรวจ") -->
                        <tr class="text-center">
                          <td colspan="6" data-pdfmake="{&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                        </tr>
                    </template>
                </template>
                <!-- ไม่ชุดตรวจแรกของห้อง ไม่ต้องพิมพ์ [ชื่อห้องตรวจ] -->
                <template v-else>
                    <!-- เป็นชุดตรวจแบบกลุ่ม เช่น CBC -->
                    <template v-if="item1.CountItemTest>1">
                        <!-- ไม่ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] / พิมพ์ [ชื่อชุดตรวจ] -->
                        <tr class="text-start">
                          <td colspan="5" ><b>{{item1.TestName}}</b></td>
                          <td>{{item1.Specimen}}</td>
                        </tr>
                    </template>
                    <!-- เป็นชุดตรวจเดี่ยว เช่น FBS -->
                    <template v-else>
                        <!-- ไม่ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] - (ไม่พิมพ์ "ชื่อชุดตรวจ") -->
                        <!-- <tr class="text-center">
                          <td colspan="6" ></td>
                        </tr> -->
                    </template>
                </template>
            </template>
            <!-- ไม่แสดง [ชื่อห้องตรวจ] -->
            <template v-else>
                <!-- เป็นชุดตรวจแบบกลุ่ม เช่น CBC -->
                <template v-if="item1.CountItemTest>1">
                    <!--  ไม่ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] / พิมพ์ [ชื่อชุดตรวจ] -->
                    <tr class="text-start">
                      <td colspan="5" ><b>{{item1.TestName}}</b></td>
                      <td>{{item1.Specimen}}</td>
                    </tr>
                </template>
                <!-- เป็นชุดตรวจเดี่ยว เช่น FBS -->
                <template v-else>
                    <!-- ไม่ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] - (ไม่พิมพ์ "ชื่อชุดตรวจ") -->
                    <!-- <tr class="text-start">
                      <td colspan="6" ></td>
                    </tr> -->
                </template>
            </template>
        </template>
        <!-- ====================== DETAIL ===================== -->
        <!-- รายการเทส ที่อยู่ในชุดตรวจ (Detail) -->
        <!-- <tr class="text-start" v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID"> -->
        <template v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID">
          <tr class="text-start"  v-if="!optResultedOnly || item2.Result!=='' || item2.ResultText!=='' || item2.PrintUL=='1'">
            <td v-if="(item2.PrintUL==0)">
                <span v-if="nameTestsuitIdx==0"> <span v-if="item1.CountItemTest>1">&nbsp;</span> {{item2.ItemTestName}} </span>
                <span v-else> <span v-if="item1.CountItemTest>1">&nbsp;</span> {{item2.ItemTestName2}} </span>
            </td>
            <td v-else> <b>{{item2.ItemTestName}}</b></td>
            <td style="text-align:right;" > : </td>
            <!-- ------- Beg RESULT COL : ValueType : 0-ตัวเลข 1-ข้อความ 2-รายการเลือก (ตัวเข้มถ้าเป็น detected/positive) -->
            <td v-if="(item2.ValueType==1)">
              <span v-if="arrBoldResults.includes(item2.ResultText.toLowerCase().trim())"> <b> {{item2.PrefixResult}}{{item2.ResultText}}</b> </span>
              <span v-else style="white-space: pre-line">{{item2.PrefixResult}}{{item2.ResultText}} </span>
            </td>
            <td v-else-if="(item2.ValueType==2)">
              <span v-if="arrBoldResults.includes(item2.Result.toLowerCase().trim())"> <b> {{item2.PrefixResult}}{{item2.Result}}</b> </span>
              <span v-else>{{item2.PrefixResult}}{{item2.Result}} </span>
            </td>
            <td v-else>{{item2.PrefixResult}}{{ FormatNumResult(item2) }}</td>
            <!-- ------- End RESULT COL ------- -->
            <td style="text-align:right;" >
              <span v-if="arrBoldResults.includes(_lowerCase(arrRepeatChk[item2.RepeatChecked]))"><b>{{arrRepeatChk[item2.RepeatChecked]}}</b></span>
              <span v-if="arrBoldResults.includes( _lowerCase(_getHighLowSign(item2)) )"><b>{{ _getHighLowSign(item2) }}</b></span>
            </td>
            <td> {{item2.Unit}}</td>
            <!-- ------------------- -->
            <td>{{ getNormalValueBySex(item2) }} {{ getStageDescByResult(item2) }}</td>
          </tr>
        </template>
      </template>
      <tr>
        <td colspan="6"> <span v-if="A5reportHd.Remark"> <br> <strong> Remark :</strong></span> <span style="white-space: pre-line"> {{A5reportHd.Remark}}</span> </td>
      </tr>
    </tbody>
  </table>
  <!-- 30.12.2565 เพิ่มคำแนะนำเมื่อค่าสูงหรือต่ำ -->
  <br>
  <div class="container">
    <span v-if="_adviceText.length>0">คำแนะนำ :: <br></span>
    <div class="alert alert-warning mb-1" v-for="(item, index) in _adviceText" :key="index">
      <strong>{{index+1}}.</strong> {{item}}
    </div>
  </div>
</div>

<!-- ===================================================== -->
<!-- 26.04.2567 NEW A4 : อยากรวมทุกฟอร์ม A4 ไว้ใน div เดียวกัน  -->
<!--  ต้นแบบ divToPrint_MasterDtlA5L_smFooter A5-3L :      -->
<!-- ===================================================== -->
<div id="divToPrint_MasterDtlA4_1New" hidden>
  <!-- <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'noBorders'}"> -->
  <!-- <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'headerLineOnly'}"> -->
  <!-- <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}"> -->
  <table style="width:100%" :data-pdfmake="arrPdfOption[Number(optHLineTable)]">
    <!-- ============================= -->
    <!-- A4 ฟอร์มที่ 1 : Ref. -->
    <!-- ============================= -->
    <template v-if="formA4A5=='A4-1New'">
      <thead>
        <tr class="text-start">
          <th style="width:210px;">Test</th>
          <th style="width:5px;"></th>
          <th style="width:130px;">Result</th>
          <th style="width:22px;"></th>
          <th style="width:120px;">Unit</th>
          <th style="width:140px;">Ref. range</th>
        </tr>
      </thead>
    </template>
    <!-- ============================= -->
    <!-- A4 ฟอร์มที่ 2 : Method / Ref. -->
    <!-- ============================= -->
    <template v-if="formA4A5=='A4-2New'">
      <thead>
        <tr class="text-start">
          <th style="width:200px;">Test</th>
          <th style="width:5px;"></th>
          <th style="width:130px;">Result</th>
          <th style="width:22px;"></th>
          <th style="width:60px;">Unit</th>
          <th style="width:60px;">Method</th>
          <th style="width:130px;">Ref. range</th>
        </tr>
      </thead>
    </template>
    <!-- ============================= -->
    <!-- A4 ฟอร์มที่ 3 : WIDE Result / Ref. & Method-->
    <!-- ============================= -->
    <template v-if="formA4A5=='A4-3New'">
      <thead>
        <tr class="text-start">
          <th style="width:180px;">Test</th>
          <th style="width:5px;"></th>
          <th style="width:250px;">Result</th>
          <th style="width:22px;"></th>
          <th style="width:60px;">Unit</th>
          <th style="width:110px;">Ref. / Method</th>
        </tr>
      </thead>
    </template>
    <tbody>
      <template v-for="(item1,index) in A5GroupTest" :key="item1.TestID">
        <!-- ====================== HEADER SPLIT TEST ===================== -->
        <!--
          - Check ขึ้นหน้าใหม่?
          - Check เป็นชุดตรวจแรก? : index == 0
          - Check พิมพ์ชื่อห้องตรวจ? : optRoomShow == true
          - if Check ห้องตรวจใหม่ให้แยกหน้าใหม่? : RoomNewPage == true (assign จาก chkbox "optRoomSplit")
            -- Check เป็นชุดตรวจกลุ่มหรือเดี่ยว? : ชุดตรวจกลุ่ม -> item1.CountItemTest>1
          - else Check ชุดตรวจใหม่ให้แยกหน้าใหม่? : NewPage == true (assign จาก chkbox "optTSSplit")
            -- Check เป็นชุดตรวจกลุ่มหรือเดี่ยว? : ชุดตรวจกลุ่ม -> item1.CountItemTest>1
         -->
        <!-- * ขึ้นหน้าใหม่/ขึ้นแผ่นใหม่ * -->
        <!-- <template v-if="optRoomSplit || optTSSplit || item1.NewPage>0 || item1.RoomNewPage"> -->
        <template v-if="index===0 || item1.NewPage>0 || item1.RoomNewPage">
            <!-- เป็นรายการแรก ถือเป็นหน้าใหม่อยู่แล้ว : พิมพ์เลย! -->
            <template v-if="index===0">
                <!-- แสดง [ชื่อห้องตรวจ] -->
                <template v-if="optRoomShow">
                    <!-- เป็นชุดตรวจแบบกลุ่ม เช่น CBC -->
                    <template v-if="item1.CountItemTest>1">
                        <!-- ไม่ขึ้นหน้าใหม่ / พิมพ์ [ชื่อห้อง] / พิมพ์ [ชื่อชุดตรวจ] -->
                        <tr class="text-center">
                          <td colspan="6" data-pdfmake="{&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                        </tr>
                        <tr class="text-start">
                          <td colspan="5" ><b>{{item1.TestName}}</b></td>
                          <td>{{item1.Specimen}}</td>
                        </tr>
                    </template>
                    <!-- เป็นชุดตรวจเดี่ยว เช่น FBS -->
                    <template v-else>
                        <!-- ไม่ขึ้นหน้าใหม่ / พิมพ์ [ชื่อห้อง] - (ไม่พิมพ์ "ชื่อชุดตรวจ") -->
                        <tr class="text-center">
                          <td colspan="6"><b>[{{item1.RoomtypeName}}]</b></td>
                        </tr>
                    </template>
                </template>
                <!-- ไม่แสดง [ชื่อห้องตรวจ] -->
                <template v-else>
                    <!-- เป็นชุดตรวจแบบกลุ่ม เช่น CBC -->
                    <template v-if="item1.CountItemTest>1">
                        <!-- ไม่ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] / พิมพ์ [ชื่อชุดตรวจ] -->
                        <tr class="text-start">
                          <td colspan="5"><b>{{item1.TestName}}</b></td>
                          <td>{{item1.Specimen}}</td>
                        </tr>
                    </template>
                    <!-- เป็นชุดตรวจเดี่ยว เช่น FBS -->
                    <template v-else>
                        <!-- ไม่ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] - (ไม่พิมพ์ "ชื่อชุดตรวจ") -->
                        <tr class="text-start">
                          <td colspan="6"></td>
                        </tr>
                    </template>
                </template>
            </template>
            <!-- เป็นรายการชุดตรวจที่ 2,3,.. -->
            <template v-else>
                <!-- แสดง [ชื่อห้องตรวจ] -->
                <template v-if="optRoomShow">
                    <!-- เป็นชุดตรวจแบบกลุ่ม เช่น CBC -->
                    <template v-if="item1.CountItemTest>1">
                        <!-- ขึ้นหน้าใหม่ / พิมพ์ [ชื่อห้อง] / พิมพ์ [ชื่อชุดตรวจ] -->
                        <tr class="text-center">
                          <td colspan="6" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                        </tr>
                        <tr class="text-start">
                          <td colspan="5" ><b>{{item1.TestName}}</b></td>
                          <td>{{item1.Specimen}}</td>
                        </tr>
                    </template>
                    <!-- เป็นชุดตรวจเดี่ยว เช่น FBS -->
                    <template v-else>
                        <!-- ขึ้นหน้าใหม่ / พิมพ์ [ชื่อห้อง] - (ไม่พิมพ์ "ชื่อชุดตรวจ") -->
                        <tr class="text-center">
                          <td colspan="6" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                        </tr>
                    </template>
                </template>
                <!-- ไม่แสดง [ชื่อห้องตรวจ] -->
                <template v-else>
                    <!-- เป็นชุดตรวจแบบกลุ่ม เช่น CBC -->
                    <template v-if="item1.CountItemTest>1">
                        <!-- ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] / พิมพ์ [ชื่อชุดตรวจ] -->
                        <tr class="text-start">
                          <td colspan="5" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;left&quot;}"><b>{{item1.TestName}}</b></td>
                          <td>{{item1.Specimen}}</td>
                        </tr>
                    </template>
                    <!-- เป็นชุดตรวจเดี่ยว เช่น FBS -->
                    <template v-else>
                        <!-- ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] - (ไม่พิมพ์ "ชื่อชุดตรวจ") -->
                        <tr class="text-start">
                          <td colspan="6" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;left&quot;}"></td>
                        </tr>
                    </template>
                </template>
            </template>
        </template>
        <!-- * ไม่ขึ้นหน้าใหม่/ไม่ขึ้นแผ่นใหม่ *  -->
        <template v-else>
            <!-- แสดง [ชื่อห้องตรวจ] -->
            <template v-if="optRoomShow">
                <!-- ถ้าเป็นชุดตรวจแรกของห้อง พิมพ์ [ชื่อห้องตรวจ] -->
                <template v-if="item1.RoomFirstTS">
                    <!-- เป็นชุดตรวจแบบกลุ่ม เช่น CBC -->
                    <template v-if="item1.CountItemTest>1">
                        <!-- ไม่ขึ้นหน้าใหม่ / พิมพ์ [ชื่อห้อง] / พิมพ์ [ชื่อชุดตรวจ] -->
                        <tr class="text-center">
                          <td colspan="6" data-pdfmake="{&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                        </tr>
                        <tr class="text-start">
                          <td colspan="5" ><b>{{item1.TestName}}</b></td>
                          <td>{{item1.Specimen}}</td>
                        </tr>
                    </template>
                    <!-- เป็นชุดตรวจเดี่ยว เช่น FBS -->
                    <template v-else>
                        <!-- ไม่ขึ้นหน้าใหม่ / พิมพ์ [ชื่อห้อง] - (ไม่พิมพ์ "ชื่อชุดตรวจ") -->
                        <tr class="text-center">
                          <td colspan="6" data-pdfmake="{&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                        </tr>
                    </template>
                </template>
                <!-- ไม่ชุดตรวจแรกของห้อง ไม่ต้องพิมพ์ [ชื่อห้องตรวจ] -->
                <template v-else>
                    <!-- เป็นชุดตรวจแบบกลุ่ม เช่น CBC -->
                    <template v-if="item1.CountItemTest>1">
                        <!-- ไม่ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] / พิมพ์ [ชื่อชุดตรวจ] -->
                        <tr class="text-start">
                          <td colspan="5" ><b>{{item1.TestName}}</b></td>
                          <td>{{item1.Specimen}}</td>
                        </tr>
                    </template>
                    <!-- เป็นชุดตรวจเดี่ยว เช่น FBS -->
                    <template v-else>
                        <!-- ไม่ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] - (ไม่พิมพ์ "ชื่อชุดตรวจ") -->
                        <!-- <tr class="text-center">
                          <td colspan="6" ></td>
                        </tr> -->
                    </template>
                </template>
            </template>
            <!-- ไม่แสดง [ชื่อห้องตรวจ] -->
            <template v-else>
                <!-- เป็นชุดตรวจแบบกลุ่ม เช่น CBC -->
                <template v-if="item1.CountItemTest>1">
                    <!--  ไม่ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] / พิมพ์ [ชื่อชุดตรวจ] -->
                    <tr class="text-start">
                      <td colspan="5" ><b>{{item1.TestName}}</b></td>
                      <td>{{item1.Specimen}}</td>
                    </tr>
                </template>
                <!-- เป็นชุดตรวจเดี่ยว เช่น FBS -->
                <template v-else>
                    <!-- ไม่ขึ้นหน้าใหม่ / ไม่พิมพ์ [ชื่อห้อง] - (ไม่พิมพ์ "ชื่อชุดตรวจ") -->
                    <!-- <tr class="text-start">
                      <td colspan="6" ></td>
                    </tr> -->
                </template>
            </template>
        </template>

        <!-- ====================== DETAIL ===================== -->
        <!-- รายการเทส ที่อยู่ในชุดตรวจ (Detail) -->
        <!-- <tr class="text-start" v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID"> -->
        <template v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID">
          <tr class="text-start"  v-if="!optResultedOnly || item2.Result!=='' || item2.ResultText!=='' || item2.PrintUL=='1'">
            <td v-if="(item2.PrintUL==0)">
                <span v-if="nameTestsuitIdx==0"> <span v-if="item1.CountItemTest>1">&nbsp;</span> {{item2.ItemTestName}} </span>
                <span v-else> <span v-if="item1.CountItemTest>1">&nbsp;</span> {{item2.ItemTestName2}} </span>
            </td>
            <td v-else> <b>{{item2.ItemTestName}}</b></td>
            <td style="text-align:right;" > : </td>
            <!-- ------- Beg RESULT COL : ValueType : 0-ตัวเลข 1-ข้อความ 2-รายการเลือก (ตัวเข้มถ้าเป็น detected/positive) -->
            <td v-if="(item2.ValueType==1)">
              <span v-if="arrBoldResults.includes(item2.ResultText.toLowerCase().trim())"> <b> {{item2.PrefixResult}}{{item2.ResultText}}</b> </span>
              <span v-else style="white-space: pre-line">{{item2.PrefixResult}}{{item2.ResultText}} </span>
            </td>
            <td v-else-if="(item2.ValueType==2)">
              <span v-if="arrBoldResults.includes(item2.Result.toLowerCase().trim())"> <b> {{item2.PrefixResult}}{{item2.Result}}</b> </span>
              <span v-else>{{item2.PrefixResult}}{{item2.Result}} </span>
            </td>
            <td v-else>{{item2.PrefixResult}}{{ FormatNumResult(item2) }}</td>
            <!-- ------- End RESULT COL ------- -->
            <td style="text-align:right;" >
              <span v-if="arrBoldResults.includes(_lowerCase(arrRepeatChk[item2.RepeatChecked]))"><b>{{arrRepeatChk[item2.RepeatChecked]}}</b></span>
              <span v-if="arrBoldResults.includes( _lowerCase(_getHighLowSign(item2)) )"><b>{{ _getHighLowSign(item2) }}</b></span>
            </td>
            <td> {{item2.Unit}}</td>
            <!-- ------------------- -->
            <td v-if="formA4A5=='A4-2New'">{{item2.Method}}</td>
            <td>{{ getNormalValueBySex(item2) }} {{ getStageDescByResult(item2) }}</td>
          </tr>
        </template>
      </template>
      <tr>
        <td colspan="6" v-if="formA4A5=='A4-1New'"> <span v-if="A5reportHd.Remark"> <br> <strong> Remark :</strong></span> <span style="white-space: pre-line"> {{A5reportHd.Remark}}</span> </td>
        <td colspan="7" v-else-if="formA4A5=='A4-2New'"> <span v-if="A5reportHd.Remark"> <br> <strong> Remark :</strong></span> <span style="white-space: pre-line"> {{A5reportHd.Remark}}</span> </td>
        <td colspan="6" v-else> <span v-if="A5reportHd.Remark"> <br> <strong> Remark :</strong></span> <span style="white-space: pre-line"> {{A5reportHd.Remark}}</span> </td>
      </tr>
    </tbody>
  </table>
  <!-- 30.12.2565 เพิ่มคำแนะนำเมื่อค่าสูงหรือต่ำ -->
  <br>
  <div class="container">
    <span v-if="_adviceText.length>0">คำแนะนำ :: <br></span>
    <div class="alert alert-warning mb-1" v-for="(item, index) in _adviceText" :key="index">
      <strong>{{index+1}}.</strong> {{item}}
    </div>
  </div>
</div>
<!-- ===================================================== -->
<!-- ........................ END ........................ -->
<!-- ===================================================== -->

<!-- formA5Idx= 'A4-1' -->
<!-- COLS : Test Result Unit Normal : 15.09.2566 ไม่ต้องขึ้นหน้าใหม่พิมพ์ต่อไปเรื่อยๆ -->
<!-- ตารางใบสั่งตรวจแบบ Master-Detail แต่ละชุดตรวจมีเทสตั้งแต่หนึ่งเทสขึ้นไป -->
<div id="divToPrint_MasterDtl2" hidden>
  <!-- <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}"> -->
  <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}">
    <thead>
      <tr class="text-start">
        <th>Test</th>
        <th></th>
        <th>Result</th>
        <th>Unit</th>
        <th>Ref. range</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="item1 in A5GroupTest" :key="item1.TestID">
        <tr class="text-start" v-if="item1.CountItemTest>1">
          <!-- Check : New Page or not -->
          <!-- <td colspan="5" v-if="item1.NewPage>0" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}"><b>{{item1.TestName}}</b></td> -->
            <td colspan="5" v-if="item1.NewPage>0 || item1.NewPagePropack > 0" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}" style="text-decoration: underline;"><b>{{item1.TestName}}</b><span v-if="item1.Specimen">&nbsp;&nbsp; ( {{item1.Specimen}} )</span></td>
            <td colspan="5" v-else style="text-decoration: underline;"><b>{{item1.TestName}}</b> <span v-if="item1.Specimen">&nbsp;&nbsp; ( {{item1.Specimen}} )</span></td>
          <!-- ----------------------- -->
        </tr>
        <tr v-else-if="item1.NewPage>0 || item1.NewPagePropack > 0">
          <!-- 14.01.2566 : เป็นชุดตรวจที่มี่ 1 เทสและสั่งให้ขึ้นหน้าใหม่ NEW PAGE  -->
            <td colspan="5" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}"></td>
        </tr>
        <!-- รายการเทส ที่อยู่ในชุดตรวจ (Detail) -->
        <template v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID">
          <tr class="text-start" v-if="!optResultedOnly || item2.Result!=='' || item2.ResultText!=='' || item2.PrintUL=='1'">
            <td style="width:210px;" v-if="(item2.PrintUL==0)">
              <span v-if="nameTestsuitIdx==0"> <span v-if="item1.CountItemTest>1">&nbsp;</span>  {{item2.ItemTestName}} </span>
              <span v-else>  <span v-if="item1.CountItemTest>1">&nbsp;</span>  {{item2.ItemTestName2}} </span>
            </td>
            <td style="width:210px;" v-else> <b>{{item2.ItemTestName}}</b> </td>
            <td style="width:22px; text-align:right;" >
              <span v-if="arrBoldResults.includes(_lowerCase(arrRepeatChk[item2.RepeatChecked]))"><b>{{arrRepeatChk[item2.RepeatChecked]}}</b></span>
              <span v-if="arrBoldResults.includes( _lowerCase(_getHighLowSign(item2)) )"><b>{{ _getHighLowSign(item2) }}</b></span>
            </td>
            <!-- ------- Beg RESULT COL : ValueType : 0-ตัวเลข 1-ข้อความ 2-รายการเลือก (ตัวเข้มถ้าเป็น detected/positive) -->
            <td style="width:150px;" v-if="(item2.ValueType==1)">
              <span v-if="arrBoldResults.includes(item2.ResultText.toLowerCase().trim())"> <b> {{item2.PrefixResult}}{{item2.ResultText}}</b> </span>
              <span v-else style="white-space: pre-line">{{item2.PrefixResult}}{{item2.ResultText}} </span>
            </td>
            <td style="width:150px;" v-else-if="(item2.ValueType==2)">
              <span v-if="arrBoldResults.includes(item2.Result.toLowerCase().trim())"> <b> {{item2.PrefixResult}}{{item2.Result}}</b> </span>
              <span v-else>{{item2.PrefixResult}}{{item2.Result}} </span>
            </td>
            <td style="width:150px;" v-else>{{item2.PrefixResult}}{{ FormatNumResult(item2) }}</td>
            <!-- ------- End RESULT COL ------- -->
            <td style="width:120px;"> {{item2.Unit}}</td>
            <td style="width:154px;">{{ getNormalValueBySex(item2) }} {{ getStageDescByResult(item2) }}</td>
          </tr>
        </template>
      </template>
      <tr>
        <td colspan="5"> <span v-if="A5reportHd.Remark"> <br> <strong> Remark :</strong></span> <span style="white-space: pre-line"> {{A5reportHd.Remark}}</span> </td>
      </tr>
    </tbody>
  </table>
  <!-- 30.12.2565 เพิ่มคำแนะนำเมื่อค่าสูงหรือต่ำ -->
  <br>
  <div class="container">
    <span v-if="_adviceText.length>0">คำแนะนำ :: <br></span>
    <div class="alert alert-warning mb-1" v-for="(item, index) in _adviceText" :key="index">
      <strong>{{index+1}}.</strong> {{item}}
    </div>
  </div>
</div>

<!-- formA5Idx= 'A4-2'  -->
<!-- COLS : Test Result Unit METHOD Normal : 15.09.2566 ไม่ต้องขึ้นหน้าใหม่พิมพ์ต่อไปเรื่อยๆ -->
<!-- ตารางใบสั่งตรวจแบบ Master-Detail แต่ละชุดตรวจมีเทสตั้งแต่หนึ่งเทสขึ้นไป -->
<div id="divToPrint_MasterDtl3" hidden>
  <!-- <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}"> -->
  <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}">
    <thead>
      <tr class="text-start">
        <th>Test</th>
        <th></th>
        <th>Result</th>
        <th>Unit</th>
        <th>Method</th>
        <th>Ref. range</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="item1 in A5GroupTest" :key="item1.TestID">
        <tr class="text-start" v-if="item1.CountItemTest>1">
          <!-- Check : New Page or not -->
          <!-- <td colspan="5" v-if="item1.NewPage>0" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}"><b>{{item1.TestName}}</b></td> -->
          <div v-if="item1.NewPage == '1' || item1.NewPagePropack == '1' ">
            <td colspan="5" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}"><u><b>{{item1.TestName}} </b></u></td>
            <td colspan="2" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}">{{item1.Specimen}}</td>
          </div>
          <div v-else>
            <td colspan="5" ><u><b>{{item1.TestName}} </b></u></td>
            <td colspan="2" >{{item1.Specimen}}</td>
          </div>
          <!-- ----------------------- -->
        </tr>
        <tr v-else-if="item1.NewPage>0 || item1.NewPagePropack>0">
          <!-- 14.01.2566 : เป็นชุดตรวจที่มี่ 1 เทสและสั่งให้ขึ้นหน้าใหม่ NEW PAGE  -->
            <td colspan="7" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}"></td>
        </tr>
        <!-- รายการเทส ที่อยู่ในชุดตรวจ (Detail) -->
        <!-- <tr class="text-start" v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID"> -->
        <template v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID">
          <tr class="text-start"  v-if="!optResultedOnly || item2.Result!=='' || item2.ResultText!=='' || item2.PrintUL=='1'">
                          <td style="width:150px;" v-if="(item2.PrintUL==0)">
                <span v-if="nameTestsuitIdx==0"> <span v-if="item1.CountItemTest>1">&nbsp;</span> {{item2.ItemTestName}} </span>
                <span v-else> <span v-if="item1.CountItemTest>1">&nbsp;</span> {{item2.ItemTestName2}} </span>
            </td>
            <td style="width:150px;" v-else> <b>{{item2.ItemTestName}}</b></td>
            <td style="width:22px; text-align:right;" >
              <span v-if="arrBoldResults.includes(_lowerCase(arrRepeatChk[item2.RepeatChecked]))"><b>{{arrRepeatChk[item2.RepeatChecked]}}</b></span>
              <span v-if="arrBoldResults.includes( _lowerCase(_getHighLowSign(item2)) )"><b>{{ _getHighLowSign(item2) }}</b></span>
            </td>
            <!-- ------- Beg RESULT COL : ValueType : 0-ตัวเลข 1-ข้อความ 2-รายการเลือก (ตัวเข้มถ้าเป็น detected/positive) -->
            <td style="width:150px;" v-if="(item2.ValueType==1)">
              <span v-if="arrBoldResults.includes(item2.ResultText.toLowerCase().trim())"> <b> {{item2.PrefixResult}}{{item2.ResultText}}</b> </span>
              <span v-else style="white-space: pre-line">{{item2.PrefixResult}}{{item2.ResultText}}</span>
            </td>
            <td style="width:150px;" v-else-if="(item2.ValueType==2)">
              <span v-if="arrBoldResults.includes(item2.Result.toLowerCase().trim())"> <b> {{item2.PrefixResult}}{{item2.Result}}</b> </span>
              <span v-else>{{item2.PrefixResult}}{{item2.Result}} </span>
            </td>
            <td style="width:150px;" v-else>{{item2.PrefixResult}}{{ FormatNumResult(item2) }}</td>
            <!-- ------- End RESULT COL ------- -->
            <td style="width:60px;"> {{item2.Unit}}</td>
            <td style="width:100px;">{{item2.Method}}  </td>
            <!-- ------------------- -->
            <td style="width:132px;">{{ getNormalValueBySex(item2) }} {{ getStageDescByResult(item2) }}</td>
          </tr>
        </template>
      </template>
      <tr>
        <td colspan="6"> <span v-if="A5reportHd.Remark"> <br> <strong> Remark :</strong></span> <span style="white-space: pre-line"> {{A5reportHd.Remark}}</span> </td>
      </tr>
    </tbody>
  </table>
  <!-- 30.12.2565 เพิ่มคำแนะนำเมื่อค่าสูงหรือต่ำ -->
  <br>
  <div class="container">
    <span v-if="_adviceText.length>0">คำแนะนำ :: <br></span>
    <div class="alert alert-warning mb-1" v-for="(item, index) in _adviceText" :key="index">
      <strong>{{index+1}}.</strong> {{item}}
    </div>
  </div>
</div>

<!-- formA5Idx= 'A4-3' :  28.06.2566  -->
<!-- : COLS : Wide Result, NormalValue/Method  // : 115.09.2566 ไม่ต้องขึ้นหน้าใหม่พิมพ์ต่อไปเรื่อยๆ
      : ขยายความกว้าง Result (เผื่อชนิด ข้อความ) และย้าย Ref. & Method ไว้คอลัมส์เดียวกัน -->
<!-- ตารางใบสั่งตรวจแบบ Master-Detail แต่ละชุดตรวจมีเทสตั้งแต่หนึ่งเทสขึ้นไป -->
<div id="divToPrint_MasterDtl4" hidden>
  <!-- <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}"> -->
  <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}">
    <thead>
      <tr class="text-start">
        <th>Test</th>
        <th></th>
        <th>Result</th>
        <th>Unit</th>
        <th>Ref. / Method</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="item1 in A5GroupTest" :key="item1.TestID">
        <tr class="text-start" v-if="item1.CountItemTest>1">
          <!-- Check : New Page or not -->
          <!-- <td colspan="5" v-if="item1.NewPage>0" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}"><b>{{item1.TestName}}</b></td> -->
          <div v-if="item1.NewPage == '1' || item1.NewPagePropack == '1' ">
            <td colspan="4" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}"><u><b>{{item1.TestName}} </b></u></td>
            <td colspan="2" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}">{{item1.Specimen}}</td>
          </div>
          <div v-else>
            <td colspan="4" ><u><b>{{item1.TestName}} </b></u></td>
            <td colspan="2" >{{item1.Specimen}}</td>
          </div>
          <!-- ----------------------- -->
        </tr>
        <tr v-else-if="item1.NewPage>0 || item1.NewPagePropack>0">
          <!-- 14.01.2566 : เป็นชุดตรวจที่มี่ 1 เทสและสั่งให้ขึ้นหน้าใหม่ NEW PAGE  -->
            <td colspan="6" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}"></td>
        </tr>
        <!-- รายการเทส ที่อยู่ในชุดตรวจ (Detail) -->
        <!-- <tr class="text-start" v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID"> -->
        <template v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID">
          <tr class="text-start"  v-if="!optResultedOnly || item2.Result!=='' || item2.ResultText!=='' || item2.PrintUL=='1'">
            <td style="width:150px;" v-if="(item2.PrintUL==0)">
                <span v-if="nameTestsuitIdx==0"> <span v-if="item1.CountItemTest>1">&nbsp;</span> {{item2.ItemTestName}} </span>
                <span v-else> <span v-if="item1.CountItemTest>1">&nbsp;</span> {{item2.ItemTestName2}} </span>
            </td>
            <td style="width:150px;" v-else> <b>{{item2.ItemTestName}}</b></td>
            <td style="width:22px; text-align:right;" >
              <span v-if="arrBoldResults.includes(_lowerCase(arrRepeatChk[item2.RepeatChecked]))"><b>{{arrRepeatChk[item2.RepeatChecked]}}</b></span>
              <span v-if="arrBoldResults.includes( _lowerCase(_getHighLowSign(item2)) )"><b>{{ _getHighLowSign(item2) }}</b></span>
            </td>
            <!-- ------- Beg RESULT COL : ValueType : 0-ตัวเลข 1-ข้อความ 2-รายการเลือก (ตัวเข้มถ้าเป็น detected/positive) -->
            <td style="width:270px;" v-if="(item2.ValueType==1)">
              <span v-if="arrBoldResults.includes(item2.ResultText.toLowerCase().trim())"> <b> {{item2.PrefixResult}}{{item2.ResultText}}</b> </span>
              <span v-else style="white-space: pre-line">{{item2.PrefixResult}}{{item2.ResultText}}</span>
            </td>
            <td style="width:270px;" v-else-if="(item2.ValueType==2)">
              <span v-if="arrBoldResults.includes(item2.Result.toLowerCase().trim())"> <b> {{item2.PrefixResult}}{{item2.Result}}</b> </span>
              <span v-else>{{item2.PrefixResult}}{{item2.Result}} </span>
            </td>
            <td style="width:270px;" v-else>{{item2.PrefixResult}}{{ FormatNumResult(item2) }}</td>
            <!-- ------- End RESULT COL ------- -->
            <td style="width:60px;"> {{item2.Unit}}</td>
            <!-- ------------------- -->
            <td style="width:132px;">{{ getNormalValueBySex(item2) }} {{ getStageDescByResult(item2) }} <span v-if="item2.Method"> <br> Method: {{item2.Method}}</span></td>
          </tr>
        </template>
      </template>
      <tr>
        <td colspan="6"> <span v-if="A5reportHd.Remark"> <br> <strong> Remark :</strong></span> <span style="white-space: pre-line"> {{A5reportHd.Remark}}</span> </td>
      </tr>
    </tbody>
  </table>
  <!-- 30.12.2565 เพิ่มคำแนะนำเมื่อค่าสูงหรือต่ำ -->
  <br>
  <div class="container">
    <span v-if="_adviceText.length>0">คำแนะนำ :: <br></span>
    <div class="alert alert-warning mb-1" v-for="(item, index) in _adviceText" :key="index">
      <strong>{{index+1}}.</strong> {{item}}
    </div>
  </div>
</div>

<!-- ============================================================================ -->
<!-- formA5Idx= 'A5-3L' แนวนอน : ลด Font/Line space ลง, Footer เล็กลง, ย้าย H/L ไว้หลัง col ผลแล็บ  -->
<!-- COLS : Test Result Unit Normal -->
<!-- ตารางใบสั่งตรวจแบบ Master-Detail แต่ละชุดตรวจมีเทสตั้งแต่หนึ่งเทสขึ้นไป -->
<div id="divToPrint_MasterDtlA5L_smFooter" hidden>
  <!-- <table style="width:100%" data-pdfmake="{'headerRows': 2, 'layout':'headerLineOnly'}"> -->
  <!-- <table style="width:100%" data-pdfmake="{'headerRows': 2, 'layout':'noBorders'}"> -->
  <table style="width:100%" :data-pdfmake="arrPdfOption[Number(optHLineTable)]">
    <thead>
      <tr class="text-start">
        <th style="width:235px;">Test</th>
        <th style="width:5px;"></th>
        <th style="width:120px;">Result</th>
        <th style="width:22px;"></th>
        <th style="width:100px;">Unit</th>
        <th style="width:145px;">Ref. range</th>
      </tr>
      <!-- <tr>
        <th colspan="6"></th>
      </tr> -->
    </thead>
    <tbody>
      <template v-for="(item1,index) in A5GroupTest" :key="item1.TestID">
        <!-- ====================== HEADER ===================== -->
        <!-- A.CHECK : แสดงชื่อห้องตรวจ ? -->
        <template v-if="optRoomShow">
            <!-- 1.CHECK : NEW PAGE ? -->
            <template v-if="item1.RoomNewPage">
              <!-- CHECK optRoomSplit = True : ถ้าระบุแปลว่าให้พิมพ์ แยกห้อง-แยกหน้า -->
              <template v-if="optRoomSplit">
                <!-- เป็นชุดตรวจแรกของห้อง : ขึ้นหน้าใหม่ + พิมพ์ชื่อห้อง-->
                <tr class="text-center">
                  <td colspan="6" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                </tr>
              </template>
              <template v-else>
                <!-- เป็นชุดตรวจแรกของห้อง : ไม่ขึ้นหน้าใหม่ + พิมพ์ชื่อห้อง-->
                <tr class="text-center">
                  <td colspan="6" data-pdfmake="{&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                </tr>
              </template>
            </template>
            <template v-else-if="index==0">
              <!-- เป็นรายการแรก ไม่ขึ้นหน้าใหม่ + พิมพ์ชื่อห้อง -->
              <tr class="text-center">
                <td colspan="6" data-pdfmake="{&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
              </tr>
            </template>
        </template>
        <!-- B.CHECK : ไม่แสดงชื่อห้องตรวจ -->
        <template v-else>
            <!-- 1.CHECK : NEW PAGE ? -->
            <template v-if="item1.RoomNewPage">
              <!-- CHECK optRoomSplit = True : ถ้าระบุแปลว่าให้พิมพ์ แยกห้อง-แยกหน้า -->
              <template v-if="optRoomSplit">
                <!-- เป็นชุดตรวจแรกของห้อง : ขึ้นหน้าใหม่ + ไม่พิมพ์ชื่อห้อง-->
                <tr class="text-center">
                  <td colspan="6" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;center&quot;}"></td>
                </tr>
              </template>
            </template>
        </template>

        <!-- 2.CHECK : เป็นชุดตรวจใหญ่ หรือ ชุดตรวจเดี่ยว ? -->
        <template v-if="item1.CountItemTest>1">
          <!-- เป็นชุดตรวจใหญ่มีหลายเทสย่อย : พิมพชื่อชุดตรวจ -->
          <tr>
            <td colspan="5" ><b>{{item1.TestName}}</b></td>
            <td>{{item1.Specimen}}</td>
          </tr>
        </template>
        <template v-else>
          <!-- เป็นชุดตรวจเดี่ยว มีหนึ่งเทสย่อย : ไม่ต้องพิมพ์ชื่อชุดตรวจ -->
          <tr v-if="item1.NewPage>0 || item1.NewPagePropack>0">
            <!-- 14.01.2566 : เป็นชุดตรวจที่มี่ 1 เทสและสั่งให้ขึ้นหน้าใหม่ NEW PAGE ไม่ต้องพิมพ์ชื่อชุดตรวจ (พิมพ์เฉพาะชื่อเทสย่อย) -->
            <td colspan="6" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}"></td>
          </tr>
        </template>

        <!-- ====================== DETAIL ===================== -->
        <!-- รายการเทส ที่อยู่ในชุดตรวจ (Detail) -->
        <!-- <tr class="text-start" v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID"> -->
        <template v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID">
          <tr class="text-start"  v-if="!optResultedOnly || item2.Result!=='' || item2.ResultText!=='' || item2.PrintUL=='1'">
            <td v-if="(item2.PrintUL==0)">
                <span v-if="nameTestsuitIdx==0"> <span v-if="item1.CountItemTest>1">&nbsp;</span> {{item2.ItemTestName}} </span>
                <span v-else> <span v-if="item1.CountItemTest>1">&nbsp;</span> {{item2.ItemTestName2}} </span>
            </td>
            <td v-else> <b>{{item2.ItemTestName}}</b></td>
            <td style="text-align:right;" > : </td>
            <!-- ------- Beg RESULT COL : ValueType : 0-ตัวเลข 1-ข้อความ 2-รายการเลือก (ตัวเข้มถ้าเป็น detected/positive) -->
            <td v-if="(item2.ValueType==1)">
              <span v-if="arrBoldResults.includes(item2.ResultText.toLowerCase().trim())"> <b> {{item2.PrefixResult}}{{item2.ResultText}}</b> </span>
              <span v-else style="white-space: pre-line">{{item2.PrefixResult}}{{item2.ResultText}} </span>
            </td>
            <td v-else-if="(item2.ValueType==2)">
              <span v-if="arrBoldResults.includes(item2.Result.toLowerCase().trim())"> <b> {{item2.PrefixResult}}{{item2.Result}}</b> </span>
              <span v-else>{{item2.PrefixResult}}{{item2.Result}} </span>
            </td>
            <td v-else>{{item2.PrefixResult}}{{ FormatNumResult(item2) }}</td>
            <!-- ------- End RESULT COL ------- -->
            <td style="text-align:right;" >
              <span v-if="arrBoldResults.includes(_lowerCase(arrRepeatChk[item2.RepeatChecked]))"><b>{{arrRepeatChk[item2.RepeatChecked]}}</b></span>
              <span v-if="arrBoldResults.includes( _lowerCase(_getHighLowSign(item2)) )"><b>{{ _getHighLowSign(item2) }}</b></span>
            </td>
            <td> {{item2.Unit}}</td>
            <!-- ------------------- -->
            <td>{{ getNormalValueBySex(item2) }} {{ getStageDescByResult(item2) }}</td>
          </tr>
        </template>
      </template>
      <tr>
        <td colspan="6"> <span v-if="A5reportHd.Remark"> <br> <strong> Remark :</strong></span> <span style="white-space: pre-line"> {{A5reportHd.Remark}}</span> </td>
      </tr>
    </tbody>
  </table>
  <!-- 30.12.2565 เพิ่มคำแนะนำเมื่อค่าสูงหรือต่ำ -->
  <br>
  <div class="container">
    <span v-if="_adviceText.length>0">คำแนะนำ :: <br></span>
    <div class="alert alert-warning mb-1" v-for="(item, index) in _adviceText" :key="index">
      <strong>{{index+1}}.</strong> {{item}}
    </div>
  </div>
</div>
<!-- formA5Idx= 'A5-3P' แนวตั้ง : ลด Font/Line space ลง, Footer เล็กลง, ย้าย H/L ไว้หลัง col ผลแล็บ  -->
<!-- COLS : Test Result Unit Normal -->
<!-- ตารางใบสั่งตรวจแบบ Master-Detail แต่ละชุดตรวจมีเทสตั้งแต่หนึ่งเทสขึ้นไป -->
<div id="divToPrint_MasterDtlA5P_smFooter" hidden>
  <!-- <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'noBorders'}"> -->
  <table style="width:100%" :data-pdfmake="arrPdfOption[Number(optHLineTable)]">
    <thead>
      <tr class="text-start">
        <th style="width:120px;">Test</th>
        <th style="width:5px;"></th>
        <th style="width:80px;">Result</th>
        <th style="width:22px;"></th>
        <th style="width:60px;">Unit</th>
        <th style="width:120px;">Ref. range</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(item1,index) in A5GroupTest" :key="item1.TestID">
        <!-- ====================== HEADER ===================== -->
        <!-- A.CHECK : แสดงชื่อห้องตรวจ ? -->
        <template v-if="optRoomShow">
            <!-- 1.CHECK : NEW PAGE ? -->
            <template v-if="item1.RoomNewPage">
              <!-- CHECK optRoomSplit = True : ถ้าระบุแปลว่าให้พิมพ์ แยกห้อง-แยกหน้า -->
              <template v-if="optRoomSplit">
                <!-- เป็นชุดตรวจแรกของห้อง : ขึ้นหน้าใหม่ + พิมพ์ชื่อห้อง-->
                <tr class="text-center">
                  <td colspan="6" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                </tr>
              </template>
              <template v-else>
                <!-- เป็นชุดตรวจแรกของห้อง : ไม่ขึ้นหน้าใหม่ + พิมพ์ชื่อห้อง-->
                <tr class="text-center">
                  <td colspan="6" data-pdfmake="{&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
                </tr>
              </template>
            </template>
            <!-- เป็นรายการแรก -->
            <template v-else-if="index==0">
              <!-- เป็นรายการแรก ไม่ขึ้นหน้าใหม่ + พิมพ์ชื่อห้อง -->
              <tr class="text-center">
                <td colspan="6" data-pdfmake="{&quot;alignment&quot;:&quot;center&quot;}"><b>[{{item1.RoomtypeName}}]</b></td>
              </tr>
            </template>
        </template>
        <!-- B.CHECK : ไม่แสดงชื่อห้องตรวจ -->
        <template v-else>
            <!-- 1.CHECK : NEW PAGE ? -->
            <template v-if="item1.RoomNewPage">
              <!-- CHECK optRoomSplit = True : ถ้าระบุแปลว่าให้พิมพ์ แยกห้อง-แยกหน้า -->
              <template v-if="optRoomSplit">
                <!-- เป็นชุดตรวจแรกของห้อง : ขึ้นหน้าใหม่ + ไม่พิมพ์ชื่อห้อง-->
                <tr class="text-center">
                  <td colspan="6" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;,&quot;alignment&quot;:&quot;center&quot;}"></td>
                </tr>
              </template>
            </template>
        </template>

        <!-- 2.CHECK : เป็นชุดตรวจใหญ่ หรือ ชุดตรวจเดี่ยว ? -->
        <template v-if="item1.CountItemTest>1">
          <!-- เป็นชุดตรวจใหญ่มีหลายเทสย่อย : พิมพชื่อชุดตรวจ -->
          <tr>
            <td colspan="5" ><b>{{item1.TestName}}</b></td>
            <td>{{item1.Specimen}}</td>
          </tr>
        </template>
        <template v-else>
          <!-- เป็นชุดตรวจเดี่ยว มีหนึ่งเทสย่อย : ไม่ต้องพิมพ์ชื่อชุดตรวจ -->
          <tr v-if="item1.NewPage>0 || item1.NewPagePropack>0">
            <!-- 14.01.2566 : เป็นชุดตรวจที่มี่ 1 เทสและสั่งให้ขึ้นหน้าใหม่ NEW PAGE ไม่ต้องพิมพ์ชื่อชุดตรวจ (พิมพ์เฉพาะชื่อเทสย่อย) -->
            <td colspan="6" data-pdfmake="{&quot;pageBreak&quot;:&quot;before&quot;}"></td>
          </tr>
        </template>

        <!-- ====================== DETAIL ===================== -->
        <!-- รายการเทส ที่อยู่ในชุดตรวจ (Detail) -->
        <!-- <tr class="text-start" v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID"> -->
        <template v-for="item2 in filterA5ItemsOfGroup(A5reportDtl,item1.TestID)" :key="item2.ItemTestID">
          <tr class="text-start"  v-if="!optResultedOnly || item2.Result!=='' || item2.ResultText!=='' || item2.PrintUL=='1'">
            <td v-if="(item2.PrintUL==0)">
                <span v-if="nameTestsuitIdx==0"> <span v-if="item1.CountItemTest>1">&nbsp;</span> {{item2.ItemTestName}} </span>
                <span v-else> <span v-if="item1.CountItemTest>1">&nbsp;</span> {{item2.ItemTestName2}} </span>
            </td>
            <td  v-else> <b>{{item2.ItemTestName}}</b></td>
            <td style="text-align:right;" > : </td>
            <!-- ------- Beg RESULT COL : ValueType : 0-ตัวเลข 1-ข้อความ 2-รายการเลือก (ตัวเข้มถ้าเป็น detected/positive) -->
            <td  v-if="(item2.ValueType==1)">
              <span v-if="arrBoldResults.includes(item2.ResultText.toLowerCase().trim())"> <b> {{item2.PrefixResult}} {{item2.ResultText}}</b> </span>
              <span v-else style="white-space: pre-line">{{item2.PrefixResult}}{{item2.ResultText}} </span>
            </td>
            <td  v-else-if="(item2.ValueType==2)">
              <span v-if="arrBoldResults.includes(item2.Result.toLowerCase().trim())"> <b> {{item2.PrefixResult}} {{item2.Result}}</b> </span>
              <span v-else>{{item2.PrefixResult}}{{item2.Result}} </span>
            </td>
            <td  v-else>{{item2.PrefixResult}}{{ FormatNumResult(item2) }}</td>
            <!-- ------- End RESULT COL ------- -->
            <td style="text-align:right;" >
              <span v-if="arrBoldResults.includes(_lowerCase(arrRepeatChk[item2.RepeatChecked]))"><b>{{arrRepeatChk[item2.RepeatChecked]}}</b></span>
              <span v-if="arrBoldResults.includes( _lowerCase(_getHighLowSign(item2)) )"><b>{{ _getHighLowSign(item2) }}</b></span>
            </td>
            <td style=""> {{item2.Unit}}</td>
            <!-- ------------------- -->
            <td style="" >{{ getNormalValueBySex(item2) }} {{ getStageDescByResult(item2) }}</td>
          </tr>
        </template>
      </template>
      <tr>
        <td colspan="6"> <span v-if="A5reportHd.Remark"> <br> <strong> Remark :</strong></span> <span style="white-space: pre-line"> {{A5reportHd.Remark}}</span> </td>
      </tr>
    </tbody>
  </table>
  <!-- 30.12.2565 เพิ่มคำแนะนำเมื่อค่าสูงหรือต่ำ -->
  <br>
  <div class="container">
    <span v-if="_adviceText.length>0">คำแนะนำ :: <br></span>
    <div class="alert alert-warning mb-1" v-for="(item, index) in _adviceText" :key="index">
      <strong>{{index+1}}.</strong> {{item}}
    </div>
  </div>
</div>
<!-- ======================================================================== -->

<div id="divToPrint_Algy" hidden>
  <!-- <div class="d-flex flex-wrap align-content-start container p-0 active page-scroll " id="msg"> -->
  <div class=" container p-0 active page-scroll " id="msg">
    <template v-for="item in algylist" :key="item.Name">
      <img :src="getIMGPath(item.Picture)"
          :alt="`img of {item.Name}`">
      <p>{{item.Name}}</p>
      <!-- <div class="polaroid m-2">
        <img :src="getIMGPath(item.Picture)"
          :alt="`img of {item.Name}`">
        <div class="container">
        <p>{{item.Name}}</p>
        </div>
      </div> -->
    </template>
  </div>
</div>

<!-- <hr>
optHLineTable :: {{optHLineTable}} br
arrPdfOption[Number(optHLineTable)] :: {{arrPdfOption[Number(optHLineTable)]}}
<hr>
A5GroupTest :: {{A5GroupTest}} -->
</template>

<script>
// import axios from 'axios'
import myfuncs from '../myjs/myfuncs.js'
import funcRO from '../myjs/funcRO.js'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
// import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import JsBarcode from 'jsbarcode/bin/JsBarcode'

// import pdfMake from 'pdfmake'
// import pdfFonts from 'pdfmake/build/vfs_fonts'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import htmlToPdfmake from 'html-to-pdfmake'
pdfMake.vfs = pdfFonts.pdfMake.vfs

// // ต้องระบุตามชื่อของ ไฟล์ font
// normal: path.resolve('./fonts/Prompt-Regular.ttf'),
// bold: 'Prompt-Bold.ttf',
// italics: 'Prompt-Italic.ttf',
// bolditalics: 'Prompt-BoldItalic.ttf'
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  THPrompt: {
    normal: 'Prompt-Regular.ttf',
    bold: 'Prompt-Bold.ttf',
    italics: 'Prompt-Italic.ttf',
    bolditalics: 'Prompt-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'LabPrint1View',
  data () {
    return {
      // arrPdfOption: ["{'headerRows': 2, 'layout':'headerLineOnly'}", "{'headerRows': 2, 'layout':'lightHorizontalLines'}"],
      arrPdfOption: ["{'headerRows': 1, 'layout':'headerLineOnly'}", "{'headerRows': 1, 'layout':'lightHorizontalLines'}"],
      layoutPdfTable: 'noBorders',
      dataPdfTable: { headerRows: 1, layout: 'noBorders' },
      arrRepeatChk: ['', 'R'],
      arrSex: ['', 'Male', 'Female'],
      arrSexTh: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      arrPaid: ['', 'Paid'],

      // Form A5/A4 ที่เลือกพิมพ์
      formA4A5: '',
      // ตัวแปรสำหรับพิมพ์แบบฟอร์ม Covid
      dataheader: null,
      reportDtl: null,
      reportHd: {
        BranchID: 0,
        ROID: 0,
        RONo: '',
        DocDate: null,
        DocTime: null,
        PatID: 0,
        PatCode: '',
        PrefixName: '',
        PatName: 'สมชาย แข็งแรงดี',
        PatLName: '',
        PrefixName2: '',
        PatName2: '',
        PatLName2: '',
        IDNo: '',
        Sex: 0,
        Tel1: '',
        Tel2: '',
        AgeYears: 0,
        AgeMonths: 0,
        AgeDays: 0,
        ReqClinicID: 0,
        ReqClinicName: '',
        HNNo: '',
        OfficerID1: 0,
        OfficerName1: '',
        OfficerName1Sign: '',
        OfficerID2: 0,
        OfficerName2: '',
        OfficerName2Sign: '',
        ResultedDate: null,
        OfficerID3: 0,
        OfficerName3: '',
        OfficerName3Sign: '',
        ApprovedDate: null,
        Remark: '',
        Status: 0
      },
      // ตัวแปรสำหรับพิมพ์แบบ A5 มีชื่อชุดตรวจ
      A5dataheader: null,
      A5reportHd: {
        BranchID: 0,
        ROID: 0,
        RONo: '',
        DocDate: null,
        DocTime: null,
        PatID: 0,
        PatCode: '',
        PrefixName: '',
        PatName: 'สมชาย แข็งแรงดี',
        PatLName: '',
        PrefixName2: '',
        PatName2: '',
        PatLName2: '',
        IDNo: '',
        Sex: 0,
        Tel1: '',
        Tel2: '',
        AgeYears: 0,
        AgeMonths: 0,
        AgeDays: 0,
        ReqClinicID: 0,
        ReqClinicName: '',
        HNNo: '',
        OfficerID1: 0,
        OfficerName1: '',
        OfficerName1Sign: '',
        OfficerID2: 0,
        OfficerName2: '',
        OfficerName2Sign: '',
        ResultedDate: null,
        OfficerID3: 0,
        OfficerName3: '',
        OfficerName3Sign: '',
        ApprovedDate: null,
        Remark: '',
        Status: 0
      },
      A5GroupTest: [],
      A5reportDtl: [],

      // ====================== TEST ALGY FORM ================= //
      algylist: [
        { Name: 'กุ้ง', Picture: 'กุ้ง.png' },
        { Name: 'ปลาทูน่า', Picture: 'ปลาทูน่า.jpeg' },
        { Name: 'ปลาคอด', Picture: 'ปลาคอด.png' },
        { Name: 'หอยแครง', Picture: 'หอยแครง.jpg' }
      ]
    }
  },
  props: ['datalists', 'nameIdx', 'optResultedOnly', 'nameTestsuitIdx', 'optDOB', 'optWatermark', 'optOneTestsuitPerPaper', 'optHLineTable', 'optRoomSplit', 'optTSSplit', 'optRoomShow', 'arrBoldResults', 'dataCliniclists'],
  mounted () {
    this.layoutPdfTable = 'headerLineOnly'
    this.dataPdfTable = { headerRows: 2, layout: 'headerLineOnly' }
  },
  components: {

  },
  computed: {
    // a computed getter
    _adviceText: function () {
      if (this.A5reportDtl == null) return []
      // ----------------------------------- //
      var arrAdviceText = []
      for (let i = 0; i < this.A5reportDtl.length; i++) {
        var signHL = this._getHighLowSign(this.A5reportDtl[i])
        if (signHL === 'L') {
          if (this.A5reportDtl[i].AdviceMin !== '') {
            arrAdviceText.push(this.A5reportDtl[i].AdviceMin)
          }
        } else if (signHL === 'H') {
          if (this.A5reportDtl[i].AdviceMax !== '') {
            arrAdviceText.push(this.A5reportDtl[i].AdviceMax)
          }
        }
      }
      return arrAdviceText
    },
    // _vitalSignText ใช้ในการพิมพ์ผลแล็บ
    _vitalSignText: function () {
      var vitalSignText = ''
      if (this.A5reportHd === null || typeof this.A5reportHd === 'undefined') return vitalSignText
      // ----------------------------------- //
      if (this.A5reportHd.BP_1 !== '0' && typeof this.A5reportHd.BP_1 !== 'undefined') {
        vitalSignText = vitalSignText + '  BP: ' + this.A5reportHd.BP_1 + '/' + this.A5reportHd.BP_2 + ' mmHg.'
      }
      if (this.A5reportHd.Pulse !== '0' && typeof this.A5reportHd.Pulse !== 'undefined') {
        vitalSignText = vitalSignText + '  P: ' + this.A5reportHd.Pulse + ' bpm.'
      }
      if (this.A5reportHd.Weight !== '0' && typeof this.A5reportHd.Weight !== 'undefined') {
        vitalSignText = vitalSignText + '  W: ' + this.A5reportHd.Weight + ' kg.'
      }
      if (this.A5reportHd.Height !== '0' && typeof this.A5reportHd.Height !== 'undefined') {
        vitalSignText = vitalSignText + ' H: ' + this.A5reportHd.Height + ' cm.'
      }
      if (this.A5reportHd.Weight !== '0' && typeof this.A5reportHd.Weight !== 'undefined' &&
          this.A5reportHd.Height !== '0' && typeof this.A5reportHd.Height !== 'undefined') {
        let BMI = 0
        BMI = parseFloat(this.A5reportHd.Weight) / ((parseFloat(this.A5reportHd.Height) / 100) *
                                                      (parseFloat(this.A5reportHd.Height) / 100))
        vitalSignText = vitalSignText + '  BMI: ' + BMI.toFixed(2)
      }

      if (this.A5reportHd.BodyTemp !== '0' && typeof this.A5reportHd.BodyTemp !== 'undefined') {
        vitalSignText = vitalSignText + '  Temp: ' + this.A5reportHd.BodyTemp + ' C.'
      }
      if (this.A5reportHd.SpO2 !== '0' && typeof this.A5reportHd.SpO2 !== 'undefined') {
        vitalSignText = vitalSignText + '  SpO2: ' + this.A5reportHd.SpO2 + ' %'
      }
      return vitalSignText
    }
  },
  methods: {
    getIMGPath (img) {
      return img ? require('@/../algy_img/mylab/Allergy222Type/seafoods/' + img) : ''
      // return ''
    },
    // // แปลงรูปแบบการแสดงผลแล็บ ถ้าเป็นตัวเลขใส่คอมม่าและทศนิมยม ถ้าไม่ใช่แสดงค่าเดิม
    // FormatNumResult (row) {
    //   if (this.isNumber(row.Result) && (row.Result.trim() !== '')) {
    //     let NumStr = ''
    //     NumStr = row.Result.replace(/[,]/g, '') // ตัด , ออกไปก่อน (ถ้ามี) -> ex. 456789.567
    //     NumStr = Number(NumStr).toFixed(row.Decimals) // ปรับจำนวนทศนิยม
    //     var A = NumStr.toString().split('.')[0] // จำนวนหน้า .
    //     var B = NumStr.toString().split('.')[1] // ทศนิยมหลัง .
    //     // console.log(A.replace(/\B(?=(\d{3})+(?!\d))/g, ',').trim() + '.' + B)
    //     return A.replace(/\B(?=(\d{3})+(?!\d))/g, ',').trim() + '.' + B
    //   } else {
    //     return row.Result
    //   }
    // },
    // // ตรวจสอบว่าเป็นตัวเลขหรือไม่
    // isNumber (val) {
    //   let NumStr = ''
    //   NumStr = val.replace(/[,]/g, '') // ตัด , ออกไปก่อน
    //   return !isNaN(NumStr)
    // },

    // แสดงคำอธิบายผลแล็บ ที่แยกแต่ละ Stage ตามค่าผลแล็บ
    // เช่น eGFR จะมีทั้งหมด 5 ระยะ เช็คว่าอยู่ที่ระยะไหน แล้วแสดงข้อความของระยะนั้น
    getStageDescByResult (row) {
      // console.log('getStageDescByResult ::')
      // console.log(row.JSONStageDesc)
      // console.log(row.JSONStageDesc.length)
      if (row.JSONStageDesc.length > 0 && (row.ValueType === 0 || row.ValueType === '0')) {
        // console.log('JSON.parse(row.JSONStageDesc) >>')
        // console.log(JSON.parse(row.JSONStageDesc))
        var strJson = row.JSONStageDesc
        var arrJson = JSON.parse(strJson)
        var strStageDesc = ''

        for (let i = 0; i < arrJson.length; i++) {
          if (parseFloat(row.Result) >= arrJson[i].value1 && parseFloat(row.Result) < arrJson[i].value2) {
            strStageDesc = arrJson[i].stage + ' ' + arrJson[i].desc
            break
          }
        }
        return strStageDesc
      } else {
        return ''
      }
    },
    getNormalValueBySex (row) {
      // ใช้ Min/Max/Normal แยกตามชายหรือหญิง
      if (row.MinMaxType === '1' || row.MinMaxType === 1) {
        if (row.Sex === '1' || row.Sex === 1) {
          return row.NormalValue
        } else if (row.Sex === '2' || row.Sex === 2) {
          return row.NormalValue2
        } else {
          return ''
        }
      } else {
        // ใช่ Min/Max/Normal เหมือนกันทั้งชายและหญิง
        return row.NormalValue
      }
    },

    // =========================
    // ใช้ฟังก์ชั่นจากไฟล์ร่วม .js
    _lowerCase (str) {
      return myfuncs.lowerCase(str)
    },
    FormatNumResult (row) {
      return myfuncs.FormatNumResult(row)
    },
    _getHighLowSign (row) {
      return funcRO.getHighLowSign(row)
    },
    // =========================
    // getHighLowSign (row) {
    //   if (row.ValueType === '0' || (row.ValueType === 0)) {
    //     // --------------------------------- //
    //     // ใช้ Min/Max/Normal แยกตามชายหรือหญิง
    //     if (row.MinMaxType === '1' || row.MinMaxType === 1) {
    //       if (row.Sex === '1' || row.Sex === 1) {
    //         // MALE ชาย
    //         if (row.MinValue !== '' && row.MaximumValue !== '') {
    //           if (parseFloat(row.Result) < parseFloat(row.MinValue)) {
    //             return 'L'
    //           } else if (parseFloat(row.Result) > parseFloat(row.MaximumValue)) {
    //             return 'H'
    //           }
    //         } else { return '' }
    //       } else if (row.Sex === '2' || row.Sex === 2) {
    //         // FEMALE หญิง
    //         if (row.MinValue2 !== '' && row.MaximumValue2 !== '') {
    //           if (parseFloat(row.Result) < parseFloat(row.MinValue2)) {
    //             return 'L'
    //           } else if (parseFloat(row.Result) > parseFloat(row.MaximumValue2)) {
    //             return 'H'
    //           }
    //         } else { return '' }
    //       }
    //     } else {
    //       // ใช่ Min/Max/Normal เหมือนกันทั้งชายและหญิง
    //       if (row.MinValue !== '' && row.MaximumValue !== '') {
    //         if (parseFloat(row.Result) < parseFloat(row.MinValue)) {
    //           return 'L'
    //         } else if (parseFloat(row.Result) > parseFloat(row.MaximumValue)) {
    //           return 'H'
    //         }
    //       } else { return '' }
    //     }
    //   } else {
    //     return ''
    //   }
    // },
    // ================================

    // พิมพ์โลโก้และชื่อคลินิก (ไม่พิมพ์ข้อมูลคนไข้)
    printEnvelopeLogoOnly (row) {
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      // const pdfTable = document.getElementById('divToPrint')
      // ------- html to pdf format
      // var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'A5',
        pageSize: { width: 8.0 * 72, height: 4.0 * 72 },
        // pageOrientation: 'landscape',
        pageMargins: [50, 120, 0, 5],
        header: {
          margin: [20, 10, 20, 5],
          table: {
            widths: [90, 440],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 3,
                  image: logoBase64,
                  width: 90,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 16,
                  lineHeight: 0.5
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 12,
                  lineHeight: 0.5
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 +
                        (self.globalCorpInfo.fax !== '' ? ' Fax: ' + self.globalCorpInfo.fax : '') + '\n' +
                        'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7
                }
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        content: [
          {
            text: '',
            fontSize: 14,
            bold: false,
            alignment: 'center',
            margin: [0, 0, 0, 0]
          }
        ],
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 16
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      // pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      pdfMake.createPdf(documentDefinition).print()
    },
    printEnvelopeWithLogo (row) {
      var ClinicName = ''
      if (row.ReqClinicName === null) {
        ClinicName = ''
      } else if (row.ReqClinicName === '') {
        ClinicName = ''
      } else {
        ClinicName = '(' + row.ReqClinicName + ')'
      }
      var PatNamePrn = row.PatName
      var PatLNamePrn = row.PatLName
      var PrefixNamePrn = row.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = row.PatName2
        PatLNamePrn = row.PatLName2
        PrefixNamePrn = row.PrefixName2
      }
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      // const pdfTable = document.getElementById('divToPrint')
      // ------- html to pdf format
      // var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'A5',
        pageSize: { width: 8.0 * 72, height: 4.0 * 72 },
        // pageOrientation: 'landscape',
        pageMargins: [50, 120, 0, 5],
        header: {
          margin: [20, 10, 20, 5],
          table: {
            widths: [90, 440],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 3,
                  image: logoBase64,
                  width: 90,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 16,
                  lineHeight: 0.5
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 12,
                  lineHeight: 0.5
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 +
                        (self.globalCorpInfo.fax !== '' ? ' Fax: ' + self.globalCorpInfo.fax : '') + '\n' +
                        'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7
                }
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        content: [
          {
            text: 'วันที่ ' + row.DocDate,
            fontSize: 14,
            bold: false,
            alignment: 'center',
            margin: [0, 0, 0, 0]
          },
          {
            text: PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn + ' อายุ ' + row.AgeYears + ' ปี',
            fontSize: 14,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 0]
          },
          {
            text: 'โทร. ' + row.Tel1 + ' ' + row.Tel2,
            fontSize: 14,
            bold: false,
            alignment: 'center',
            margin: [0, 0, 0, 0]
          },
          {
            text: ClinicName,
            fontSize: 14,
            bold: false,
            alignment: 'center',
            margin: [0, 0, 0, 0]
          }
        ],
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 16
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      // pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      pdfMake.createPdf(documentDefinition).print()
    },
    printEnvelope (row) {
      var ClinicName = ''
      if (row.ReqClinicName === null) {
        ClinicName = ''
      } else if (row.ReqClinicName === '') {
        ClinicName = ''
      } else {
        ClinicName = '(' + row.ReqClinicName + ')'
      }
      var PatNamePrn = row.PatName
      var PatLNamePrn = row.PatLName
      var PrefixNamePrn = row.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = row.PatName2
        PatLNamePrn = row.PatLName2
        PrefixNamePrn = row.PrefixName2
      }
      // -------- get table html
      // const pdfTable = document.getElementById('divToPrint')
      // ------- html to pdf format
      // var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'A5',
        pageSize: { width: 8.0 * 72, height: 4.0 * 72 },
        // pageOrientation: 'landscape',
        pageMargins: [50, 120, 0, 5],
        content: [
          {
            text: 'วันที่ ' + row.DocDate,
            fontSize: 14,
            bold: false,
            alignment: 'center',
            margin: [0, 0, 0, 0]
          },
          {
            text: PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn + ' อายุ ' + row.AgeYears + ' ปี',
            fontSize: 14,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 0]
          },
          {
            text: 'โทร. ' + row.Tel1 + ' ' + row.Tel2,
            fontSize: 14,
            bold: false,
            alignment: 'center',
            margin: [0, 0, 0, 0]
          },
          {
            text: ClinicName,
            fontSize: 14,
            bold: false,
            alignment: 'center',
            margin: [0, 0, 0, 0]
          }
        ],
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 16
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      // pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      pdfMake.createPdf(documentDefinition).print()
    },
    // แปลงไฟล์รูปภาพเป็น Base64 Image
    getBase64Image (img) {
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      var dataURL = canvas.toDataURL('image/png')
      return dataURL
    },
    textToBase64Barcode (text, heightValue) {
      var canvas = document.createElement('canvas')
      // var canvas = document.getElementById('myCanvas')
      JsBarcode(canvas, text, { width: 4, height: heightValue })
      var canvasDataURL = canvas.toDataURL('image/png')
      // console.log(canvasDataURL)
      return canvasDataURL
    },
    // =========================================================== //
    //                      ฟอร์มผลแล็บมาตราฐาน
    // =========================================================== //
    getA5ReportDtlData (row, formA5Idx) {
      var self = this
      // มาตราฐานการเรียง คือ เรียงตามห้องตรวจ -> ชุดตรวจในห้อง -> เทสในชุดตรวจ
      MyApiClient.get('getdata/labrequest_dtl_group_where_id.php?ROID=' + row.ROID)
        .then((resp) => {
          // รายการ items ผลตรวจทั้งหมด
          self.A5reportDtl = resp.data.response
          // ================== 1.TestSuit (ไม่ซ้ำ) ======================= //
          // คัดมาเฉพาะชื่อ TestSuit สำหรับจัดกลุ่มพิมพ์ เรียงตามชุด
          // ============================================================ //
          const result = []
          const map = new Map()
          for (const item of self.A5reportDtl) {
            if (!map.has(item.TestID)) { // เป็นชุดตรวจที่ยังไม่ซ้ำในหัวข้อชุดตรวจ
              // set any value to Map
              map.set(item.TestID, true)
              result.push(item)
            }
          }
          self.A5GroupTest = result
          // =================== 1.1 ================ //
          for (const item of self.A5GroupTest) {
            item.optRoomSplit = this.optRoomSplit // checkbox : T -> เปลี่ยนห้องให้ขึ้นหน้าใหม่
            item.optTSSplit = this.optTSSplit // checkbox : T -> ให้ขึ้นหน้าใหม่ทุกชุดตรวจ
          }

          // =================== 2. optRoomSplit แยกหน้าขึ้นห้องตรวจใหม่ : RoomNewPage ================== //
          // [รายชื่อชุดตรวจ]  : Chk and Assign Fld -> "RoomNewPage" (true=NewPage)
          //  - 15.09.2566 : เช็คถ้าเปลี่ยนห้องตรวจ ให้ขึ้นหน้าใหม่ (NewPage)
          // ==================================================== //
          let RoomtypeIDchk = 0
          if (self.A5GroupTest.length > 0) { RoomtypeIDchk = parseInt(self.A5GroupTest[0].RoomtypeID) }
          // --------------------------------------- //
          for (var item of self.A5GroupTest) {
            item.RoomNewPage = false // create and Init [New Fld.] : RoomNewPage
            item.RoomFirstTS = false // เป็นชุดตรวจแรกของห้อง และเป็นห้องตรวจใหม่
            if (parseInt(RoomtypeIDchk) !== parseInt(item.RoomtypeID)) {
              // เป็นห้องตรวจใหม่ -> New Page
              RoomtypeIDchk = parseInt(item.RoomtypeID)
              item.RoomFirstTS = true // เป็นชุดตรวจแรกของห้องตรวจ และเป็นห้องตรวจใหม่
              if (this.optRoomSplit) { item.RoomNewPage = true }
            } else {
              // ห้องตรวจเดิม ไม่ต้องขึ้นหน้าใหม่
              item.RoomNewPage = false
            }
          }
          // =================== 2.1 optTSSplit แยกหน้าทุกชุดตรวจ : NewPage ================== //
          // [รายชื่อชุดตรวจ]  : Chk and Assign value : Fld -> "NewPage" (1=NewPage)
          //  - 21.05.2567 : checkbox [optTSSplit] แสดงว่าให้ขึ้นหน้าใหม่ทุกชุดตรวจ (NewPage)
          // ============================================================================== //
          if (this.optTSSplit) {
            for (const item of self.A5GroupTest) {
              // [NewPage] ค่าเดิมที่เซตมาตอนสร้างใบสั่งตรวจ แต่สามารถสั่งคลิก checkbox ตอนพิมพ์ให้ขึ้นหน้าใหม่ทุกชุดตรวจได้
              item.NewPage = 1
            }
          }
          // ================== 3.NewPagePropack ==================== //
          // [รายชื่อชุดตรวจ]  : Chk and Edit Fld -> "NewPagePropack"
          //  - 15.09.2566 : เช็คถ้าชุดตรวจใหม่ แต่แพคเกจเดิม ไม่ต้องขึ้นหน้าใหม่ (NOT NewPage)
          // ======================================================== //
          let PropackIDchk = 0
          if (self.A5GroupTest.length > 0) { PropackIDchk = parseInt(self.A5GroupTest[0].PropackID) }
          // --------------------------------------- //
          for (const item of self.A5GroupTest) {
            if (parseInt(PropackIDchk) !== parseInt(item.PropackID)) {
              // เป็น แพคเกจใหม่ -> New Page
              PropackIDchk = parseInt(item.PropackID)
              item.NewPagePropack = true
            } else {
              // ห้องตรวจเดิม ไม่ต้องขึ้นหน้าใหม่
              item.NewPagePropack = false
            }
          }
          // console.log(self.A5GroupTest)
          // Print/Create Pdf
          if (formA5Idx === 'A5-1New' || formA5Idx === 'A5-2New') {
            // A5 New รวมทุกฟอร์มของ A5-Landscape
            this.$nextTick(() => self.createNewA5PdfFormToScreen_Landscape_ClassicFooter())
          } else if (formA5Idx === 'A5-3New') {
            // A5 New รวมทุกฟอร์มของ A5-Landscape / sm-Footer
            this.$nextTick(() => self.createNewA5PdfFormToScreen_Landscape())
          } else if (formA5Idx === 'A5-4PNew') {
            // A5 New รวมทุกฟอร์มของ A5-Portrait / sm-Footer
            this.$nextTick(() => self.createNewA5PdfFormToScreen_Portrait())
          } else if (formA5Idx === 'A4-1New' || formA5Idx === 'A4-2New' || formA5Idx === 'A4-3New') {
            // A4 New รวมทุกฟอร์มของ A4
            this.$nextTick(() => self.createNewA4PdfFormToScreen())
          } else if (formA5Idx === 'A5-1') {
            // รูปแบบมาตราฐาน
            this.$nextTick(() => self.createA5PdfForm1ToScreen())
          } else if (formA5Idx === 'A5-2') {
            // รูปแบบที่ 2
            this.$nextTick(() => self.createA5PdfForm2ToScreen())
          } else if (formA5Idx === 'A5-3-smFooter') {
            // รูปแบบที่ 6 : นครนายก
            this.$nextTick(() => self.createA5PdfForm1ToScreen_A5L_smFooter())
          } else if (formA5Idx === 'A5-3P-smFooter') {
            // รูปแบบที่ 7 : นครนายก
            this.$nextTick(() => self.createA5PdfForm1ToScreen_A5P_smFooter())
          } else if (formA5Idx === 'A5-3PBold-smFooter') {
            // รูปแบบที่ 7-1 : นครนายก
            this.$nextTick(() => self.createA5PdfForm1ToScreen_A5PBold_smFooter())
          } else if (formA5Idx === 'A4-1') {
            // รูปแบบที่ 3
            this.$nextTick(() => self.createA4PdfForm3ToScreen())
          } else if (formA5Idx === 'A4-2') {
            // รูปแบบที่ 4
            this.$nextTick(() => self.createA4PdfForm4ToScreen())
          } else if (formA5Idx === 'A4-3') {
            // รูปแบบที่ 5 : Wide RESULT
            this.$nextTick(() => self.createA4PdfForm5ToScreen())
          }
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // A5reportDtl filter เฉพาะเทสที่อยู่ในชุดตรวจที่ส่งค่ามา paraTestID
    filterA5ItemsOfGroup: function (items, paraTestID) {
      return items.filter(function (item) {
        return item.TestID === paraTestID
      })
    },
    getA5ReportData (row, formA5Idx) {
      var self = this
      MyApiClient.get('getdata/labrequest_hd_where_id.php?ROID=' + row.ROID)
        .then((resp) => {
          self.A5dataheader = resp.data.response
          self.A5reportHd.ROID = self.A5dataheader[0].ROID
          self.A5reportHd.RONo = self.A5dataheader[0].RONo
          self.A5reportHd.DocDate = self.A5dataheader[0].DocDate
          self.A5reportHd.DocTime = self.A5dataheader[0].DocTime
          self.A5reportHd.PatCode = self.A5dataheader[0].PatCode
          self.A5reportHd.PrefixName = self.A5dataheader[0].PrefixName
          self.A5reportHd.PatName = self.A5dataheader[0].PatName
          self.A5reportHd.PatLName = self.A5dataheader[0].PatLName
          self.A5reportHd.PrefixName2 = self.A5dataheader[0].PrefixName2
          self.A5reportHd.PatName2 = self.A5dataheader[0].PatName2
          self.A5reportHd.PatLName2 = self.A5dataheader[0].PatLName2
          self.A5reportHd.IDNo = self.A5dataheader[0].IDNo
          self.A5reportHd.Sex = self.A5dataheader[0].Sex
          self.A5reportHd.Tel1 = self.A5dataheader[0].Tel1
          self.A5reportHd.Tel2 = self.A5dataheader[0].Tel2
          self.A5reportHd.BirthDate = self.A5dataheader[0].BirthDate
          self.A5reportHd.AgeYears = self.A5dataheader[0].AgeYears
          self.A5reportHd.AgeMonths = self.A5dataheader[0].AgeMonths
          self.A5reportHd.AgeDays = self.A5dataheader[0].AgeDays
          self.A5reportHd.ReqClinicName = self.A5dataheader[0].ReqClinicName
          self.A5reportHd.HNNo = self.A5dataheader[0].HNNo
          self.A5reportHd.OfficerName1 = self.A5dataheader[0].OfficerName1
          self.A5reportHd.OfficerName2 = self.A5dataheader[0].OfficerName2
          self.A5reportHd.OfficerName3 = self.A5dataheader[0].OfficerName3
          self.A5reportHd.PassportNo = self.A5dataheader[0].PassportNo
          self.A5reportHd.Country = self.A5dataheader[0].Country
          self.A5reportHd.BP_1 = self.A5dataheader[0].BP_1
          self.A5reportHd.BP_2 = self.A5dataheader[0].BP_2
          self.A5reportHd.Pulse = self.A5dataheader[0].Pulse
          self.A5reportHd.Weight = self.A5dataheader[0].Weight
          self.A5reportHd.Height = self.A5dataheader[0].Height
          self.A5reportHd.BodyTemp = self.A5dataheader[0].BodyTemp
          self.A5reportHd.SpO2 = self.A5dataheader[0].SpO2
          self.A5reportHd.Specimen = self.A5dataheader[0].Specimen
          // ชื่อไฟล์ลายเซ็นต์ *.PNG
          self.A5reportHd.OfficerName1Sign = self.A5dataheader[0].OfficerName1Sign
          self.A5reportHd.OfficerName2Sign = self.A5dataheader[0].OfficerName2Sign
          self.A5reportHd.OfficerName3Sign = self.A5dataheader[0].OfficerName3Sign
          self.A5reportHd.ResultedDate = self.A5dataheader[0].ResultedDate
          self.A5reportHd.ApprovedDate = self.A5dataheader[0].ApprovedDate
          self.A5reportHd.Status = self.A5dataheader[0].Status
          self.A5reportHd.Remark = self.A5dataheader[0].Remark
          if (self.A5reportHd.ReqClinicName == null) {
            self.A5reportHd.ReqClinicName = ''
          }
          if (self.A5reportHd.OfficerName3 == null) {
            self.A5reportHd.OfficerName3 = ''
          }
          // ========================================= //
          // ดึง Detail ของใบสั่งตรวจ
          // ========================================= //
          self.getA5ReportDtlData(row, formA5Idx)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    printRODocA5 (row, formA5Idx) {
      this.formA4A5 = formA5Idx
      // ดึงข้อมูลให้เสร็จก่อนแล้วค่อยสร้างรายงาน เรียกแบบ promise
      // A5GroupTest
      //    A5reportDtl
      this.getA5ReportData(row, formA5Idx)
    },
    // =========================================================== //
    //                           COVID
    // =========================================================== //
    getReportHdData (ROID, formType) {
      var self = this
      MyApiClient.get('getdata/labrequest_hd_where_id.php?ROID=' + ROID)
        .then((resp) => {
          self.dataheader = resp.data.response
          self.reportHd.ROID = self.dataheader[0].ROID
          self.reportHd.RONo = self.dataheader[0].RONo
          self.reportHd.DocDate = self.dataheader[0].DocDate
          self.reportHd.DocTime = self.dataheader[0].DocTime
          self.reportHd.PatCode = self.dataheader[0].PatCode
          self.reportHd.PrefixName = self.dataheader[0].PrefixName
          self.reportHd.PatName = self.dataheader[0].PatName
          self.reportHd.PatLName = self.dataheader[0].PatLName
          self.reportHd.PrefixName2 = self.dataheader[0].PrefixName2
          self.reportHd.PatName2 = self.dataheader[0].PatName2
          self.reportHd.PatLName2 = self.dataheader[0].PatLName2
          self.reportHd.IDNo = self.dataheader[0].IDNo
          self.reportHd.Sex = self.dataheader[0].Sex
          self.reportHd.Tel1 = self.dataheader[0].Tel1
          self.reportHd.Tel2 = self.dataheader[0].Tel2
          self.reportHd.BirthDate = self.dataheader[0].BirthDate
          self.reportHd.AgeYears = self.dataheader[0].AgeYears
          self.reportHd.AgeMonths = self.dataheader[0].AgeMonths
          self.reportHd.AgeDays = self.dataheader[0].AgeDays
          self.reportHd.ReqClinicName = self.dataheader[0].ReqClinicName
          self.reportHd.OfficerName1 = self.dataheader[0].OfficerName1
          self.reportHd.OfficerName2 = self.dataheader[0].OfficerName2
          self.reportHd.OfficerName3 = self.dataheader[0].OfficerName3
          self.reportHd.PassportNo = self.dataheader[0].PassportNo
          self.reportHd.Country = self.dataheader[0].Country
          // ชื่อไฟล์ลายเซ็นต์ *.PNG
          self.reportHd.OfficerName1Sign = self.dataheader[0].OfficerName1Sign
          self.reportHd.OfficerName2Sign = self.dataheader[0].OfficerName2Sign
          self.reportHd.OfficerName3Sign = self.dataheader[0].OfficerName3Sign
          self.reportHd.ResultedDate = self.dataheader[0].ResultedDate
          self.reportHd.ApprovedDate = self.dataheader[0].ApprovedDate
          self.reportHd.Status = self.dataheader[0].Status
          self.reportHd.Remark = self.dataheader[0].Remark
          if (self.reportHd.ReqClinicName == null) {
            self.reportHd.ReqClinicName = ''
          }
          if (self.reportHd.OfficerName3 == null) {
            self.reportHd.OfficerName3 = ''
          }
          // console.log(self.reportHd.OfficerName3)
          if (formType === '') {
            // รูปแบบมาตราฐาน
            self.createPdfForm1ToScreen()
          } else if (formType === 'RT-PCR') {
            if (this.isDetected(this.reportDtl[0].Result, 'not')) {
              // แบบฟอร์มตรวจ DETECTED Covid RT-PCR ของลูกค้าเพิ่มบาร์โค้ดและปรับตำแหน่ง
              self.createPdfForm2DetectedToScreen()
            } else {
              // แบบฟอร์มตรวจ NOT DETECTED Covid RT-PCR ของลูกค้าเพิ่มบาร์โค้ดและปรับตำแหน่ง
              self.createPdfForm2NotDetectedToScreen()
            }
          } else if (formType === 'ATK') {
            // แบบฟอร์มตรวจ Covid ATK ของลูกค้าเพิ่มบาร์โค้ดและปรับตำแหน่ง
            self.createPdfForm3ToScreen()
          } else if (formType === 'ATK-4') {
            // แบบฟอร์มตรวจ Covid ATK ของลูกค้า (คุณโต้บุรีรัมย์)
            self.createPdfForm4ToScreen()
          } else if (formType === 'PCR-5') {
            // แบบฟอร์มตรวจ Covid RT-PCR ของลูกค้า (คุณโต้บุรีรัมย์)
            self.createPdfForm5ToScreen()
          } else if (formType === 'ATK-6') {
            // แบบฟอร์มตรวจ Covid ATK ของลูกค้า (คุณหญิงนครศรี) ตัด company/unit/method ออก
            self.createPdfForm6ToScreen() // copy from "createPdfForm3ToScreen()"
          } else if (formType === 'ATK-7') {
            // แบบฟอร์มตรวจ Covid ATK ของลูกค้า (คุณหญิงนครศรี) เหมือน #6 แต่เป็นภาษาอังกฤษ
            self.createPdfForm7ToScreen()
          } else {
            // ไม่พบฟอร์มที่ระบุ--> พิมพ์รูปแบบมาตราฐาน
            self.createPdfForm1ToScreen()
          }
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // ผลแล็บทั้งหมดของใบนั้นๆ
    getReportDtlData (ROID, formType) {
      var self = this
      MyApiClient.get('getdata/labrequest_dtl_where_id.php?ROID=' + ROID)
        .then((resp) => {
          // console.log(resp.data.response)
          self.reportDtl = resp.data.response
          self.getReportHdData(ROID, formType)
          // console.log()
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    printRODoc (ROID, formType) {
      // ดึงข้อมูลให้เสร็จก่อนแล้วค่อยสร้างรายงาน เรียกแบบ promise
      //  getReportDtlData(ROID) -> getReportHdData (ROID) -> createPdfForm1ToScreen ()
      this.getReportDtlData(ROID, formType)
    },
    // =========================================================== //
    //                         ฟอร์มภูมิแพ้อาหาร
    // =========================================================== //
    // (1.) รูปแบบใบแสดงผลภูมิแพ้อาหาร แบบที่ 1 ---------- //
    createAlgyPdfForm1ToScreen () {
      var pageMarginsTop = 125
      if (this._vitalSignText === '') { pageMarginsTop = 110 }
      //  ---------------------------------- //
      var PatNamePrn = this.A5reportHd.PatName
      var PatLNamePrn = this.A5reportHd.PatLName
      var PrefixNamePrn = this.A5reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.A5reportHd.PatName2
        PatLNamePrn = this.A5reportHd.PatLName2
        PrefixNamePrn = this.A5reportHd.PrefixName2
      }

      var DOBPrn = ''
      if (this.optDOB) {
        DOBPrn = '  DOB: ' + this.A5reportHd.BirthDate
      }
      // ==================================== //
      // ข้อความลายน้ำชื่อคลินิก
      var strWatermark = ''
      var colorWatermark = 'gray'
      if (this.A5reportHd.Cancel === 1 || this.A5reportHd.Cancel === '1') {
        strWatermark = 'ยกเลิก CANCELED'
        colorWatermark = 'red'
      } else {
        if (this.optWatermark) {
          strWatermark = this.globalCorpInfo.name + ' '
        }
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint_Algy')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        pageSize: 'A5',
        pageOrientation: 'landscape',
        pageMargins: [20, pageMarginsTop, 20, 100],
        watermark: { text: strWatermark, color: colorWatermark, opacity: 0.2, bold: true, italics: true },
        header: {
          margin: [20, 10, 20, 5],
          table: {
            widths: [50, 230, 250],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 4,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 16,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                // Header ด้านขวา ใบสั่งตรวจ
                {
                  rowSpan: 4,
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '\n Sex: ' + this.arrSex[this.A5reportHd.Sex] +
                    '  Age: ' + this.A5reportHd.AgeYears + '.' + this.A5reportHd.AgeMonths + '.' + this.A5reportHd.AgeDays + ' years' +
                    DOBPrn +
                    (this.A5reportHd.IDNo === '' ? '' : '\n ID No.: ' + this.A5reportHd.IDNo) +
                    (this.A5reportHd.PassportNo === '' ? '' : '\n Passport No.: ' + this.A5reportHd.PassportNo) +
                    (this.A5reportHd.Country === '' ? '' : ' / ' + this.A5reportHd.Country) +
                    '\n Clinic: ' + this.A5reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.A5reportHd.RONo + '    Date: ' + this.A5reportHd.DocDate + ' ' + this.A5reportHd.DocTime],
                  bold: true,
                  fontSize: 14,
                  margin: [10, 0, 0, 0],
                  lineHeight: 0.8,
                  border: [0, 0, 0, 0]
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 12,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 +
                        (self.globalCorpInfo.fax !== '' ? ' Fax: ' + self.globalCorpInfo.fax : '') + '\n' +
                        'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                { },
                {
                  image: self.textToBase64Barcode(self.A5reportHd.RONo, 35),
                  width: 100,
                  alignment: 'left',
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                },
                { }
              ],
              [
                {
                  colSpan: 3,
                  text: 'Vital signs :' + this._vitalSignText,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#DCDCDC'
                },
                {},
                {}
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [20, 0, 20, 5],
            table: {
              widths: [220, 150, 150],
              body: [
                [
                  {
                    rowSpan: 3,
                    text: 'L=Result below reference interval\n H=Result above reference interval\n R=Repeat\n' +
                          'This report only certifies samples that have been analyzed. Do not copy the report only partialy ' +
                          'without permission from labaratory Writer',
                    fontSize: 11
                  },
                  { text: 'Reported by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] },
                  { text: 'Approved by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] }],
                ['',
                  {
                    image: self.A5reportHd.OfficerName2Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  },
                  {
                    image: self.A5reportHd.OfficerName3Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                ['',
                  {
                    text: self.A5reportHd.OfficerName2 + '\n' + self.A5reportHd.ResultedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  },
                  {
                    text: self.A5reportHd.OfficerName3 + '\n' + self.A5reportHd.ApprovedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 15,
          lineHeight: 0.7
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    getAlgyReportDtlData (row, formAlgyIdx) {
      var self = this
      MyApiClient.get('getdata/labrequest_dtl_group_where_id.php?ROID=' + row.ROID)
        .then((resp) => {
          // รายการ items ผลตรวจทั้งหมด
          self.A5reportDtl = resp.data.response
          // ========================================= //
          // คัดมาเฉพาะชื่อ TestSuit สำหรับจัดกลุ่มพิมพ์ เรียงตามชุด
          // ========================================= //
          const result = []
          const map = new Map()
          for (const item of self.A5reportDtl) {
            if (!map.has(item.TestID)) {
              map.set(item.TestID, true) // set any value to Map
              result.push(item)
            }
          }
          self.A5GroupTest = result
          // Print/Create Pdf
          if (formAlgyIdx === 'ALGY-1') {
            // รูปแบบมาตราฐาน
            this.$nextTick(() => self.createAlgyPdfForm1ToScreen())
          } else {
            // รูปแบบที่ 1
            this.$nextTick(() => self.createAlgyPdfForm1ToScreen())
          }
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getAlgyReportData (row, formAlgyIdx) {
      var self = this
      MyApiClient.get('getdata/labrequest_hd_where_id.php?ROID=' + row.ROID)
        .then((resp) => {
          self.A5dataheader = resp.data.response
          self.A5reportHd.ROID = self.A5dataheader[0].ROID
          self.A5reportHd.RONo = self.A5dataheader[0].RONo
          self.A5reportHd.DocDate = self.A5dataheader[0].DocDate
          self.A5reportHd.DocTime = self.A5dataheader[0].DocTime
          self.A5reportHd.PatCode = self.A5dataheader[0].PatCode
          self.A5reportHd.PrefixName = self.A5dataheader[0].PrefixName
          self.A5reportHd.PatName = self.A5dataheader[0].PatName
          self.A5reportHd.PatLName = self.A5dataheader[0].PatLName
          self.A5reportHd.PrefixName2 = self.A5dataheader[0].PrefixName2
          self.A5reportHd.PatName2 = self.A5dataheader[0].PatName2
          self.A5reportHd.PatLName2 = self.A5dataheader[0].PatLName2
          self.A5reportHd.IDNo = self.A5dataheader[0].IDNo
          self.A5reportHd.Sex = self.A5dataheader[0].Sex
          self.A5reportHd.Tel1 = self.A5dataheader[0].Tel1
          self.A5reportHd.Tel2 = self.A5dataheader[0].Tel2
          self.A5reportHd.BirthDate = self.A5dataheader[0].BirthDate
          self.A5reportHd.AgeYears = self.A5dataheader[0].AgeYears
          self.A5reportHd.AgeMonths = self.A5dataheader[0].AgeMonths
          self.A5reportHd.AgeDays = self.A5dataheader[0].AgeDays
          self.A5reportHd.ReqClinicName = self.A5dataheader[0].ReqClinicName
          self.A5reportHd.OfficerName1 = self.A5dataheader[0].OfficerName1
          self.A5reportHd.OfficerName2 = self.A5dataheader[0].OfficerName2
          self.A5reportHd.OfficerName3 = self.A5dataheader[0].OfficerName3
          self.A5reportHd.PassportNo = self.A5dataheader[0].PassportNo
          self.A5reportHd.Country = self.A5dataheader[0].Country
          self.A5reportHd.BP_1 = self.A5dataheader[0].BP_1
          self.A5reportHd.BP_2 = self.A5dataheader[0].BP_2
          self.A5reportHd.Pulse = self.A5dataheader[0].Pulse
          self.A5reportHd.Weight = self.A5dataheader[0].Weight
          self.A5reportHd.Height = self.A5dataheader[0].Height
          self.A5reportHd.BodyTemp = self.A5dataheader[0].BodyTemp
          self.A5reportHd.SpO2 = self.A5dataheader[0].SpO2
          // ชื่อไฟล์ลายเซ็นต์ *.PNG
          self.A5reportHd.OfficerName1Sign = self.A5dataheader[0].OfficerName1Sign
          self.A5reportHd.OfficerName2Sign = self.A5dataheader[0].OfficerName2Sign
          self.A5reportHd.OfficerName3Sign = self.A5dataheader[0].OfficerName3Sign
          self.A5reportHd.ResultedDate = self.A5dataheader[0].ResultedDate
          self.A5reportHd.ApprovedDate = self.A5dataheader[0].ApprovedDate
          self.A5reportHd.Status = self.A5dataheader[0].Status
          self.A5reportHd.Remark = self.A5dataheader[0].Remark
          if (self.A5reportHd.ReqClinicName == null) {
            self.A5reportHd.ReqClinicName = ''
          }
          if (self.A5reportHd.OfficerName3 == null) {
            self.A5reportHd.OfficerName3 = ''
          }
          // ========================================= //
          // ดึง Detail ของใบสั่งตรวจ
          // ========================================= //
          self.getAlgyReportDtlData(row, formAlgyIdx)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    printAlgyForm (row, formAlgyIdx) {
      // ดึงข้อมูลให้เสร็จก่อนแล้วค่อยสร้างรายงาน เรียกแบบ promise
      // A5GroupTest
      //    A5reportDtl
      this.getAlgyReportData(row, formAlgyIdx)
    },
    // =========================================================== //
    isDetected (str1, srcStr) {
      if (str1.toLowerCase().indexOf(srcStr) === -1) {
        // Detected
        return true
      } else {
        return false
      }
    },
    GetCommentOfDetected_NotDetected (str1, srcStr) {
      var ret
      if (str1.toLowerCase().indexOf(srcStr) === -1) {
        // Detected
        ret = 'Comment : SAR-CoV-2 RNA : Detected by RT-PCR Genetic material of SAR-CoV-2 was detedted in this specimen.' +
          ' SAR-CoV-2 RNA was presence in this specimen.\n\n' +
          'Comment : SAR-CoV-2 RNA : Detected by RT-PCR ตรวจพบสารพันธุกรรมของเชื้อ SAR-CoV-2 (โควิด-19)' +
          'แสดงว่าในสิ่งส่งตรวจผู้ป่วยมีการพบเชื้อ SAR-CoV-19 (โควิด-19)'
      } else {
        // Not Detected
        ret = 'Comment : RT-PCR Not Detectable. The result state you were not infected with SAR-CoV-2 at' +
          ' the time of testing or SAR-CoV-2 RNA was not present in the specimen above the time limit of detection. We recommended' +
          ' following quarantine recommendations and universal precautions. if COVID-19 is still suspected,re-testing shound be considered.\n\n' +
          'Comment : RT-PCR Not Detectable. ตรวจไม่พบสารพันธุกรรมของ SAR-CoV-2 ในสิ่งที่ส่งตรวจ แสดงว่าผู้ป่วยไม่น่าจะติดเชื้อ' +
          'SAR-CoV-2 และ/หรือ ติดเชื้อแล้วแต่ยังไม่แสดงอาการ เพราะมีปริมาณเชื้อในร่างกายน้อยมาก จึงทำให้ตรวจไม่พบสารพัธุกรรมของ SAR-CoV-2'
      }
      return ret
    },
    // เช็ค "ประเภทการตรวจ" จากชื่อเทสว่าเป็น RT-PCR หรือ ATK สำหรับเป็นพิมพ์ฟอร์มแบบเลือกฟอร์มอัติโนมัติ
    GetCaptionRTPCR_ATK (str1) {
      return 'None'
      // const strSARS = 'sars'
      // const strATK = 'atk'
      // if (str1.toLowerCase().indexOf(strATK) >= 0) {
      //   return 'ATK'
      // } else if (str1.toLowerCase().indexOf(strSARS) >= 0) {
      //   return 'RT-PCR'
      // } else {
      //   return 'None'
      // }
    },
    FormatNumberLabResult (value, valueType) {
      // console.log('CHECK FORMAT ')
      // console.log(value)
      // console.log(valueType)
      // console.log(valueType === '0')
      if (valueType === '0') {
        // console.log(value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'))
        return value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      } else {
        return value
      }
    },
    // ----------- (1) รูปแบบใบแสดงผลเป็นฟอร์ม A4 (General) ---------- //
    createPdfForm1ToScreen () {
      var PatNamePrn = this.reportHd.PatName
      var PatLNamePrn = this.reportHd.PatLName
      var PrefixNamePrn = this.reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.reportHd.PatName2
        PatLNamePrn = this.reportHd.PatLName2
        PrefixNamePrn = this.reportHd.PrefixName2
      }
      // ==================================== //
      var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'LEGAL',
        // pageOrientation: 'landscape',
        pageMargins: [30, 160, 30, 160],
        header: {
          columns: [
            {
              image: self.textToBase64Barcode(self.reportHd.RONo, 60),
              width: 200,
              margin: [40, 110, 10, 10]
            },
            {
              text: '',
              width: 100,
              margin: [10, 20, 10, 10]
            },
            {
              text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                '\n Sex: ' + this.arrSex[this.reportHd.Sex] +
                '       Age: ' + this.reportHd.AgeYears + '.' + this.reportHd.AgeMonths + '.' + this.reportHd.AgeDays + ' years' +
                '\n ID No.: ' + this.reportHd.IDNo +
                '\n ID No.: ' + this.reportHd.IDNo + (this.reportHd.PassportNo === '' ? '' : '    Passport No.: ' + this.reportHd.PassportNo) +
                '\n Clinic: ' + this.reportHd.ReqClinicName +
                '\n LAB No.: ' + this.reportHd.RONo + '    Date: ' + this.reportHd.DocDate + ' ' + this.reportHd.DocTime],
              bold: true,
              fontSize: 16,
              margin: [10, 20, 10, 10]
            }
          ]
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [40, 10, 40, 20],
            table: {
              widths: [200, 150, 150],
              body: [
                [
                  {
                    rowSpan: 3,
                    text: 'L=Result below reference interval\n H=Result above reference interval\n R=Repeat\n' +
                          'This report only certifies samples that have been analyzed. Do not copy the report only partialy ' +
                          'without permission from labaratory Writer',
                    fontSize: 12
                  },
                  { text: 'Reported by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] },
                  { text: 'Approved by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] }],
                ['',
                  {
                    image: self.reportHd.OfficerName2Sign,
                    width: 60,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  },
                  {
                    image: self.reportHd.OfficerName3Sign,
                    width: 60,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                ['',
                  {
                    text: self.reportHd.OfficerName2 + '\n' + self.reportHd.ResultedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  },
                  {
                    text: self.reportHd.OfficerName3 + '\n' + self.reportHd.ApprovedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 16
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // ----------- (2-1) รูปแบบใบแสดงผลเป็นฟอร์ม A4 : DETECTED (RT-PCR) ---------- //
    createPdfForm2DetectedToScreen () {
      var PatNamePrn = this.reportHd.PatName
      var PatLNamePrn = this.reportHd.PatLName
      var PrefixNamePrn = this.reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.reportHd.PatName2
        PatLNamePrn = this.reportHd.PatLName2
        PrefixNamePrn = this.reportHd.PrefixName2
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      // const pdfTable = document.getElementById('divToPrint')
      // ------- html to pdf format
      // var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'LEGAL',
        // pageOrientation: 'landscape',
        pageMargins: [20, 160, 20, 160],
        header: {
          margin: [20, 20, 20, 5],
          table: {
            widths: [50, 230, 250],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 4,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 18,
                  lineHeight: 0.5
                },
                // Header ด้านขวา ใบสั่งตรวจ
                {
                  rowSpan: 4,
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '\n Sex: ' + this.arrSex[this.reportHd.Sex] +
                    '       Age: ' + this.reportHd.AgeYears + '.' + this.reportHd.AgeMonths + '.' + this.reportHd.AgeDays + ' years' +
                    '\n ID No.: ' + this.reportHd.IDNo +
                    '\n Company: ' + this.reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.reportHd.RONo + '    \nDate: ' + this.reportHd.DocDate + ' ' + this.reportHd.DocTime],
                  bold: true,
                  fontSize: 18,
                  margin: [10, 0, 0, 0],
                  lineHeight: 0.8,
                  border: [0, 0, 0, 0]
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 14,
                  lineHeight: 0.5
                },
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 + ' Fax: ' + self.globalCorpInfo.fax + '\n' +
                        'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                  bold: false,
                  fontSize: 14,
                  lineHeight: 0.7
                },
                {}
              ],
              [
                { },
                {
                  image: self.textToBase64Barcode(self.reportHd.RONo, 70),
                  width: 100,
                  alignment: 'left',
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                },
                { }
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
          // columns: [
          //   {
          //     image: self.textToBase64Barcode(self.reportHd.RONo, 60),
          //     width: 200,
          //     margin: [40, 110, 10, 10]
          //   },
          //   {
          //     text: '',
          //     width: 100,
          //     margin: [10, 20, 10, 10]
          //   },
          //   {
          //     text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
          //       '\n Sex: ' + this.arrSex[this.reportHd.Sex] +
          //       '       Age: ' + this.reportHd.AgeYears + '.' + this.reportHd.AgeMonths + '.' + this.reportHd.AgeDays + ' years' +
          //       '\n ID No.: ' + this.reportHd.IDNo +
          //       '\n Company: ' + this.reportHd.ReqClinicName +
          //       '\n LAB No.: ' + this.reportHd.RONo + '    Date: ' + this.reportHd.DocDate + ' ' + this.reportHd.DocTime],
          //     bold: true,
          //     fontSize: 18,
          //     margin: [10, 20, 10, 10]
          //   }
          // ]
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [40, 10, 40, 20],
            table: {
              widths: [200, 150, 150],
              body: [
                [
                  {
                    rowSpan: 3,
                    text: 'L=Result below reference interval\n H=Result above reference interval\n R=Repeat\n' +
                          'This report only certifies samples that have been analyzed. Do not copy the report only partialy ' +
                          'without permission from labaratory Writer',
                    fontSize: 12
                  },
                  { text: 'Reported by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] },
                  { text: 'Approved by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] }],
                ['',
                  {
                    image: self.reportHd.OfficerName2Sign,
                    width: 60,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  },
                  {
                    image: self.reportHd.OfficerName3Sign,
                    width: 60,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                ['',
                  {
                    text: self.reportHd.OfficerName2 + '\n' + self.reportHd.ResultedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  },
                  {
                    text: self.reportHd.OfficerName3 + '\n' + self.reportHd.ApprovedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        // content: html,
        content: [
          {
            table: {
              widths: [100, 5, 120, 100, '*', 100],
              // widths: [100, '*', 200, 10, 80, 50, '*'],
              body: [
                // ============ แถวที่ 1 ============
                [
                  { text: 'Test', bold: true, border: [false, true, false, true] },
                  { text: '', bold: true, border: [false, true, false, true] },
                  { text: 'Result', alignment: 'left', bold: true, border: [false, true, false, true] },
                  { text: 'Specimen', bold: true, border: [false, true, false, true] },
                  { text: 'Method', bold: true, border: [false, true, false, true] },
                  { text: 'Normal Range', bold: true, border: [false, true, false, true] }
                ],
                // ============ แถวที่ 2 ============
                [
                  { text: this.reportDtl[0].ItemTestName, margin: [0, 10, 0, 5], italics: false },
                  { text: this.arrRepeatChk[this.reportDtl[0].RepeatChecked], margin: [0, 10, 0, 5], italics: false },
                  { text: this.reportDtl[0].PrefixResult + ' ' + this.reportDtl[0].Result, margin: [0, 10, 0, 5], italics: false, color: ((this.reportDtl[0].Result.toLowerCase().indexOf('not') === -1) ? 'red' : 'black') },
                  { text: this.reportDtl[0].Specimen, margin: [0, 10, 0, 5], italics: false },
                  { text: this.reportDtl[0].Method, margin: [0, 10, 0, 5], italics: false },
                  { text: this.reportDtl[0].NormalValue, margin: [0, 10, 0, 5], italics: false }
                ]
              ]
            },
            layout: {
              defaultBorder: false
            }
          },
          { text: '\n ' },
          { text: this.GetCommentOfDetected_NotDetected(this.reportDtl[0].Result, 'not'), fontSize: 14 },
          { text: '\n ' },
          {
            table: {
              widths: [120, 100, 50],
              body: [
                // ============ แถวที่ 1 ============
                [
                  { text: 'Recommendation : ', bold: true, border: [false, false, false, false] },
                  { text: this.reportDtl[1].ItemTestName, bold: false, border: [false, false, false, false] },
                  { text: this.FormatNumberLabResult(this.reportDtl[1].Result, this.reportDtl[1].ValueType), bold: false, border: [false, false, false, false] }
                ],
                // ============ แถวที่ 2 ============
                [
                  { text: '', bold: true, border: [false, false, false, false] },
                  { text: this.reportDtl[2].ItemTestName, bold: false, border: [false, false, false, false] },
                  { text: this.reportDtl[2].Result, bold: false, border: [false, false, false, false] }
                ],
                // ============ แถวที่ 3 ============
                [
                  { text: '', bold: true, border: [false, false, false, false] },
                  { text: this.reportDtl[3].ItemTestName, bold: false, border: [false, false, false, false] },
                  { text: this.reportDtl[3].Result, bold: false, border: [false, false, false, false] }
                ]
              ]
            },
            layout: {
              defaultBorder: false
            },
            margin: [60, 0, 0, 0]
          },
          { text: '___________________________________________________________________________________', alignment: 'center' },
          {
            table: {
              widths: [120, 200],
              body: [
                // ============ แถวที่ 1 ============
                [
                  { text: 'Reagent', bold: true },
                  { text: 'Novel Coronavirus (2019-nCoV)', bold: false }
                ],
                // ============ แถวที่ 2 ============
                [
                  { text: 'Target Gene', bold: true },
                  { text: 'ORF-1ab gene, N gene', bold: false }
                ],
                // ============ แถวที่ 3 ============
                [
                  { text: 'Ct Cut off', bold: true },
                  { text: '<= 40', bold: false }
                ],
                // ============ แถวที่ 4 ============
                [
                  { text: 'Limit of Detection (LOD)', bold: true },
                  { text: '200 copies/ml', bold: false }
                ]
              ]
            },
            layout: {
              defaultBorder: false
            },
            margin: [60, 0, 0, 0]
          }
        ],
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 18
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // ----------- (2-2) รูปแบบใบแสดงผลเป็นฟอร์ม A4 : NOT DETECTED (RT-PCR) ---------- //
    createPdfForm2NotDetectedToScreen () {
      var PatNamePrn = this.reportHd.PatName
      var PatLNamePrn = this.reportHd.PatLName
      var PrefixNamePrn = this.reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.reportHd.PatName2
        PatLNamePrn = this.reportHd.PatLName2
        PrefixNamePrn = this.reportHd.PrefixName2
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      // const pdfTable = document.getElementById('divToPrint')
      // ------- html to pdf format
      // var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'LEGAL',
        // pageOrientation: 'landscape',
        pageMargins: [20, 160, 20, 160],
        header: {
          margin: [20, 20, 20, 5],
          table: {
            widths: [50, 230, 250],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 4,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 18,
                  lineHeight: 0.5
                },
                // Header ด้านขวา ใบสั่งตรวจ
                {
                  rowSpan: 4,
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '\n Sex: ' + this.arrSex[this.reportHd.Sex] +
                    '       Age: ' + this.reportHd.AgeYears + '.' + this.reportHd.AgeMonths + '.' + this.reportHd.AgeDays + ' years' +
                    '\n ID No.: ' + this.reportHd.IDNo +
                    '\n Company: ' + this.reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.reportHd.RONo + '    \nDate: ' + this.reportHd.DocDate + ' ' + this.reportHd.DocTime],
                  bold: true,
                  fontSize: 18,
                  margin: [10, 0, 0, 0],
                  lineHeight: 0.8,
                  border: [0, 0, 0, 0]
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 14,
                  lineHeight: 0.5
                },
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 + ' Fax: ' + self.globalCorpInfo.fax + '\n' +
                        'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                  bold: false,
                  fontSize: 14,
                  lineHeight: 0.7
                },
                {}
              ],
              [
                { },
                {
                  image: self.textToBase64Barcode(self.reportHd.RONo, 70),
                  width: 100,
                  alignment: 'left',
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                },
                { }
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [40, 10, 40, 20],
            // table: {
            //   body: [
            //     // แถวที่ 1 ของตาราง : มีขอบตาราง แสดงลายเซ็นต์
            //     [
            //       {
            //         text: 'L=Result below reference interval\n H=Result above reference interval\n R=Repeat\n' +
            //               'This report only certifies samples that have been analyzed. Do not copy the report only partialy ' +
            //               'without permission from labaratory Writer',
            //         border: [1, 1, 1, 1],
            //         width: 200,
            //         alignment: 'left',
            //         fontSize: 12
            //       },
            //       {
            //         text: 'Reported by \n\n _____________________________________ \n' + self.reportHd.OfficerName2 + '\n' + self.reportHd.ResultedDate,
            //         width: 150,
            //         alignment: 'center',
            //         fontSize: 12
            //       },
            //       {
            //         text: 'Approved by \n\n _____________________________________ \n' + self.reportHd.OfficerName3 + '\n' + self.reportHd.ApprovedDate,
            //         width: 150,
            //         alignment: 'center',
            //         fontSize: 12
            //       }
            //     ],
            //     // แถวที่ 1-1 ของตาราง : มีขอบตาราง แสดงภาพลายเซ็นต์
            //     [
            //       {
            //         text: '',
            //         border: [1, 1, 1, 1],
            //         width: 200,
            //         alignment: 'left',
            //         fontSize: 12
            //       },
            //       {
            //         text: 'Reported by',
            //         width: 150,
            //         alignment: 'center',
            //         fontSize: 12
            //       },
            //       {
            //         text: 'Approved by',
            //         width: 150,
            //         alignment: 'center',
            //         fontSize: 12
            //       }
            //     ],
            //     // แถวที่ 2 ของตาราง : ไม่มีขอบตาราง แสดงเลขที่หน้า
            //     [
            //       {
            //         text: '',
            //         border: [0, 0, 0, 0],
            //         width: 200,
            //         alignment: 'left',
            //         fontSize: 12
            //       },
            //       {
            //         text: '',
            //         border: [0, 0, 0, 0],
            //         width: 150,
            //         alignment: 'center',
            //         fontSize: 12
            //       },
            //       {
            //         text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
            //         border: [0, 0, 0, 0],
            //         width: 150,
            //         alignment: 'right',
            //         fontSize: 12
            //       }
            //     ]
            //   ]
            // }
            table: {
              widths: [200, 150, 150],
              body: [
                [
                  {
                    rowSpan: 3,
                    text: 'L=Result below reference interval\n H=Result above reference interval\n R=Repeat\n' +
                          'This report only certifies samples that have been analyzed. Do not copy the report only partialy ' +
                          'without permission from labaratory Writer',
                    fontSize: 12
                  },
                  { text: 'Reported by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] },
                  { text: 'Approved by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] }],
                ['',
                  {
                    image: self.reportHd.OfficerName2Sign,
                    width: 60,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  },
                  {
                    image: self.reportHd.OfficerName3Sign,
                    width: 60,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                ['',
                  {
                    text: self.reportHd.OfficerName2 + '\n' + self.reportHd.ResultedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  },
                  {
                    text: self.reportHd.OfficerName3 + '\n' + self.reportHd.ApprovedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        // content: html,
        content: [
          {
            table: {
              widths: [100, 5, 120, 100, '*', 100],
              // widths: [100, '*', 200, 10, 80, 50, '*'],
              body: [
                // ============ แถวที่ 1 ============
                [
                  { text: 'Test', bold: true, border: [false, true, false, true] },
                  { text: '', bold: true, border: [false, true, false, true] },
                  { text: 'Result', alignment: 'left', bold: true, border: [false, true, false, true] },
                  { text: 'Specimen', bold: true, border: [false, true, false, true] },
                  { text: 'Method', bold: true, border: [false, true, false, true] },
                  { text: 'Normal Range', bold: true, border: [false, true, false, true] }
                ],
                // ============ แถวที่ 2 ============
                [
                  { text: this.reportDtl[0].ItemTestName, margin: [0, 10, 0, 5], italics: false },
                  { text: this.arrRepeatChk[this.reportDtl[0].RepeatChecked], margin: [0, 10, 0, 5], italics: false },
                  { text: this.reportDtl[0].PrefixResult + ' ' + this.reportDtl[0].Result, margin: [0, 10, 0, 5], italics: false, color: ((this.reportDtl[0].Result.toLowerCase().indexOf('not') === -1) ? 'red' : 'green') },
                  { text: this.reportDtl[0].Specimen, margin: [0, 10, 0, 5], italics: false },
                  { text: this.reportDtl[0].Method, margin: [0, 10, 0, 5], italics: false },
                  { text: this.reportDtl[0].NormalValue, margin: [0, 10, 0, 5], italics: false }
                ]
              ]
            },
            layout: {
              defaultBorder: false
            }
          },
          { text: '\n ' },
          { text: this.GetCommentOfDetected_NotDetected(this.reportDtl[0].Result, 'not'), fontSize: 14 },
          { text: '\n ' },
          {
            table: {
              widths: [120, 100, 50],
              body: [
                // ============ กรณี Not Detected ไม่ต้องแสดงค่าอื่นๆ ให้แสดง N/A ============
                [
                  { text: 'Recommendation : ', bold: true, border: [false, false, false, false] },
                  { text: 'N/A', bold: false, border: [false, false, false, false] },
                  { text: '', bold: false, border: [false, false, false, false] }
                ]
              ]
            },
            layout: {
              defaultBorder: false
            },
            margin: [60, 0, 0, 0]
          },
          { text: '_________________________________________________________________________________', alignment: 'center' },
          {
            table: {
              widths: [120, 200],
              body: [
                // ============ แถวที่ 1 ============
                [
                  { text: 'Reagent', bold: true },
                  { text: 'Novel Coronavirus (2019-nCoV)', bold: false }
                ],
                // ============ แถวที่ 2 ============
                [
                  { text: 'Target Gene', bold: true },
                  { text: 'ORF-1ab gene, N gene', bold: false }
                ],
                // ============ แถวที่ 3 ============
                [
                  { text: 'Ct Cut off', bold: true },
                  { text: '<= 40', bold: false }
                ],
                // ============ แถวที่ 4 ============
                [
                  { text: 'Limit of Detection (LOD)', bold: true },
                  { text: '200 copies/ml', bold: false }
                ]
              ]
            },
            layout: {
              defaultBorder: false
            },
            margin: [60, 0, 0, 0]
          }
        ],
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 18
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },

    // ----------- (3) รูปแบบใบแสดงผลเป็นฟอร์ม A4 (ATK Rapid Test แบบที่ 1) ---------- //
    createPdfForm3ToScreen () {
      var PatNamePrn = this.reportHd.PatName
      var PatLNamePrn = this.reportHd.PatLName
      var PrefixNamePrn = this.reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.reportHd.PatName2
        PatLNamePrn = this.reportHd.PatLName2
        PrefixNamePrn = this.reportHd.PrefixName2
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      // const pdfTable = document.getElementById('divToPrint')
      // ------- html to pdf format
      // var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'LEGAL',
        // pageOrientation: 'landscape',
        pageMargins: [30, 290, 30, 300],
        header: {
          margin: [30, 20, 30, 10],
          table: {
            widths: [130, 170, 80, 120],
            body: [
              [
                {
                  colSpan: 4,
                  // alignment: 'center',
                  // margin: [0, 20, 0, 0],
                  table: {
                    widths: [50, 230, 220],
                    body: [
                      [
                        // Header ซ้าย โลโก้คลินิก
                        {
                          rowSpan: 3,
                          image: logoBase64,
                          width: 50,
                          alignment: 'center',
                          margin: [0, 0, 0, 0]
                        },
                        // Header กลาง ชื่อคลินิก
                        {
                          text: self.globalCorpInfo.name,
                          bold: true,
                          fontSize: 18,
                          lineHeight: 0.5
                        },
                        {
                          rowSpan: 3,
                          image: self.textToBase64Barcode(self.reportHd.RONo, 60),
                          width: 180,
                          alignment: 'right',
                          margin: [0, 0, 0, 0]
                        }
                      ],
                      [
                        {},
                        {
                          text: self.globalCorpInfo.name2,
                          bold: true,
                          fontSize: 14,
                          lineHeight: 0.5
                        },
                        {}
                      ],
                      [
                        {},
                        {
                          text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                                self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                                'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 + ' Fax: ' + self.globalCorpInfo.fax + '\n' +
                                'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                          bold: false,
                          fontSize: 14,
                          lineHeight: 0.7
                        },
                        {}
                      ]
                    ]
                  },
                  layout: {
                    defaultBorder: false
                  }
                },
                {}, {}, {}
              ],
              [
                { text: 'ใบรับรองผลการตรวจโควิด-19\n Certificate of Testing for COVID-19', bold: true, style: 'tableHeader', colSpan: 4, alignment: 'center', margin: [0, 0, 0, 0] },
                {}, {}, {}
              ],
              [
                { text: 'ชื่อ นามสกุล / Name', margin: [5, 0, 0, 0], bold: true },
                { text: PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn, margin: [5, 0, 0, 0] },
                { text: 'อายุ / Age', margin: [5, 0, 0, 0], bold: true },
                { text: this.reportHd.AgeYears + '.' + this.reportHd.AgeMonths + '.' + this.reportHd.AgeDays + ' years', margin: [5, 0, 0, 0] }
              ],
              [
                { text: 'หมายเลขบัตรประชาชน / ID card number', margin: [5, 0, 0, 0], bold: true, colSpan: 2 },
                {},
                { text: this.reportHd.IDNo, margin: [5, 0, 0, 0], colSpan: 2 },
                {}
              ],
              [
                { text: 'เพศ / Gender ', margin: [5, 0, 0, 0], bold: true },
                { text: this.arrSex[this.reportHd.Sex], margin: [5, 0, 0, 0], colSpan: 3 },
                {},
                {}
              ],
              [
                { text: 'หน่วยงานบริษัท/Company', margin: [5, 0, 0, 0], bold: true },
                { text: this.reportHd.ReqClinicName, margin: [5, 0, 0, 0], colSpan: 3 },
                {},
                {}
              ]
            ]
          },
          layout: {
            defaultBorder: true
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [40, 10, 40, 20],
            table: {
              // widths: [250, 250],
              widths: [125, 125, 125, 125],
              body: [
                [
                  {
                    text: 'Test Result Date :  ',
                    alignment: 'left',
                    fontSize: 16,
                    margin: [0, 0, 0, 20]
                  },
                  {
                    text: self.reportHd.ResultedDate,
                    alignment: 'left',
                    fontSize: 16,
                    bold: true,
                    margin: [0, 0, 0, 20]
                  },
                  {
                  },
                  {
                  }
                ],
                [
                  {
                    text: 'หมายเหตุ : ใบรับรองสามารถยืนยันผลตรวจหลังจากได้รับการตรวจ ภายใน 72 ชั่วโมงเท่านั้น',
                    alignment: 'left',
                    fontSize: 16,
                    colSpan: 4,
                    bold: true,
                    decoration: 'underline',
                    margin: [0, 0, 0, 80]
                  },
                  {
                  },
                  {
                  },
                  {
                  }
                ],
                [
                  {
                    text: '',
                    fontSize: 12,
                    colSpan: 2
                  },
                  {
                  },
                  {
                    image: self.reportHd.OfficerName3Sign,
                    width: 60,
                    alignment: 'center',
                    margin: [45, 0, 0, -10],
                    fontSize: 12,
                    colSpan: 2
                  },
                  {
                  }
                ],
                [
                  {
                    text: 'ลงชื่อผู้รับการตรวจ _____________________________________ \n' +
                          '(' + self.reportHd.PrefixName + self.reportHd.PatName + ' ' + self.reportHd.PatLName + ')' +
                          '\n ผู้รับการตรวจ',
                    alignment: 'center',
                    fontSize: 12,
                    colSpan: 2
                  },
                  {

                  },
                  {
                    text: 'ลงชื่อผู้รับรองผลการตรวจ _____________________________________ \n (' + self.reportHd.OfficerName3 + ')\n ตำแหน่งนักเทคนิคการแพทย์ \n ผู้รับรองผลการตรวจ',
                    alignment: 'center',
                    fontSize: 12,
                    colSpan: 2
                  },
                  {

                  }
                ],
                [
                  {
                    text: ''
                  },
                  {
                    text: ''
                  },
                  {
                    text: ''
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            },
            layout: 'noBorders'
          }
        },
        // content: html,
        content: [
          {
            table: {
              widths: [160, 5, 120, 30, 60, '*'],
              // widths: [100, '*', 200, 10, 80, 50, '*'],
              body: [
                // ============ แถวที่ 1 ============
                [
                  { text: 'Test', bold: true, border: [false, false, false, false], fillColor: '#bfbfbf' },
                  { text: '', bold: true, border: [false, false, false, false], fillColor: '#bfbfbf' },
                  { text: 'Result', alignment: 'left', bold: true, border: [false, false, false, false], fillColor: '#bfbfbf' },
                  { text: 'Unit', bold: true, border: [false, false, false, false], fillColor: '#bfbfbf' },
                  { text: 'Method', bold: true, border: [false, false, false, false], fillColor: '#bfbfbf' },
                  { text: 'Specimen', bold: true, border: [false, false, false, false], fillColor: '#bfbfbf' }
                ],
                // ============ แถวที่ 2 ============
                [
                  { text: this.reportDtl[0].ItemTestName, margin: [0, 10, 0, 5], italics: false },
                  { text: this.arrRepeatChk[this.reportDtl[0].RepeatChecked], margin: [0, 10, 0, 5], italics: false },
                  { text: this.reportDtl[0].PrefixResult + ' ' + this.reportDtl[0].Result, margin: [0, 10, 0, 5], italics: false, color: ((this.reportDtl[0].Result.toLowerCase().indexOf('negative') === -1) ? 'red' : 'green') },
                  { text: this.reportDtl[0].Unit, margin: [0, 10, 0, 5], italics: false },
                  { text: this.reportDtl[0].Method, margin: [0, 10, 0, 5], italics: false },
                  { text: this.reportDtl[0].Specimen, margin: [0, 10, 0, 5], italics: false }
                ]
              ]
            },
            layout: {
              defaultBorder: false
            }
          }
        ],
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 16
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // ----------- (4) รูปแบบใบแสดงผลเป็นฟอร์ม A4 (ATK-4 แบบที่ 4) : คุณโต้บุรีรัมย์ ---------- //
    createPdfForm4ToScreen () {
      var PatNamePrn = this.reportHd.PatName
      var PatLNamePrn = this.reportHd.PatLName
      var PrefixNamePrn = this.reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.reportHd.PatName2
        PatLNamePrn = this.reportHd.PatLName2
        PrefixNamePrn = this.reportHd.PrefixName2
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      // const pdfTable = document.getElementById('divToPrint')
      const pdfTable = document.getElementById('divToPrint_2Col')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'LEGAL',
        // pageOrientation: 'landscape',
        pageMargins: [30, 140, 30, 300],
        header: {
          margin: [20, 20, 20, 5],
          table: {
            widths: [50, 230, 250],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 4,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 18,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                // Header ด้านขวา ใบสั่งตรวจ
                {
                  rowSpan: 4,
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '\n Sex: ' + this.arrSex[this.reportHd.Sex] +
                    '       Age: ' + this.reportHd.AgeYears + '.' + this.reportHd.AgeMonths + '.' + this.reportHd.AgeDays + ' years' +
                    '\n ID No.: ' + this.reportHd.IDNo +
                    '\n Company: ' + this.reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.reportHd.RONo + '    \nDate: ' + this.reportHd.DocDate + ' ' + this.reportHd.DocTime],
                  bold: true,
                  fontSize: 16,
                  margin: [10, 0, 0, 0],
                  lineHeight: 0.8,
                  border: [0, 0, 0, 0]
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 14,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 + ' Fax: ' + self.globalCorpInfo.fax + '\n' +
                        'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                  bold: false,
                  fontSize: 14,
                  lineHeight: 0.7,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                { },
                {
                  image: self.textToBase64Barcode(self.reportHd.RONo, 50),
                  width: 100,
                  alignment: 'left',
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                },
                { }
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [40, 10, 40, 40],
            table: {
              widths: [125, 125, 250],
              body: [
                [
                  {
                    colSpan: 3,
                    text:
                      '- สิ่งส่งตรวจ Nasopharyngeal Swab หลักการตรวจ Immunochromatography' +
                      '\n- กรณี ผลบวก (Positive) ต้องตรวจยืนยันด้วยวิธี RT-PCR' +
                      '\n- กรณี ผลลบ (Negative) หากท่านมีความเสี่ยง แนะนำให้สังเกตุอาการอยู่ที่พัก หลีกเลี่ยงที่สาธารณะ' +
                      'สวมหน้ากากอนามัย เมื่ออยู่ร่วมกับผู้อื่น หมั่นล้างมือ' +
                      '\n- หากภายใน 14 วัน มีอาการตามข้างต้น แนะนำติดต่อสถานพยาบาลตามสิทธิการรักษา',
                    fontSize: 14,
                    margin: [10, 5, 10, 0],
                    border: [0, 0, 0, 0]
                  },
                  { },
                  { }
                ],
                [
                  { },
                  { },
                  { text: 'Approved by', alignment: 'center', fontSize: 14, border: [0, 0, 0, 0] }],
                [
                  { },
                  { },
                  {
                    image: self.reportHd.OfficerName3Sign,
                    width: 60,
                    alignment: 'center',
                    border: [0, 0, 0, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                [
                  { },
                  { },
                  {
                    text: self.reportHd.OfficerName3 + '\n' + self.reportHd.ApprovedDate,
                    alignment: 'center',
                    fontSize: 14,
                    border: [0, 0, 0, 0]
                  }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: '\n\nPage-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            },
            layout: {
              defaultBorder: false
            }
          }
        },
        content: html,
        // content: { text: 'TEST' },
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 16
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // ----------- (5) รูปแบบใบแสดงผลเป็นฟอร์ม A4 (PCR-5 แบบที่ 5) : คุณโต้บุรีรัมย์ ---------- //
    createPdfForm5ToScreen () {
      var PatNamePrn = this.reportHd.PatName
      var PatLNamePrn = this.reportHd.PatLName
      var PrefixNamePrn = this.reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.reportHd.PatName2
        PatLNamePrn = this.reportHd.PatLName2
        PrefixNamePrn = this.reportHd.PrefixName2
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint_2Col')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'LEGAL',
        // pageOrientation: 'landscape',
        pageMargins: [30, 315, 20, 270],
        header: {
          margin: [20, 20, 20, 5],
          table: {
            widths: [520],
            body: [
              [
                {
                  table: {
                    widths: [120, 260, 130],
                    body: [
                      [
                        // Header ซ้าย โลโก้คลินิก
                        {
                          rowSpan: 3,
                          image: logoBase64,
                          width: 80,
                          alignment: 'center',
                          border: [0, 0, 0, 1],
                          margin: [0, 0, 0, 10]
                        },
                        // Header กลาง ชื่อคลินิก
                        {
                          colSpan: 2,
                          text: self.globalCorpInfo.name,
                          bold: true,
                          fontSize: 18,
                          lineHeight: 0.5
                        },
                        { }
                      ],
                      [
                        {},
                        {
                          colSpan: 2,
                          text: self.globalCorpInfo.name2,
                          bold: true,
                          fontSize: 14,
                          lineHeight: 0.5
                        },
                        {}
                      ],
                      [
                        {},
                        {
                          colSpan: 2,
                          text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                                self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                                'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 + ' Fax: ' + self.globalCorpInfo.fax + '\n' +
                                'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                          bold: false,
                          fontSize: 14,
                          lineHeight: 0.7,
                          border: [0, 0, 0, 1]
                        },
                        {}
                      ]
                    ]
                  },
                  layout: {
                    defaultBorder: false
                  }
                }
              ],
              [
                {
                  // Document Header : ตาราง 4 คอลัมส์
                  margin: [0, 10, 0, 0],
                  table: {
                    widths: [100, 160, 100, 140],
                    body: [
                      [
                        {
                          text: 'Name : ',
                          bold: false,
                          fontSize: 16,
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 0, 0],
                          lineHeight: 0.8
                        },
                        {
                          text: PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn,
                          bold: true,
                          fontSize: 16,
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 0, 0],
                          lineHeight: 0.8
                        },
                        {
                          text: 'Sex :',
                          bold: false,
                          fontSize: 16,
                          alignment: 'right',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 0, 0],
                          lineHeight: 0.8
                        },
                        {
                          text: this.arrSex[this.reportHd.Sex],
                          bold: true,
                          fontSize: 16,
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 0, 0],
                          lineHeight: 0.8
                        }
                      ],
                      [
                        {
                          text: 'ID No. : ',
                          bold: false,
                          fontSize: 16,
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 0, 0],
                          lineHeight: 0.8
                        },
                        {
                          text: this.reportHd.IDNo,
                          bold: true,
                          fontSize: 16,
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 0, 0],
                          lineHeight: 0.8
                        },
                        {
                          text: 'Age :',
                          bold: false,
                          fontSize: 16,
                          alignment: 'right',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 0, 0],
                          lineHeight: 0.8
                        },
                        {
                          text: this.reportHd.AgeYears + '.' + this.reportHd.AgeMonths + '.' + this.reportHd.AgeDays + ' years',
                          bold: true,
                          fontSize: 16,
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 0, 0],
                          lineHeight: 0.8
                        }
                      ],
                      [
                        {
                          text: 'Hostpital/Clinic : ',
                          bold: false,
                          fontSize: 16,
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 0, 0],
                          lineHeight: 0.8
                        },
                        {
                          colSpan: 3,
                          text: this.reportHd.ReqClinicName,
                          bold: true,
                          fontSize: 16,
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 0, 0],
                          lineHeight: 0.8
                        },
                        {
                        },
                        {
                        }
                      ],
                      [
                        {
                          text: 'LAB No : ',
                          bold: false,
                          fontSize: 16,
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 0, 0],
                          lineHeight: 0.8
                        },
                        {
                          text: this.reportHd.RONo,
                          bold: true,
                          fontSize: 16,
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 0, 0],
                          lineHeight: 0.8
                        },
                        {
                          text: 'Received Date : ',
                          bold: false,
                          fontSize: 16,
                          alignment: 'right',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 0, 0],
                          lineHeight: 0.8
                        },
                        {
                          text: this.reportHd.DocDate + ' ' + this.reportHd.DocTime,
                          bold: true,
                          fontSize: 16,
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 0, 0],
                          lineHeight: 0.8
                        }
                      ],
                      [
                        { },
                        {
                          image: self.textToBase64Barcode(self.reportHd.RONo, 70),
                          width: 120,
                          alignment: 'left',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0],
                          lineHeight: 0.8
                        },
                        { },
                        { }
                      ],
                      ['\n', {}, {}, {}],
                      [
                        {
                          text: 'Lab Diagnosis Test for SARS-CoV-2 RNA (COVID-19) by Real-time RT PCR',
                          colSpan: 4,
                          alignment: 'center',
                          fontSize: 18,
                          bold: true,
                          // fillColor: '#eeeeee',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0]
                        },
                        { },
                        { },
                        { }
                      ]
                    ]
                  },
                  layout: {
                    defaultBorder: false
                  }
                }
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [30, 10, 20, 20],
            table: {
              widths: [260, 260],
              body: [
                [
                  {
                    text: 'Remark : When N and ORF1ab genes are detected at Ct <= 40, it is interpreted and reported as "Detected", which means SARS-CoV-2 RNA is detected with the assay reagent.\n' +
                          'In case of N and ORF1ab genes are detected at Ct > 40 or No Ct value, it is interpreted and reported as "Not detected", which means SARS-CoV-2 RNA is not detected with the assay reagent.\n\n',
                    alignment: 'left',
                    fontSize: 12,
                    colSpan: 2,
                    bold: true,
                    border: [0, 0, 0, 0]
                  },
                  { }
                ],
                [
                  { text: 'Reported by', alignment: 'center', fontSize: 14, border: [1, 1, 1, 0] },
                  { text: 'Approved by', alignment: 'center', fontSize: 14, border: [0, 1, 1, 0] }
                ],
                [
                  {
                    image: self.reportHd.OfficerName2Sign,
                    width: 60,
                    alignment: 'center',
                    border: [1, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  },
                  {
                    image: self.reportHd.OfficerName3Sign,
                    width: 60,
                    alignment: 'center',
                    border: [1, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                [
                  {
                    text: self.reportHd.OfficerName2 + '\n' + self.reportHd.ResultedDate,
                    alignment: 'center',
                    fontSize: 14,
                    border: [1, 0, 1, 1]
                  },
                  {
                    text: self.reportHd.OfficerName3 + '\n' + self.reportHd.ApprovedDate,
                    alignment: 'center',
                    fontSize: 14,
                    border: [0, 0, 1, 1]
                  }
                ],
                [
                  {
                    text:
                      'The test report merely corresponds to the test sample.\n' +
                      'It is not permitted to copy extracts of these test result without the written permission of the test laboratory',
                    alignment: 'center',
                    fontSize: 12,
                    colSpan: 2,
                    bold: true,
                    lineHeight: 0.6,
                    border: [1, 0, 1, 1],
                    margin: [0, 0, 0, 8]
                  },
                  { }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 18
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // ----------- (6) รูปแบบใบแสดงผลเป็นฟอร์ม A4 (ATK-6 แบบที่ 6) : คุณหญิง วาสนาแล็บ นครศรีธรรมราช Thai Form ---------- //
    textExplainPosNeg (resultPosNeg) {
      resultPosNeg = resultPosNeg.toLowerCase().trim()
      const explains = ['ไม่พบเชื้อ', 'พบเชื้อ']
      const resultList = ['negative', 'positive']
      console.log(resultPosNeg.toLowerCase())
      console.log(resultList[1])
      console.log(resultList.indexOf(resultPosNeg.toLowerCase()))
      console.log(resultList[1] === resultPosNeg.toLowerCase())
      var explainText = (resultList.indexOf(resultPosNeg.toLowerCase()) > -1) ? explains[resultList.indexOf(resultPosNeg.toLowerCase())] : ''
      return explainText
    },
    createPdfForm6ToScreen () {
      var PatNamePrn = this.reportHd.PatName
      var PatLNamePrn = this.reportHd.PatLName
      var PrefixNamePrn = this.reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.reportHd.PatName2
        PatLNamePrn = this.reportHd.PatLName2
        PrefixNamePrn = this.reportHd.PrefixName2
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      // const pdfTable = document.getElementById('divToPrint')
      // ------- html to pdf format
      // var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'LEGAL',
        // pageOrientation: 'landscape',
        pageMargins: [30, 220, 30, 300],
        header: {
          margin: [30, 20, 30, 10],
          table: {
            widths: [130, 170, 80, 120],
            body: [
              [
                {
                  colSpan: 4,
                  // alignment: 'center',
                  // margin: [0, 20, 0, 0],
                  table: {
                    widths: [50, 230, 220],
                    body: [
                      [
                        // Header ซ้าย โลโก้คลินิก
                        {
                          rowSpan: 3,
                          image: logoBase64,
                          width: 50,
                          alignment: 'center',
                          margin: [0, 0, 0, 0]
                        },
                        // Header กลาง ชื่อคลินิก
                        {
                          text: self.globalCorpInfo.name,
                          bold: true,
                          fontSize: 18,
                          lineHeight: 0.5
                        },
                        {
                          rowSpan: 3,
                          image: self.textToBase64Barcode(self.reportHd.RONo, 60),
                          width: 180,
                          alignment: 'right',
                          margin: [0, 0, 0, 0]
                        }
                      ],
                      [
                        {},
                        {
                          text: self.globalCorpInfo.name2,
                          bold: true,
                          fontSize: 14,
                          lineHeight: 0.5
                        },
                        {}
                      ],
                      [
                        {},
                        {
                          text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                                self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                                'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 + ' Fax: ' + self.globalCorpInfo.fax + '\n' +
                                'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                          bold: false,
                          fontSize: 14,
                          lineHeight: 0.7
                        },
                        {}
                      ]
                    ]
                  },
                  layout: {
                    defaultBorder: false
                  }
                },
                {}, {}, {}
              ],
              [
                { text: 'ใบรับรองผลการตรวจโควิด-19\n Certificate of Testing for COVID-19', bold: true, style: 'tableHeader', colSpan: 4, alignment: 'center', margin: [0, 0, 0, 0] },
                {}, {}, {}
              ],
              [
                { text: 'ชื่อ นามสกุล', margin: [5, 0, 0, 0], bold: true },
                { text: PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn, margin: [5, 0, 0, 0] },
                { text: 'อายุ', margin: [5, 0, 0, 0], bold: true },
                { text: this.reportHd.AgeYears + ' ปี', margin: [5, 0, 0, 0] }
              ],
              [
                { text: 'หมายเลขบัตรประชาชน', margin: [5, 0, 0, 0], bold: true },
                { text: this.reportHd.IDNo, margin: [5, 0, 0, 0] },
                { text: 'เพศ', margin: [5, 0, 0, 0], bold: true },
                { text: this.arrSexTh[this.reportHd.Sex], margin: [5, 0, 0, 0] }
              ]
            ]
          },
          layout: {
            defaultBorder: true
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [40, 10, 40, 20],
            table: {
              // widths: [250, 250],
              widths: [125, 125, 125, 125],
              body: [
                [
                  {
                    text: 'Test Result Date :  ',
                    alignment: 'left',
                    fontSize: 16,
                    margin: [0, 0, 0, 20]
                  },
                  {
                    text: self.reportHd.ResultedDate,
                    alignment: 'left',
                    fontSize: 16,
                    bold: true,
                    margin: [0, 0, 0, 20]
                  },
                  {
                  },
                  {
                  }
                ],
                [
                  {
                    text: 'หมายเหตุ : ใบรับรองสามารถยืนยันผลตรวจหลังจากได้รับการตรวจ ภายใน 72 ชั่วโมงเท่านั้น',
                    alignment: 'left',
                    fontSize: 16,
                    colSpan: 4,
                    bold: true,
                    decoration: 'underline',
                    margin: [0, 0, 0, 80]
                  },
                  {
                  },
                  {
                  },
                  {
                  }
                ],
                [
                  {
                    text: '',
                    fontSize: 12,
                    colSpan: 2
                  },
                  {
                  },
                  {
                    image: self.reportHd.OfficerName3Sign,
                    width: 60,
                    alignment: 'center',
                    margin: [45, 0, 0, -10],
                    fontSize: 12,
                    colSpan: 2
                  },
                  {
                  }
                ],
                [
                  {
                    text: 'ลงชื่อผู้รับการตรวจ _____________________________________ \n' +
                          '(' + self.reportHd.PrefixName + self.reportHd.PatName + ' ' + self.reportHd.PatLName + ')' +
                          '\n ผู้รับการตรวจ',
                    alignment: 'center',
                    fontSize: 12,
                    colSpan: 2
                  },
                  {

                  },
                  {
                    text: 'ลงชื่อผู้รับรองผลการตรวจ _____________________________________ \n (' + self.reportHd.OfficerName3 + ')\n ตำแหน่งนักเทคนิคการแพทย์ \n ผู้รับรองผลการตรวจ',
                    alignment: 'center',
                    fontSize: 12,
                    colSpan: 2
                  },
                  {

                  }
                ],
                [
                  {
                    text: ''
                  },
                  {
                    text: ''
                  },
                  {
                    text: ''
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            },
            layout: 'noBorders'
          }
        },
        // content: html,
        content: [
          {
            table: {
              widths: [200, 5, 80, '*'],
              // widths: [100, '*', 200, 10, 80, 50, '*'],
              body: [
                // ============ แถวที่ 1 ============
                [
                  { text: 'รายการตรวจ', bold: true, border: [false, false, false, false], fillColor: '#bfbfbf' },
                  { text: '', bold: true, border: [false, false, false, false], fillColor: '#bfbfbf' },
                  { text: 'ผลการตรวจ', alignment: 'left', bold: true, border: [false, false, false, false], fillColor: '#bfbfbf' },
                  { text: 'แปลผล', bold: true, border: [false, false, false, false], fillColor: '#bfbfbf' }
                ],
                // ============ แถวที่ 2 ============
                [
                  { text: this.reportDtl[0].ItemTestName, margin: [0, 10, 0, 5], italics: false },
                  { text: this.arrRepeatChk[this.reportDtl[0].RepeatChecked], margin: [0, 10, 0, 5], italics: false },
                  { text: this.reportDtl[0].PrefixResult + ' ' + this.reportDtl[0].Result, margin: [0, 10, 0, 5], italics: false, color: ((this.reportDtl[0].Result.toLowerCase().indexOf('negative') === -1) ? 'red' : 'green') },
                  { text: this.textExplainPosNeg(this.reportDtl[0].Result), margin: [0, 10, 0, 5], italics: false }
                ]
              ]
            },
            layout: {
              defaultBorder: false
            }
          }
        ],
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 16
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // ----------- (7) รูปแบบใบแสดงผลเป็นฟอร์ม A4 (ATK-6 แบบที่ 7) : คุณหญิง วาสนาแล็บ นครศรีธรรมราช English Form ---------- //
    createPdfForm7ToScreen () {
      var PatNamePrn = this.reportHd.PatName
      var PatLNamePrn = this.reportHd.PatLName
      var PrefixNamePrn = this.reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.reportHd.PatName2
        PatLNamePrn = this.reportHd.PatLName2
        PrefixNamePrn = this.reportHd.PrefixName2
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      // const pdfTable = document.getElementById('divToPrint')
      // ------- html to pdf format
      // var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'LEGAL',
        // pageOrientation: 'landscape',
        pageMargins: [30, 200, 30, 300],
        header: {
          margin: [30, 20, 30, 10],
          table: {
            widths: [130, 170, 80, 120],
            body: [
              [
                {
                  colSpan: 4,
                  // alignment: 'center',
                  // margin: [0, 20, 0, 0],
                  table: {
                    widths: [50, 230, 220],
                    body: [
                      [
                        // Header ซ้าย โลโก้คลินิก
                        {
                          rowSpan: 3,
                          image: logoBase64,
                          width: 50,
                          alignment: 'center',
                          margin: [0, 0, 0, 0]
                        },
                        // Header กลาง ชื่อคลินิก
                        {
                          text: self.globalCorpInfo.name,
                          bold: true,
                          fontSize: 18,
                          lineHeight: 0.5
                        },
                        {
                          rowSpan: 3,
                          image: self.textToBase64Barcode(self.reportHd.RONo, 60),
                          width: 180,
                          alignment: 'right',
                          margin: [0, 0, 0, 0]
                        }
                      ],
                      [
                        {},
                        {
                          text: self.globalCorpInfo.name2,
                          bold: true,
                          fontSize: 14,
                          lineHeight: 0.5
                        },
                        {}
                      ],
                      [
                        {},
                        {
                          text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                                self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                                'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 + ' Fax: ' + self.globalCorpInfo.fax + '\n' +
                                'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                          bold: false,
                          fontSize: 14,
                          lineHeight: 0.7
                        },
                        {}
                      ]
                    ]
                  },
                  layout: {
                    defaultBorder: false
                  }
                },
                {}, {}, {}
              ],
              [
                { text: 'Certificate of Testing for COVID-19 \n', bold: true, style: 'tableHeader', colSpan: 4, alignment: 'center', margin: [0, 0, 0, 0] },
                {}, {}, {}
              ],
              [
                { text: 'Name', margin: [5, 0, 0, 0], bold: true },
                { text: PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn, margin: [5, 0, 0, 0] },
                { text: 'Age', margin: [5, 0, 0, 0], bold: true },
                { text: this.reportHd.AgeYears + ' years.', margin: [5, 0, 0, 0] }
              ],
              [
                { text: 'ID card number', margin: [5, 0, 0, 0], bold: true },
                { text: this.reportHd.IDNo, margin: [5, 0, 0, 0] },
                { text: 'Gender', margin: [5, 0, 0, 0], bold: true },
                { text: this.arrSex[this.reportHd.Sex], margin: [5, 0, 0, 0] }
              ]
            ]
          },
          layout: {
            defaultBorder: true
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [40, 10, 40, 20],
            table: {
              // widths: [250, 250],
              widths: [125, 125, 125, 125],
              body: [
                [
                  {
                    text: 'Test Result Date :  ',
                    alignment: 'left',
                    fontSize: 16,
                    margin: [0, 0, 0, 20]
                  },
                  {
                    text: self.reportHd.ResultedDate,
                    alignment: 'left',
                    fontSize: 16,
                    bold: true,
                    margin: [0, 0, 0, 20]
                  },
                  {
                  },
                  {
                  }
                ],
                [
                  {
                    text: 'Remark : The test result is valid within 72 hours.',
                    alignment: 'left',
                    fontSize: 16,
                    colSpan: 4,
                    bold: true,
                    decoration: '',
                    margin: [0, 0, 0, 80]
                  },
                  {
                  },
                  {
                  },
                  {
                  }
                ],
                [
                  {
                    text: '',
                    fontSize: 12,
                    colSpan: 2
                  },
                  {
                  },
                  {
                    image: self.reportHd.OfficerName3Sign,
                    width: 60,
                    alignment: 'center',
                    margin: [45, 0, 0, -10],
                    fontSize: 12,
                    colSpan: 2
                  },
                  {
                  }
                ],
                [
                  {
                    text: 'ลงชื่อผู้รับการตรวจ _____________________________________ \n' +
                          '(' + self.reportHd.PrefixName + self.reportHd.PatName + ' ' + self.reportHd.PatLName + ')' +
                          '\n ผู้รับการตรวจ',
                    alignment: 'center',
                    fontSize: 12,
                    colSpan: 2
                  },
                  {

                  },
                  {
                    text: 'ลงชื่อผู้รับรองผลการตรวจ _____________________________________ \n (' + self.reportHd.OfficerName3 + ')\n ตำแหน่งนักเทคนิคการแพทย์ \n ผู้รับรองผลการตรวจ',
                    alignment: 'center',
                    fontSize: 12,
                    colSpan: 2
                  },
                  {

                  }
                ],
                [
                  {
                    text: ''
                  },
                  {
                    text: ''
                  },
                  {
                    text: ''
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            },
            layout: 'noBorders'
          }
        },
        // content: html,
        content: [
          {
            table: {
              widths: [200, 5, 80, '*'],
              // widths: [100, '*', 200, 10, 80, 50, '*'],
              body: [
                // ============ แถวที่ 1 ============
                [
                  { text: 'Test', bold: true, border: [false, false, false, false], fillColor: '#bfbfbf' },
                  { text: '', bold: true, border: [false, false, false, false], fillColor: '#bfbfbf' },
                  { text: 'Result', alignment: 'left', bold: true, border: [false, false, false, false], fillColor: '#bfbfbf' },
                  { text: 'Reference', bold: true, border: [false, false, false, false], fillColor: '#bfbfbf' }
                ],
                // ============ แถวที่ 2 ============
                [
                  { text: this.reportDtl[0].ItemTestName2, margin: [0, 10, 0, 5], italics: false },
                  { text: this.arrRepeatChk[this.reportDtl[0].RepeatChecked], margin: [0, 10, 0, 5], italics: false },
                  { text: this.reportDtl[0].PrefixResult + ' ' + this.reportDtl[0].Result, margin: [0, 10, 0, 5], italics: false, color: ((this.reportDtl[0].Result.toLowerCase().indexOf('negative') === -1) ? 'red' : 'green') },
                  { text: this.reportDtl[0].NormalValue, margin: [0, 10, 0, 5], italics: false }
                ]
              ]
            },
            layout: {
              defaultBorder: false
            }
          }
        ],
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 16
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // ----------- (I.) รูปแบบใบแสดงผลเป็นฟอร์ม A5 (General) => COLS : Method/Specimen/NormalValue ---------- //
    createA5PdfForm1ToScreen () {
      var subHeader = ''
      var pageMarginsTop = 98
      if (this._vitalSignText !== '') {
        pageMarginsTop = pageMarginsTop + 16 // บรรทัดที่แรก บวก 16 pixels
        subHeader = subHeader + 'Vital signs: ' + this._vitalSignText
        if (this.A5reportHd.Specimen !== '') {
          pageMarginsTop = pageMarginsTop + 10 // บรรทัดที่สอง บวกแค่ 10 pixels
          subHeader = subHeader + '\n Specimens : ' + this.A5reportHd.Specimen
        }
      } else if (this.A5reportHd.Specimen !== '') {
        pageMarginsTop = pageMarginsTop + 16
        subHeader = subHeader + 'Specimens : ' + this.A5reportHd.Specimen
      }
      //  ---------------------------------- //
      var PatNamePrn = this.A5reportHd.PatName
      var PatLNamePrn = this.A5reportHd.PatLName
      var PrefixNamePrn = this.A5reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.A5reportHd.PatName2
        PatLNamePrn = this.A5reportHd.PatLName2
        PrefixNamePrn = this.A5reportHd.PrefixName2
      }

      var DOBPrn = ''
      if (this.optDOB) {
        DOBPrn = '  DOB: ' + this.A5reportHd.BirthDate
      }
      // ==================================== //
      // ข้อความลายน้ำชื่อคลินิก
      var strWatermark = ''
      var colorWatermark = 'gray'
      if (this.A5reportHd.Cancel === 1 || this.A5reportHd.Cancel === '1') {
        strWatermark = 'ยกเลิก CANCELED'
        colorWatermark = 'red'
      } else {
        if (this.optWatermark) {
          strWatermark = this.globalCorpInfo.name + ' '
        }
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint_MasterDtl')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        pageSize: 'A5',
        pageOrientation: 'landscape',
        pageMargins: [20, pageMarginsTop, 20, 100],
        watermark: { text: strWatermark, color: colorWatermark, opacity: 0.2, bold: true, italics: true },
        header: {
          margin: [20, 10, 20, 5],
          table: {
            widths: [50, 230, 250],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 4,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 16,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                // Header ด้านขวา ใบสั่งตรวจ
                {
                  rowSpan: 4,
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '\n Sex: ' + this.arrSex[this.A5reportHd.Sex] +
                    '  Age: ' + this.A5reportHd.AgeYears + '.' + this.A5reportHd.AgeMonths + '.' + this.A5reportHd.AgeDays + ' years' +
                    DOBPrn +
                    (this.A5reportHd.IDNo === '' ? '' : '\n ID No.: ' + this.A5reportHd.IDNo) +
                    (this.A5reportHd.HNNo === '' ? '' : ' HN : ' + this.A5reportHd.HNNo) +
                    (this.A5reportHd.PassportNo === '' ? '' : '\n Passport No.: ' + this.A5reportHd.PassportNo) +
                    (this.A5reportHd.Country === '' ? '' : ' / ' + this.A5reportHd.Country) +
                    '\n Clinic: ' + this.A5reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.A5reportHd.RONo + '    Date: ' + this.A5reportHd.DocDate + ' ' + this.A5reportHd.DocTime],
                  bold: true,
                  fontSize: 14,
                  margin: [10, 0, 0, 0],
                  lineHeight: 0.7,
                  border: [0, 0, 0, 0]
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 12,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 +
                        (self.globalCorpInfo.fax !== '' ? ' Fax: ' + self.globalCorpInfo.fax : '') + '\n' +
                        'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                { },
                {
                  image: self.textToBase64Barcode(self.A5reportHd.RONo, 35),
                  width: 100,
                  alignment: 'left',
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                },
                { }
              ],
              [
                {
                  colSpan: 3,
                  text: subHeader,
                  alignment: 'right',
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: (subHeader === '' ? '#FFFFFF' : '#DCDCDC')
                },
                {},
                {}
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [20, 0, 20, 5],
            table: {
              widths: [220, 150, 150],
              body: [
                [
                  {
                    rowSpan: 3,
                    text: 'L=Result below reference interval\n H=Result above reference interval\n R=Repeat\n' +
                          'This report only certifies samples that have been analyzed. Do not copy the report only partialy ' +
                          'without permission from labaratory Writer',
                    fontSize: 11
                  },
                  { text: 'Reported by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] },
                  { text: 'Approved by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] }],
                ['',
                  {
                    image: self.A5reportHd.OfficerName2Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  },
                  {
                    image: self.A5reportHd.OfficerName3Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                ['',
                  {
                    text: self.A5reportHd.OfficerName2 + '\n' + self.A5reportHd.ResultedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  },
                  {
                    text: self.A5reportHd.OfficerName3 + '\n' + self.A5reportHd.ApprovedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 14,
          lineHeight: 0.6
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // ----------- (II.) รูปแบบใบแสดงผลเป็นฟอร์ม A5 => COLS : NormalValue ---------- //
    createA5PdfForm2ToScreen () {
      var subHeader = ''
      var pageMarginsTop = 98
      if (this._vitalSignText !== '') {
        pageMarginsTop = pageMarginsTop + 16 // บรรทัดที่แรก บวก 16 pixels
        subHeader = subHeader + 'Vital signs: ' + this._vitalSignText
        if (this.A5reportHd.Specimen !== '') {
          pageMarginsTop = pageMarginsTop + 10 // บรรทัดที่สอง บวกแค่ 10 pixels
          subHeader = subHeader + '\n Specimens : ' + this.A5reportHd.Specimen
        }
      } else if (this.A5reportHd.Specimen !== '') {
        pageMarginsTop = pageMarginsTop + 16
        subHeader = subHeader + 'Specimens : ' + this.A5reportHd.Specimen
      }
      //  ---------------------------------- //
      var PatNamePrn = this.A5reportHd.PatName
      var PatLNamePrn = this.A5reportHd.PatLName
      var PrefixNamePrn = this.A5reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.A5reportHd.PatName2
        PatLNamePrn = this.A5reportHd.PatLName2
        PrefixNamePrn = this.A5reportHd.PrefixName2
      }

      var DOBPrn = ''
      if (this.optDOB) {
        DOBPrn = '  DOB: ' + this.A5reportHd.BirthDate
      }
      // ==================================== //
      // ข้อความลายน้ำชื่อคลินิก
      var strWatermark = ''
      var colorWatermark = 'gray'
      if (this.A5reportHd.Cancel === 1 || this.A5reportHd.Cancel === '1') {
        strWatermark = 'ยกเลิก CANCELED'
        colorWatermark = 'red'
      } else {
        if (this.optWatermark) {
          strWatermark = this.globalCorpInfo.name + ' '
        }
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html : formA5Idx=2 => divToPrint_MasterDtl2
      const pdfTable = document.getElementById('divToPrint_MasterDtl1')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        pageSize: 'A5',
        pageOrientation: 'landscape',
        pageMargins: [20, pageMarginsTop, 20, 100],
        watermark: { text: strWatermark, color: colorWatermark, opacity: 0.2, bold: true, italics: true },
        header: {
          margin: [20, 10, 20, 5],
          table: {
            widths: [50, 230, 250],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 4,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 16,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                // Header ด้านขวา ใบสั่งตรวจ
                {
                  rowSpan: 4,
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '\n Sex: ' + this.arrSex[this.A5reportHd.Sex] +
                    '  Age: ' + this.A5reportHd.AgeYears + '.' + this.A5reportHd.AgeMonths + '.' + this.A5reportHd.AgeDays + ' years' +
                    DOBPrn +
                    (this.A5reportHd.IDNo === '' ? '' : '\n ID No.: ' + this.A5reportHd.IDNo) +
                    (this.A5reportHd.HNNo === '' ? '' : ' HN : ' + this.A5reportHd.HNNo) +
                    (this.A5reportHd.PassportNo === '' ? '' : '\n Passport No.: ' + this.A5reportHd.PassportNo) +
                    (this.A5reportHd.Country === '' ? '' : ' / ' + this.A5reportHd.Country) +
                    '\n Clinic: ' + this.A5reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.A5reportHd.RONo + '    Date: ' + this.A5reportHd.DocDate + ' ' + this.A5reportHd.DocTime],
                  bold: true,
                  fontSize: 14,
                  margin: [10, 0, 0, 0],
                  lineHeight: 0.7,
                  border: [0, 0, 0, 0]
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 12,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 +
                        (self.globalCorpInfo.fax !== '' ? ' Fax: ' + self.globalCorpInfo.fax : '') + '\n' +
                        'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                { },
                {
                  image: self.textToBase64Barcode(self.A5reportHd.RONo, 35),
                  width: 100,
                  alignment: 'left',
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                },
                { }
              ],
              [
                {
                  colSpan: 3,
                  text: subHeader,
                  alignment: 'right',
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: (subHeader === '' ? '#FFFFFF' : '#DCDCDC')
                },
                {},
                {}
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [20, 0, 20, 5],
            table: {
              widths: [220, 150, 150],
              body: [
                [
                  {
                    rowSpan: 3,
                    text: 'L=Result below reference interval\n H=Result above reference interval\n R=Repeat\n' +
                          'This report only certifies samples that have been analyzed. Do not copy the report only partialy ' +
                          'without permission from labaratory Writer',
                    fontSize: 11
                  },
                  { text: 'Reported by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] },
                  { text: 'Approved by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] }],
                ['',
                  {
                    image: self.A5reportHd.OfficerName2Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  },
                  {
                    image: self.A5reportHd.OfficerName3Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                ['',
                  {
                    text: self.A5reportHd.OfficerName2 + '\n' + self.A5reportHd.ResultedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  },
                  {
                    text: self.A5reportHd.OfficerName3 + '\n' + self.A5reportHd.ApprovedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 14,
          lineHeight: 0.6
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },

    // ----------- (NEW A5-1, A5-2) รูปแบบใบแสดงผลเป็นฟอร์ม A5 (แนวนอน) ---------- //
    //   09.05.2567 : ฟอร์ม A5-Lanscape / classic-Footer
    createNewA5PdfFormToScreen_Landscape_ClassicFooter () {
      var subHeader = ''
      var pageMarginsTop = 98
      if (this._vitalSignText !== '') {
        pageMarginsTop = pageMarginsTop + 16 // บรรทัดที่แรก บวก 16 pixels
        subHeader = subHeader + 'Vital signs: ' + this._vitalSignText
        if (this.A5reportHd.Specimen !== '') {
          pageMarginsTop = pageMarginsTop + 10 // บรรทัดที่สอง บวกแค่ 10 pixels
          subHeader = subHeader + '\n Specimens : ' + this.A5reportHd.Specimen
        }
      } else if (this.A5reportHd.Specimen !== '') {
        pageMarginsTop = pageMarginsTop + 16
        subHeader = subHeader + 'Specimens : ' + this.A5reportHd.Specimen
      }
      //  ---------------------------------- //
      var PatNamePrn = this.A5reportHd.PatName
      var PatLNamePrn = this.A5reportHd.PatLName
      var PrefixNamePrn = this.A5reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.A5reportHd.PatName2
        PatLNamePrn = this.A5reportHd.PatLName2
        PrefixNamePrn = this.A5reportHd.PrefixName2
      }

      var DOBPrn = ''
      if (this.optDOB) {
        DOBPrn = '  DOB: ' + this.A5reportHd.BirthDate
      }
      // ==================================== //
      // ข้อความลายน้ำชื่อคลินิก
      var strWatermark = ''
      var colorWatermark = 'gray'
      if (this.A5reportHd.Cancel === 1 || this.A5reportHd.Cancel === '1') {
        strWatermark = 'ยกเลิก CANCELED'
        colorWatermark = 'red'
      } else {
        if (this.optWatermark) {
          strWatermark = this.globalCorpInfo.name + ' '
        }
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint_MasterDtlA5_1New')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        pageSize: 'A5',
        pageOrientation: 'landscape',
        pageMargins: [20, pageMarginsTop, 20, 100],
        watermark: { text: strWatermark, color: colorWatermark, opacity: 0.2, bold: true, italics: true },
        header: {
          margin: [20, 10, 20, 5],
          table: {
            widths: [50, 230, 250],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 4,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 16,
                  margin: [0, 0, 0, 0],
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                // ข้อมูลหัวใบสั่งตรวจ
                {
                  rowSpan: 4,
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '\n Sex: ' + this.arrSex[this.A5reportHd.Sex] +
                    '  Age: ' + this.A5reportHd.AgeYears + '.' + this.A5reportHd.AgeMonths + '.' + this.A5reportHd.AgeDays + ' years' +
                    DOBPrn +
                    (this.A5reportHd.IDNo === '' ? '' : '\n ID No.: ' + this.A5reportHd.IDNo) +
                    (this.A5reportHd.HNNo === '' ? '' : ' HN : ' + this.A5reportHd.HNNo) +
                    (this.A5reportHd.PassportNo === '' ? '' : '\n Passport No.: ' + this.A5reportHd.PassportNo) +
                    (this.A5reportHd.Country === '' ? '' : ' / ' + this.A5reportHd.Country) +
                    '\n Clinic: ' + this.A5reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.A5reportHd.RONo + '    Date: ' + this.A5reportHd.DocDate + ' ' + this.A5reportHd.DocTime],
                  // bold: false,
                  // fontSize: 9,
                  // lineHeight: 0.8,
                  bold: true,
                  fontSize: 14,
                  lineHeight: 0.7,
                  margin: [10, 0, 0, 0],
                  border: [0, 0, 0, 0]
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 12,
                  margin: [0, 0, 0, 0],
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 +
                        (self.globalCorpInfo.fax !== '' ? ' Fax: ' + self.globalCorpInfo.fax : '') +
                        (self.globalCorpInfo.email1 !== '' ? '\n Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2 : ''),
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                { },
                {
                  image: self.textToBase64Barcode(self.A5reportHd.RONo, 35),
                  width: 100,
                  alignment: 'left',
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                },
                { }
              ],
              [
                {
                  colSpan: 3,
                  text: subHeader,
                  alignment: 'right',
                  fontSize: 12,
                  lineHeight: 0.7
                  // fillColor: (subHeader === '' ? '#FFFFFF' : '#DCDCDC')
                },
                {},
                {}
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [20, 0, 20, 5],
            table: {
              widths: [220, 150, 150],
              body: [
                [
                  {
                    rowSpan: 3,
                    text: 'L=Result below reference interval\n H=Result above reference interval\n R=Repeat\n' +
                          'This report only certifies samples that have been analyzed. Do not copy the report only partialy ' +
                          'without permission from labaratory Writer',
                    fontSize: 11
                  },
                  { text: 'Reported by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] },
                  { text: 'Approved by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] }],
                ['',
                  {
                    image: self.A5reportHd.OfficerName2Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  },
                  {
                    image: self.A5reportHd.OfficerName3Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                ['',
                  {
                    text: self.A5reportHd.OfficerName2 + '\n' + self.A5reportHd.ResultedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  },
                  {
                    text: self.A5reportHd.OfficerName3 + '\n' + self.A5reportHd.ApprovedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'PromptTH' 'Roboto' 'THSarabunNew'
          // font: 'Prompt',
          // fontSize: 10,
          // lineHeight: 0.6
          font: 'THSarabunNew',
          fontSize: 14,
          lineHeight: 0.6
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // ----------- (NEW A5-3) รูปแบบใบแสดงผลเป็นฟอร์ม A5 (แนวนอน) => COLS : Ref. ---------- //
    //   09.05.2567 : ฟอร์ม A5-Lanscape / sm-Footer
    createNewA5PdfFormToScreen_Landscape () {
      var subHeader = ''
      var pageMarginsTop = 98
      if (this._vitalSignText !== '') {
        pageMarginsTop = pageMarginsTop + 16 // บรรทัดที่แรก บวก 16 pixels
        subHeader = subHeader + 'Vital signs: ' + this._vitalSignText
        if (this.A5reportHd.Specimen !== '') {
          pageMarginsTop = pageMarginsTop + 10 // บรรทัดที่สอง บวกแค่ 10 pixels
          subHeader = subHeader + '\n Specimens : ' + this.A5reportHd.Specimen
        }
      } else if (this.A5reportHd.Specimen !== '') {
        pageMarginsTop = pageMarginsTop + 16
        subHeader = subHeader + 'Specimens : ' + this.A5reportHd.Specimen
      }
      //  ---------------------------------- //
      var PatNamePrn = this.A5reportHd.PatName
      var PatLNamePrn = this.A5reportHd.PatLName
      var PrefixNamePrn = this.A5reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.A5reportHd.PatName2
        PatLNamePrn = this.A5reportHd.PatLName2
        PrefixNamePrn = this.A5reportHd.PrefixName2
      }

      var DOBPrn = ''
      if (this.optDOB) {
        DOBPrn = '  DOB: ' + this.A5reportHd.BirthDate
      }
      // ==================================== //
      // ข้อความลายน้ำชื่อคลินิก
      var strWatermark = ''
      var colorWatermark = 'gray'
      if (this.A5reportHd.Cancel === 1 || this.A5reportHd.Cancel === '1') {
        strWatermark = 'ยกเลิก CANCELED'
        colorWatermark = 'red'
      } else {
        if (this.optWatermark) {
          strWatermark = this.globalCorpInfo.name + ' '
        }
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint_MasterDtlA5_1New')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        pageSize: 'A5',
        pageOrientation: 'landscape',
        pageMargins: [20, pageMarginsTop, 20, 40],
        watermark: { text: strWatermark, color: colorWatermark, opacity: 0.2, bold: true, italics: true },
        header: {
          margin: [20, 10, 20, 5],
          table: {
            widths: [50, 230, 250],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 4,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 16,
                  margin: [0, 0, 0, 0],
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                // ข้อมูลหัวใบสั่งตรวจ
                {
                  rowSpan: 4,
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '\n Sex: ' + this.arrSex[this.A5reportHd.Sex] +
                    '  Age: ' + this.A5reportHd.AgeYears + '.' + this.A5reportHd.AgeMonths + '.' + this.A5reportHd.AgeDays + ' years' +
                    DOBPrn +
                    (this.A5reportHd.IDNo === '' ? '' : '\n ID No.: ' + this.A5reportHd.IDNo) +
                    (this.A5reportHd.HNNo === '' ? '' : ' HN : ' + this.A5reportHd.HNNo) +
                    (this.A5reportHd.PassportNo === '' ? '' : '\n Passport No.: ' + this.A5reportHd.PassportNo) +
                    (this.A5reportHd.Country === '' ? '' : ' / ' + this.A5reportHd.Country) +
                    '\n Clinic: ' + this.A5reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.A5reportHd.RONo + '    Date: ' + this.A5reportHd.DocDate + ' ' + this.A5reportHd.DocTime],
                  // bold: false,
                  // fontSize: 9,
                  // lineHeight: 0.8,
                  bold: true,
                  fontSize: 14,
                  lineHeight: 0.7,
                  margin: [10, 0, 0, 0],
                  border: [0, 0, 0, 0]
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 12,
                  margin: [0, 0, 0, 0],
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 +
                        (self.globalCorpInfo.fax !== '' ? ' Fax: ' + self.globalCorpInfo.fax : '') +
                        (self.globalCorpInfo.email1 !== '' ? '\n Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2 : ''),
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                { },
                {
                  image: self.textToBase64Barcode(self.A5reportHd.RONo, 35),
                  width: 100,
                  alignment: 'left',
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                },
                { }
              ],
              [
                {
                  colSpan: 3,
                  text: subHeader,
                  alignment: 'right',
                  fontSize: 12,
                  lineHeight: 0.7
                  // fillColor: (subHeader === '' ? '#FFFFFF' : '#DCDCDC')
                },
                {},
                {}
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [20, 0, 20, 0],
            table: {
              widths: [200, 60, 200, 60],
              body: [
                [
                  {
                    // colSpan: 2,
                    text: 'Reported by : ' + self.A5reportHd.OfficerName2 + '\n(' + self.A5reportHd.ResultedDate + ')',
                    alignment: 'center',
                    font: 'THSarabunNew',
                    fontSize: 11,
                    lineHeight: 0.5,
                    bold: false,
                    // fillColor: '#eeeeee',
                    border: [0, 1, 0, 0]
                  },
                  {
                    // colSpan: 2,
                    image: self.A5reportHd.OfficerName2Sign,
                    width: 25,
                    // height: 20,
                    alignment: 'center',
                    lineHeight: 0,
                    border: [0, 1, 0, 0],
                    margin: [0, 0, 0, 0]
                  },
                  {
                    // colSpan: 2,
                    text: 'Approved by : ' + self.A5reportHd.OfficerName3 + '\n(' + self.A5reportHd.ApprovedDate + ')',
                    alignment: 'center',
                    font: 'THSarabunNew',
                    fontSize: 11,
                    lineHeight: 0.5,
                    bold: false,
                    // fillColor: '#eeeeee',
                    border: [0, 1, 0, 0]
                  },
                  {
                    // colSpan: 2,
                    image: self.A5reportHd.OfficerName3Sign,
                    width: 25,
                    // height: 20,
                    alignment: 'center',
                    lineHeight: 0,
                    border: [0, 1, 0, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                [
                  {
                    colSpan: 3,
                    text: 'L=Result below reference interval, H=Result above reference interval, R=Repeat',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 7,
                    lineHeight: 0.3,
                    margin: [0, -5, 0, 0]
                  }, '', '',
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 7,
                    lineHeight: 0.3,
                    margin: [0, -5, 0, 0]
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'PromptTH' 'Roboto' 'THSarabunNew'
          // font: 'Prompt',
          // fontSize: 10,
          // lineHeight: 0.6
          font: 'THSarabunNew',
          fontSize: 14,
          lineHeight: 0.6
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // ----------- (NEW A5-4P) รูปแบบใบแสดงผลเป็นฟอร์ม A5 (แนวตั้ง) => COLS : Ref. ---------- //
    //   09.05.2567 : ฟอร์ม A5-Portrait / sm-Footer
    createNewA5PdfFormToScreen_Portrait () {
      // var pageMarginsTop = 140
      // if (this._vitalSignText === '') { pageMarginsTop = 125 }
      var subHeader = ''
      var pageMarginsTop = 130
      if (this._vitalSignText !== '') {
        pageMarginsTop = pageMarginsTop + 16 // บรรทัดที่แรก บวก 16 pixels
        subHeader = subHeader + 'Vital signs: ' + this._vitalSignText
        if (this.A5reportHd.Specimen !== '') {
          pageMarginsTop = pageMarginsTop + 10 // บรรทัดที่สอง บวกแค่ 10 pixels
          subHeader = subHeader + '\n Specimens : ' + this.A5reportHd.Specimen
        }
      } else if (this.A5reportHd.Specimen !== '') {
        pageMarginsTop = pageMarginsTop + 16
        subHeader = subHeader + 'Specimens : ' + this.A5reportHd.Specimen
      }
      //  ---------------------------------- //
      var PatNamePrn = this.A5reportHd.PatName
      var PatLNamePrn = this.A5reportHd.PatLName
      var PrefixNamePrn = this.A5reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.A5reportHd.PatName2
        PatLNamePrn = this.A5reportHd.PatLName2
        PrefixNamePrn = this.A5reportHd.PrefixName2
      }

      var DOBPrn = ''
      if (this.optDOB) {
        DOBPrn = '  DOB: ' + this.A5reportHd.BirthDate
      }
      // ==================================== //
      // ข้อความลายน้ำชื่อคลินิก
      var strWatermark = ''
      var colorWatermark = 'gray'
      if (this.A5reportHd.Cancel === 1 || this.A5reportHd.Cancel === '1') {
        strWatermark = 'ยกเลิก CANCELED'
        colorWatermark = 'red'
      } else {
        if (this.optWatermark) {
          strWatermark = this.globalCorpInfo.name + ' '
        }
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint_MasterDtlA5_1New')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        pageSize: 'A5',
        // pageOrientation: 'landscape',
        pageMargins: [20, pageMarginsTop, 20, 60],
        watermark: { text: strWatermark, color: colorWatermark, opacity: 0.2, bold: true, italics: true },
        header: {
          margin: [10, 10, 10, 5],
          table: {
            widths: [50, 220, 100],
            body: [
              // บรรทัดแรก
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 3,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  colSpan: 2,
                  fontSize: 16,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                }, {}
              ],
              // บรรทัดสอง
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  colSpan: 2,
                  fontSize: 12,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                }, {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 +
                        (self.globalCorpInfo.fax !== '' ? ' Fax: ' + self.globalCorpInfo.fax : '') +
                        (self.globalCorpInfo.email1 !== '' ? ' Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2 : ''),
                  bold: false,
                  colSpan: 2,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#eeeeee'
                }, {}
              ],
              // ข้อมูลใบสั่งตรวจ
              [
                {
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '  Sex: ' + this.arrSex[this.A5reportHd.Sex] +
                    '\n Age: ' + this.A5reportHd.AgeYears + '.' + this.A5reportHd.AgeMonths + '.' + this.A5reportHd.AgeDays + ' years' +
                    DOBPrn +
                    (this.A5reportHd.IDNo === '' ? '' : '\n ID No.: ' + this.A5reportHd.IDNo) +
                    (this.A5reportHd.HNNo === '' ? '' : ' HN : ' + this.A5reportHd.HNNo) +
                    (this.A5reportHd.PassportNo === '' ? '' : ' Passport No.: ' + this.A5reportHd.PassportNo) +
                    (this.A5reportHd.Country === '' ? '' : ' / ' + this.A5reportHd.Country) +
                    '\n Clinic: ' + this.A5reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.A5reportHd.RONo + '    Date: ' + this.A5reportHd.DocDate + ' ' + this.A5reportHd.DocTime],
                  colSpan: 2,
                  // bold: false,
                  // fontSize: 8,
                  // lineHeight: 0.8,
                  bold: true,
                  fontSize: 12,
                  lineHeight: 0.6,
                  // fillColor: '#DCDCCC',
                  margin: [5, 0, 0, 0],
                  border: [0, 0, 0, 0]
                }, {},
                { // Barcode เลขที่เอกสาร
                  image: self.textToBase64Barcode(self.A5reportHd.RONo, 35),
                  width: 100,
                  // fillColor: '#DCDCCC',
                  alignment: 'left',
                  lineHeight: 0.8,
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                }
              ],
              [
                {
                  colSpan: 3,
                  text: subHeader,
                  alignment: 'right',
                  fontSize: 12,
                  lineHeight: 0.7
                  // fillColor: (subHeader === '' ? '#FFFFFF' : '#DCDCDC')
                },
                {},
                {}
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [10, 0, 10, 0],
            table: {
              widths: [120, 60, 120, 60],
              body: [
                // บรรทัดแรก
                [
                  {
                    colSpan: 2,
                    image: self.A5reportHd.OfficerName2Sign,
                    width: 20,
                    // height: 20,
                    alignment: 'center',
                    lineHeight: 0,
                    border: [0, 1, 0, 0],
                    margin: [0, 0, 0, 0]
                  }, {},
                  {
                    colSpan: 2,
                    image: self.A5reportHd.OfficerName3Sign,
                    width: 20,
                    // height: 20,
                    alignment: 'center',
                    lineHeight: 0,
                    border: [0, 1, 0, 0],
                    margin: [0, 0, 0, 0]
                  }, {}
                ],
                // บรรทัดสอง
                [
                  {
                    colSpan: 2,
                    text: 'Reported by : ' + self.A5reportHd.OfficerName2 + '\n(' + self.A5reportHd.ResultedDate + ')',
                    alignment: 'center',
                    font: 'THSarabunNew',
                    fontSize: 11,
                    lineHeight: 0.5,
                    bold: false,
                    // fillColor: '#eeeeee',
                    border: [0, 0, 0, 0]
                  }, {},
                  {
                    colSpan: 2,
                    text: 'Approved by : ' + self.A5reportHd.OfficerName3 + '\n(' + self.A5reportHd.ApprovedDate + ')',
                    alignment: 'center',
                    font: 'THSarabunNew',
                    fontSize: 11,
                    lineHeight: 0.5,
                    bold: false,
                    // fillColor: '#eeeeee',
                    border: [0, 0, 0, 0]
                  }, {}
                ],
                [
                  {
                    colSpan: 3,
                    text: 'L=Result below reference interval, H=Result above reference interval, R=Repeat',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 7,
                    lineHeight: 0.4,
                    margin: [0, -5, 0, 0]
                  }, '', '',
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 7,
                    lineHeight: 0.4,
                    margin: [0, -5, 0, 0]
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          // font: 'THPrompt',
          // fontSize: 10,
          // lineHeight: 0.6
          font: 'THSarabunNew',
          fontSize: 14,
          lineHeight: 0.6
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition).open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },

    // ----------- (NEW III.) รูปแบบใบแสดงผลเป็นฟอร์ม A4 (แนวตั้ง) => COLS : ใช้รวมทุกฟอร์ม ---------- //
    //   26.04.2567 : ใช้รวมทุกฟอร์ม
    createNewA4PdfFormToScreen () {
      var subHeader = ''
      var pageMarginsTop = 110
      if (this._vitalSignText !== '') {
        pageMarginsTop = pageMarginsTop + 16 // บรรทัดที่แรก บวก 16 pixels
        subHeader = subHeader + 'Vital signs: ' + this._vitalSignText
        if (this.A5reportHd.Specimen !== '') {
          pageMarginsTop = pageMarginsTop + 10 // บรรทัดที่สอง บวกแค่ 10 pixels
          subHeader = subHeader + '\n Specimens : ' + this.A5reportHd.Specimen
        }
      } else if (this.A5reportHd.Specimen !== '') {
        pageMarginsTop = pageMarginsTop + 16
        subHeader = subHeader + 'Specimens : ' + this.A5reportHd.Specimen
      }
      //  ---------------------------------- //
      var PatNamePrn = this.A5reportHd.PatName
      var PatLNamePrn = this.A5reportHd.PatLName
      var PrefixNamePrn = this.A5reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.A5reportHd.PatName2
        PatLNamePrn = this.A5reportHd.PatLName2
        PrefixNamePrn = this.A5reportHd.PrefixName2
      }

      var DOBPrn = ''
      if (this.optDOB) {
        DOBPrn = '  DOB: ' + this.A5reportHd.BirthDate
      }
      // ==================================== //
      // ข้อความลายน้ำชื่อคลินิก
      var strWatermark = ''
      var colorWatermark = 'gray'
      if (this.A5reportHd.Cancel === 1 || this.A5reportHd.Cancel === '1') {
        strWatermark = 'ยกเลิก CANCELED'
        colorWatermark = 'red'
      } else {
        if (this.optWatermark) {
          strWatermark = this.globalCorpInfo.name + ' '
        }
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint_MasterDtlA4_1New')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        pageSize: 'A4',
        // pageOrientation: 'landscape',
        pageMargins: [20, pageMarginsTop, 20, 100],
        watermark: { text: strWatermark, color: colorWatermark, opacity: 0.2, bold: true, italics: true },
        header: {
          margin: [20, 10, 20, 5],
          table: {
            widths: [50, 230, 250],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 4,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 16,
                  margin: [0, 0, 0, 0],
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                // ข้อมูลหัวใบสั่งตรวจ
                {
                  rowSpan: 4,
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '\n Sex: ' + this.arrSex[this.A5reportHd.Sex] +
                    '  Age: ' + this.A5reportHd.AgeYears + '.' + this.A5reportHd.AgeMonths + '.' + this.A5reportHd.AgeDays + ' years' +
                    DOBPrn +
                    (this.A5reportHd.IDNo === '' ? '' : '\n ID No.: ' + this.A5reportHd.IDNo) +
                    (this.A5reportHd.HNNo === '' ? '' : ' HN : ' + this.A5reportHd.HNNo) +
                    (this.A5reportHd.PassportNo === '' ? '' : '\n Passport No.: ' + this.A5reportHd.PassportNo) +
                    (this.A5reportHd.Country === '' ? '' : ' / ' + this.A5reportHd.Country) +
                    '\n Clinic: ' + this.A5reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.A5reportHd.RONo + '    Date: ' + this.A5reportHd.DocDate + ' ' + this.A5reportHd.DocTime],
                  // bold: false,
                  // fontSize: 9,
                  // lineHeight: 0.8,
                  bold: true,
                  fontSize: 14,
                  lineHeight: 0.7,
                  margin: [10, 0, 0, 0],
                  border: [0, 0, 0, 0]
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 12,
                  margin: [0, 0, 0, 0],
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 +
                        (self.globalCorpInfo.fax !== '' ? ' Fax: ' + self.globalCorpInfo.fax : '') +
                        (self.globalCorpInfo.email1 !== '' ? '\n Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2 : ''),
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                { },
                {
                  image: self.textToBase64Barcode(self.A5reportHd.RONo, 35),
                  width: 100,
                  alignment: 'left',
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                },
                { }
              ],
              [
                {
                  colSpan: 3,
                  text: subHeader,
                  alignment: 'right',
                  fontSize: 12,
                  lineHeight: 0.7
                  // fillColor: (subHeader === '' ? '#FFFFFF' : '#DCDCDC')
                },
                {},
                {}
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [20, 0, 20, 5],
            table: {
              widths: [220, 150, 150],
              body: [
                [
                  {
                    rowSpan: 3,
                    text: 'L=Result below reference interval\n H=Result above reference interval\n R=Repeat\n' +
                          'This report only certifies samples that have been analyzed. Do not copy the report only partialy ' +
                          'without permission from labaratory Writer',
                    fontSize: 11
                  },
                  { text: 'Reported by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] },
                  { text: 'Approved by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] }],
                ['',
                  {
                    image: self.A5reportHd.OfficerName2Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  },
                  {
                    image: self.A5reportHd.OfficerName3Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                ['',
                  {
                    text: self.A5reportHd.OfficerName2 + '\n' + self.A5reportHd.ResultedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  },
                  {
                    text: self.A5reportHd.OfficerName3 + '\n' + self.A5reportHd.ApprovedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'PromptTH' 'Roboto' 'THSarabunNew'
          // font: 'Prompt',
          // fontSize: 10,
          // lineHeight: 0.6
          font: 'THSarabunNew',
          fontSize: 15,
          lineHeight: 0.7
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // ----------- (III.) รูปแบบใบแสดงผลเป็นฟอร์ม A4 => COLS : NormalValue ---------- //
    createA4PdfForm3ToScreen () {
      var pageMarginsTop = 125
      if (this._vitalSignText === '') { pageMarginsTop = 110 }
      //  ---------------------------------- //
      var PatNamePrn = this.A5reportHd.PatName
      var PatLNamePrn = this.A5reportHd.PatLName
      var PrefixNamePrn = this.A5reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.A5reportHd.PatName2
        PatLNamePrn = this.A5reportHd.PatLName2
        PrefixNamePrn = this.A5reportHd.PrefixName2
      }

      var DOBPrn = ''
      if (this.optDOB) {
        DOBPrn = '  DOB: ' + this.A5reportHd.BirthDate
      }
      // ==================================== //
      // ข้อความลายน้ำชื่อคลินิก
      var strWatermark = ''
      var colorWatermark = 'gray'
      if (this.A5reportHd.Cancel === 1 || this.A5reportHd.Cancel === '1') {
        strWatermark = 'ยกเลิก CANCELED'
        colorWatermark = 'red'
      } else {
        if (this.optWatermark) {
          strWatermark = this.globalCorpInfo.name + ' '
        }
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html : formA5Idx=2 => divToPrint_MasterDtl2
      const pdfTable = document.getElementById('divToPrint_MasterDtl2')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        pageSize: 'A4',
        // pageOrientation: 'landscape',
        pageMargins: [20, pageMarginsTop, 20, 100],
        watermark: { text: strWatermark, color: colorWatermark, opacity: 0.2, bold: true, italics: true },
        header: {
          margin: [20, 10, 20, 5],
          table: {
            widths: [50, 230, 250],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 4,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 16,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                // Header ด้านขวา ใบสั่งตรวจ
                {
                  rowSpan: 4,
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '\n Sex: ' + this.arrSex[this.A5reportHd.Sex] +
                    '  Age: ' + this.A5reportHd.AgeYears + '.' + this.A5reportHd.AgeMonths + '.' + this.A5reportHd.AgeDays + ' years' +
                    DOBPrn +
                    (this.A5reportHd.IDNo === '' ? '' : '\n ID No.: ' + this.A5reportHd.IDNo) +
                    (this.A5reportHd.PassportNo === '' ? '' : '\n Passport No.: ' + this.A5reportHd.PassportNo) +
                    (this.A5reportHd.Country === '' ? '' : ' / ' + this.A5reportHd.Country) +
                    '\n Clinic: ' + this.A5reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.A5reportHd.RONo + '    Date: ' + this.A5reportHd.DocDate + ' ' + this.A5reportHd.DocTime],
                  bold: true,
                  fontSize: 14,
                  margin: [10, 0, 0, 0],
                  lineHeight: 0.8,
                  border: [0, 0, 0, 0]
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 12,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 +
                        (self.globalCorpInfo.fax !== '' ? ' Fax: ' + self.globalCorpInfo.fax : '') + '\n' +
                        'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                { },
                {
                  image: self.textToBase64Barcode(self.A5reportHd.RONo, 35),
                  width: 100,
                  alignment: 'left',
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                },
                { }
              ],
              [
                {
                  colSpan: 3,
                  text: 'Vital signs :' + this._vitalSignText,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#DCDCDC'
                },
                {},
                {}
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [20, 0, 20, 5],
            table: {
              widths: [220, 150, 150],
              body: [
                [
                  {
                    rowSpan: 3,
                    text: 'L=Result below reference interval\n H=Result above reference interval\n R=Repeat\n' +
                          'This report only certifies samples that have been analyzed. Do not copy the report only partialy ' +
                          'without permission from labaratory Writer',
                    fontSize: 11
                  },
                  { text: 'Reported by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] },
                  { text: 'Approved by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] }],
                ['',
                  {
                    image: self.A5reportHd.OfficerName2Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  },
                  {
                    image: self.A5reportHd.OfficerName3Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                ['',
                  {
                    text: self.A5reportHd.OfficerName2 + '\n' + self.A5reportHd.ResultedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  },
                  {
                    text: self.A5reportHd.OfficerName3 + '\n' + self.A5reportHd.ApprovedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 15,
          lineHeight: 0.7
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // ----------- (III.) รูปแบบใบแสดงผลเป็นฟอร์ม A4 => COLS : Method/NormalValue  ---------- 28.04.2566 คุณธนกฤต //
    createA4PdfForm4ToScreen () {
      var pageMarginsTop = 125
      if (this._vitalSignText === '') { pageMarginsTop = 110 }
      //  ---------------------------------- //
      var PatNamePrn = this.A5reportHd.PatName
      var PatLNamePrn = this.A5reportHd.PatLName
      var PrefixNamePrn = this.A5reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.A5reportHd.PatName2
        PatLNamePrn = this.A5reportHd.PatLName2
        PrefixNamePrn = this.A5reportHd.PrefixName2
      }

      var DOBPrn = ''
      if (this.optDOB) {
        DOBPrn = '  DOB: ' + this.A5reportHd.BirthDate
      }
      // ==================================== //
      // ข้อความลายน้ำชื่อคลินิก
      var strWatermark = ''
      var colorWatermark = 'gray'
      if (this.A5reportHd.Cancel === 1 || this.A5reportHd.Cancel === '1') {
        strWatermark = 'ยกเลิก CANCELED'
        colorWatermark = 'red'
      } else {
        if (this.optWatermark) {
          strWatermark = this.globalCorpInfo.name + ' '
        }
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html : formA5Idx=2 => divToPrint_MasterDtl2
      const pdfTable = document.getElementById('divToPrint_MasterDtl3')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        pageSize: 'A4',
        // pageOrientation: 'landscape',
        pageMargins: [20, pageMarginsTop, 20, 100],
        watermark: { text: strWatermark, color: colorWatermark, opacity: 0.2, bold: true, italics: true },
        header: {
          margin: [20, 10, 20, 5],
          table: {
            widths: [50, 230, 250],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 4,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 16,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                // Header ด้านขวา ใบสั่งตรวจ
                {
                  rowSpan: 4,
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '\n Sex: ' + this.arrSex[this.A5reportHd.Sex] +
                    '  Age: ' + this.A5reportHd.AgeYears + '.' + this.A5reportHd.AgeMonths + '.' + this.A5reportHd.AgeDays + ' years' +
                    DOBPrn +
                    (this.A5reportHd.IDNo === '' ? '' : '\n ID No.: ' + this.A5reportHd.IDNo) +
                    (this.A5reportHd.PassportNo === '' ? '' : '\n Passport No.: ' + this.A5reportHd.PassportNo) +
                    (this.A5reportHd.Country === '' ? '' : ' / ' + this.A5reportHd.Country) +
                    '\n Clinic: ' + this.A5reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.A5reportHd.RONo + '    Date: ' + this.A5reportHd.DocDate + ' ' + this.A5reportHd.DocTime],
                  bold: true,
                  fontSize: 14,
                  margin: [10, 0, 0, 0],
                  lineHeight: 0.8,
                  border: [0, 0, 0, 0]
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 12,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 +
                        (self.globalCorpInfo.fax !== '' ? ' Fax: ' + self.globalCorpInfo.fax : '') + '\n' +
                        'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                { },
                {
                  image: self.textToBase64Barcode(self.A5reportHd.RONo, 35),
                  width: 100,
                  alignment: 'left',
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                },
                { }
              ],
              [
                {
                  colSpan: 3,
                  text: 'Vital signs :' + this._vitalSignText,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#DCDCDC'
                },
                {},
                {}
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [20, 0, 20, 5],
            table: {
              widths: [220, 150, 150],
              body: [
                [
                  {
                    rowSpan: 3,
                    text: 'L=Result below reference interval\n H=Result above reference interval\n R=Repeat\n' +
                          'This report only certifies samples that have been analyzed. Do not copy the report only partialy ' +
                          'without permission from labaratory Writer',
                    fontSize: 11
                  },
                  { text: 'Reported by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] },
                  { text: 'Approved by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] }],
                ['',
                  {
                    image: self.A5reportHd.OfficerName2Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  },
                  {
                    image: self.A5reportHd.OfficerName3Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                ['',
                  {
                    text: self.A5reportHd.OfficerName2 + '\n' + self.A5reportHd.ResultedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  },
                  {
                    text: self.A5reportHd.OfficerName3 + '\n' + self.A5reportHd.ApprovedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 15,
          lineHeight: 0.7
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // ----------- (IV.) รูปแบบใบแสดงผลเป็นฟอร์ม A4 => divToPrint_MasterDtl4
    // : COLS : Wide Result, NormalValue/Method  ---------- 28.06.2566 //
    // : ขยายความกว้าง Result (เผื่อชนิด ข้อความ) และย้าย Ref. & Method ไว้คอลัมส์เดียวกัน
    createA4PdfForm5ToScreen () {
      var pageMarginsTop = 125
      if (this._vitalSignText === '') { pageMarginsTop = 110 }
      //  ---------------------------------- //
      var PatNamePrn = this.A5reportHd.PatName
      var PatLNamePrn = this.A5reportHd.PatLName
      var PrefixNamePrn = this.A5reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.A5reportHd.PatName2
        PatLNamePrn = this.A5reportHd.PatLName2
        PrefixNamePrn = this.A5reportHd.PrefixName2
      }

      var DOBPrn = ''
      if (this.optDOB) {
        DOBPrn = '  DOB: ' + this.A5reportHd.BirthDate
      }
      // ==================================== //
      // ข้อความลายน้ำชื่อคลินิก
      var strWatermark = ''
      var colorWatermark = 'gray'
      if (this.A5reportHd.Cancel === 1 || this.A5reportHd.Cancel === '1') {
        strWatermark = 'ยกเลิก CANCELED'
        colorWatermark = 'red'
      } else {
        if (this.optWatermark) {
          strWatermark = this.globalCorpInfo.name + ' '
        }
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // divToPrint_MasterDtl4 : ขยายความกว้าง Result (เผื่อชนิด ข้อความ) และย้าย Ref. & Method ไว้คอลัมส์เดียวกัน
      const pdfTable = document.getElementById('divToPrint_MasterDtl4')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        pageSize: 'A4',
        // pageOrientation: 'landscape',
        pageMargins: [20, pageMarginsTop, 20, 100],
        watermark: { text: strWatermark, color: colorWatermark, opacity: 0.2, bold: true, italics: true },
        header: {
          margin: [20, 10, 20, 5],
          table: {
            widths: [50, 230, 250],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 4,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 16,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                // Header ด้านขวา ใบสั่งตรวจ
                {
                  rowSpan: 4,
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '\n Sex: ' + this.arrSex[this.A5reportHd.Sex] +
                    '  Age: ' + this.A5reportHd.AgeYears + '.' + this.A5reportHd.AgeMonths + '.' + this.A5reportHd.AgeDays + ' years' +
                    DOBPrn +
                    (this.A5reportHd.IDNo === '' ? '' : '\n ID No.: ' + this.A5reportHd.IDNo) +
                    (this.A5reportHd.PassportNo === '' ? '' : '\n Passport No.: ' + this.A5reportHd.PassportNo) +
                    (this.A5reportHd.Country === '' ? '' : ' / ' + this.A5reportHd.Country) +
                    '\n Clinic: ' + this.A5reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.A5reportHd.RONo + '    Date: ' + this.A5reportHd.DocDate + ' ' + this.A5reportHd.DocTime],
                  bold: true,
                  fontSize: 14,
                  margin: [10, 0, 0, 0],
                  lineHeight: 0.8,
                  border: [0, 0, 0, 0]
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 12,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 +
                        (self.globalCorpInfo.fax !== '' ? ' Fax: ' + self.globalCorpInfo.fax : '') + '\n' +
                        'Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2,
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                { },
                {
                  image: self.textToBase64Barcode(self.A5reportHd.RONo, 35),
                  width: 100,
                  alignment: 'left',
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                },
                { }
              ],
              [
                {
                  colSpan: 3,
                  text: 'Vital signs :' + this._vitalSignText,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#DCDCDC'
                },
                {},
                {}
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [20, 0, 20, 5],
            table: {
              widths: [220, 150, 150],
              body: [
                [
                  {
                    rowSpan: 3,
                    text: 'L=Result below reference interval\n H=Result above reference interval\n R=Repeat\n' +
                          'This report only certifies samples that have been analyzed. Do not copy the report only partialy ' +
                          'without permission from labaratory Writer',
                    fontSize: 11
                  },
                  { text: 'Reported by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] },
                  { text: 'Approved by', alignment: 'center', fontSize: 12, border: [0, 1, 1, 0] }],
                ['',
                  {
                    image: self.A5reportHd.OfficerName2Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  },
                  {
                    image: self.A5reportHd.OfficerName3Sign,
                    width: 30,
                    alignment: 'center',
                    border: [0, 0, 1, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                ['',
                  {
                    text: self.A5reportHd.OfficerName2 + '\n' + self.A5reportHd.ResultedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  },
                  {
                    text: self.A5reportHd.OfficerName3 + '\n' + self.A5reportHd.ApprovedDate,
                    alignment: 'center',
                    fontSize: 12,
                    border: [0, 0, 1, 1]
                  }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 15,
          lineHeight: 0.7
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },

    // ----------- (V.) รูปแบบใบแสดงผลเป็นฟอร์ม A5 (แนวนอน) => COLS : Method/Specimen/NormalValue ---------- //
    //   09.09.2566 นครนายก (ต้นเรื่อง) : เพิ่มจำนวนบรรทัดต่อหน้า/ลดขนาดFont/ลดLinespace/ย่อFooter
    createA5PdfForm1ToScreen_A5L_smFooter () {
      var subHeader = ''
      var pageMarginsTop = 98
      if (this._vitalSignText !== '') {
        pageMarginsTop = pageMarginsTop + 16 // บรรทัดที่แรก บวก 16 pixels
        subHeader = subHeader + 'Vital signs: ' + this._vitalSignText
        if (this.A5reportHd.Specimen !== '') {
          pageMarginsTop = pageMarginsTop + 10 // บรรทัดที่สอง บวกแค่ 10 pixels
          subHeader = subHeader + '\n Specimens : ' + this.A5reportHd.Specimen
        }
      } else if (this.A5reportHd.Specimen !== '') {
        pageMarginsTop = pageMarginsTop + 16
        subHeader = subHeader + 'Specimens : ' + this.A5reportHd.Specimen
      }
      //  ---------------------------------- //
      var PatNamePrn = this.A5reportHd.PatName
      var PatLNamePrn = this.A5reportHd.PatLName
      var PrefixNamePrn = this.A5reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.A5reportHd.PatName2
        PatLNamePrn = this.A5reportHd.PatLName2
        PrefixNamePrn = this.A5reportHd.PrefixName2
      }

      var DOBPrn = ''
      if (this.optDOB) {
        DOBPrn = '  DOB: ' + this.A5reportHd.BirthDate
      }
      // ==================================== //
      // ข้อความลายน้ำชื่อคลินิก
      var strWatermark = ''
      var colorWatermark = 'gray'
      if (this.A5reportHd.Cancel === 1 || this.A5reportHd.Cancel === '1') {
        strWatermark = 'ยกเลิก CANCELED'
        colorWatermark = 'red'
      } else {
        if (this.optWatermark) {
          strWatermark = this.globalCorpInfo.name + ' '
        }
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint_MasterDtlA5L_smFooter')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        pageSize: 'A5',
        pageOrientation: 'landscape',
        pageMargins: [20, pageMarginsTop, 20, 40],
        watermark: { text: strWatermark, color: colorWatermark, opacity: 0.2, bold: true, italics: true },
        header: {
          margin: [20, 10, 20, 5],
          table: {
            widths: [50, 230, 250],
            body: [
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 4,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  fontSize: 16,
                  margin: [0, 0, 0, 0],
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                // ข้อมูลหัวใบสั่งตรวจ
                {
                  rowSpan: 4,
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '\n Sex: ' + this.arrSex[this.A5reportHd.Sex] +
                    '  Age: ' + this.A5reportHd.AgeYears + '.' + this.A5reportHd.AgeMonths + '.' + this.A5reportHd.AgeDays + ' years' +
                    DOBPrn +
                    (this.A5reportHd.IDNo === '' ? '' : '\n ID No.: ' + this.A5reportHd.IDNo) +
                    (this.A5reportHd.HNNo === '' ? '' : ' HN : ' + this.A5reportHd.HNNo) +
                    (this.A5reportHd.PassportNo === '' ? '' : '\n Passport No.: ' + this.A5reportHd.PassportNo) +
                    (this.A5reportHd.Country === '' ? '' : ' / ' + this.A5reportHd.Country) +
                    '\n Clinic: ' + this.A5reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.A5reportHd.RONo + '    Date: ' + this.A5reportHd.DocDate + ' ' + this.A5reportHd.DocTime],
                  // bold: false,
                  // fontSize: 9,
                  // lineHeight: 0.8,
                  bold: true,
                  fontSize: 14,
                  lineHeight: 0.7,
                  margin: [10, 0, 0, 0],
                  border: [0, 0, 0, 0]
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  fontSize: 12,
                  margin: [0, 0, 0, 0],
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 +
                        (self.globalCorpInfo.fax !== '' ? ' Fax: ' + self.globalCorpInfo.fax : '') +
                        (self.globalCorpInfo.email1 !== '' ? '\n Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2 : ''),
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#eeeeee'
                },
                {}
              ],
              [
                { },
                {
                  image: self.textToBase64Barcode(self.A5reportHd.RONo, 35),
                  width: 100,
                  alignment: 'left',
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                },
                { }
              ],
              [
                {
                  colSpan: 3,
                  text: subHeader,
                  alignment: 'right',
                  fontSize: 12,
                  lineHeight: 0.7
                  // fillColor: (subHeader === '' ? '#FFFFFF' : '#DCDCDC')
                },
                {},
                {}
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [20, 0, 20, 0],
            table: {
              widths: [200, 60, 200, 60],
              body: [
                // [
                //   {
                //     colSpan: 2,
                //     image: self.A5reportHd.OfficerName2Sign,
                //     width: 30,
                //     alignment: 'center',
                //     lineHeight: 0,
                //     border: [0, 1, 0, 0],
                //     margin: [0, 0, 0, 0]
                //   }, '',
                //   {
                //     colSpan: 2,
                //     image: self.A5reportHd.OfficerName3Sign,
                //     width: 30,
                //     alignment: 'center',
                //     lineHeight: 0,
                //     border: [0, 1, 0, 0],
                //     margin: [0, 0, 0, 0]
                //   }, ''
                // ],
                [
                  {
                    // colSpan: 2,
                    text: 'Reported by : ' + self.A5reportHd.OfficerName2 + '\n(' + self.A5reportHd.ResultedDate + ')',
                    alignment: 'center',
                    font: 'THSarabunNew',
                    fontSize: 11,
                    lineHeight: 0.5,
                    bold: false,
                    // fillColor: '#eeeeee',
                    border: [0, 1, 0, 0]
                  },
                  {
                    // colSpan: 2,
                    image: self.A5reportHd.OfficerName2Sign,
                    width: 25,
                    // height: 20,
                    alignment: 'center',
                    lineHeight: 0,
                    border: [0, 1, 0, 0],
                    margin: [0, 0, 0, 0]
                  },
                  {
                    // colSpan: 2,
                    text: 'Approved by : ' + self.A5reportHd.OfficerName3 + '\n(' + self.A5reportHd.ApprovedDate + ')',
                    alignment: 'center',
                    font: 'THSarabunNew',
                    fontSize: 11,
                    lineHeight: 0.5,
                    bold: false,
                    // fillColor: '#eeeeee',
                    border: [0, 1, 0, 0]
                  },
                  {
                    // colSpan: 2,
                    image: self.A5reportHd.OfficerName3Sign,
                    width: 25,
                    // height: 20,
                    alignment: 'center',
                    lineHeight: 0,
                    border: [0, 1, 0, 0],
                    margin: [0, 0, 0, 0]
                  }
                ],
                [
                  {
                    colSpan: 3,
                    text: 'L=Result below reference interval, H=Result above reference interval, R=Repeat',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 7,
                    lineHeight: 0.3,
                    margin: [0, -5, 0, 0]
                  }, '', '',
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 7,
                    lineHeight: 0.3,
                    margin: [0, -5, 0, 0]
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'PromptTH' 'Roboto' 'THSarabunNew'
          // font: 'Prompt',
          // fontSize: 10,
          // lineHeight: 0.6
          font: 'THSarabunNew',
          fontSize: 14,
          lineHeight: 0.6
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // ----------- (V.) รูปแบบใบแสดงผลเป็นฟอร์ม A5 (แนวตั้ง) => COLS : Method/Specimen/NormalValue ---------- //
    //   09.09.2566 นครนายก (ต้นเรื่อง) : เพิ่มจำนวนบรรทัดต่อหน้า/ลดขนาดFont/ลดLinespace/ย่อFooter
    createA5PdfForm1ToScreen_A5P_smFooter () {
      // var pageMarginsTop = 140
      // if (this._vitalSignText === '') { pageMarginsTop = 125 }
      var subHeader = ''
      var pageMarginsTop = 120
      if (this._vitalSignText !== '') {
        pageMarginsTop = pageMarginsTop + 16 // บรรทัดที่แรก บวก 16 pixels
        subHeader = subHeader + 'Vital signs: ' + this._vitalSignText
        if (this.A5reportHd.Specimen !== '') {
          pageMarginsTop = pageMarginsTop + 10 // บรรทัดที่สอง บวกแค่ 10 pixels
          subHeader = subHeader + '\n Specimens : ' + this.A5reportHd.Specimen
        }
      } else if (this.A5reportHd.Specimen !== '') {
        pageMarginsTop = pageMarginsTop + 16
        subHeader = subHeader + 'Specimens : ' + this.A5reportHd.Specimen
      }
      //  ---------------------------------- //
      var PatNamePrn = this.A5reportHd.PatName
      var PatLNamePrn = this.A5reportHd.PatLName
      var PrefixNamePrn = this.A5reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.A5reportHd.PatName2
        PatLNamePrn = this.A5reportHd.PatLName2
        PrefixNamePrn = this.A5reportHd.PrefixName2
      }

      var DOBPrn = ''
      if (this.optDOB) {
        DOBPrn = '  DOB: ' + this.A5reportHd.BirthDate
      }
      // ==================================== //
      // ข้อความลายน้ำชื่อคลินิก
      var strWatermark = ''
      var colorWatermark = 'gray'
      if (this.A5reportHd.Cancel === 1 || this.A5reportHd.Cancel === '1') {
        strWatermark = 'ยกเลิก CANCELED'
        colorWatermark = 'red'
      } else {
        if (this.optWatermark) {
          strWatermark = this.globalCorpInfo.name + ' '
        }
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint_MasterDtlA5P_smFooter')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        pageSize: 'A5',
        // pageOrientation: 'landscape',
        pageMargins: [20, pageMarginsTop, 20, 60],
        watermark: { text: strWatermark, color: colorWatermark, opacity: 0.2, bold: true, italics: true },
        header: {
          margin: [10, 10, 10, 5],
          table: {
            widths: [50, 220, 100],
            body: [
              // บรรทัดแรก
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 3,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  colSpan: 2,
                  fontSize: 16,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                }, {}
              ],
              // บรรทัดสอง
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  colSpan: 2,
                  fontSize: 12,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                }, {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 +
                        (self.globalCorpInfo.fax !== '' ? ' Fax: ' + self.globalCorpInfo.fax : '') +
                        (self.globalCorpInfo.email1 !== '' ? ' Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2 : ''),
                  bold: false,
                  colSpan: 2,
                  fontSize: 12,
                  lineHeight: 0.7,
                  fillColor: '#eeeeee'
                }, {}
              ],
              // ข้อมูลใบสั่งตรวจ
              [
                {
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '  Sex: ' + this.arrSex[this.A5reportHd.Sex] +
                    '\n Age: ' + this.A5reportHd.AgeYears + '.' + this.A5reportHd.AgeMonths + '.' + this.A5reportHd.AgeDays + ' years' +
                    DOBPrn +
                    (this.A5reportHd.IDNo === '' ? '' : '\n ID No.: ' + this.A5reportHd.IDNo) +
                    (this.A5reportHd.HNNo === '' ? '' : ' HN : ' + this.A5reportHd.HNNo) +
                    (this.A5reportHd.PassportNo === '' ? '' : ' Passport No.: ' + this.A5reportHd.PassportNo) +
                    (this.A5reportHd.Country === '' ? '' : ' / ' + this.A5reportHd.Country) +
                    '\n Clinic: ' + this.A5reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.A5reportHd.RONo + '    Date: ' + this.A5reportHd.DocDate + ' ' + this.A5reportHd.DocTime],
                  colSpan: 2,
                  // bold: false,
                  // fontSize: 8,
                  // lineHeight: 0.8,
                  bold: true,
                  fontSize: 12,
                  lineHeight: 0.6,
                  // fillColor: '#DCDCCC',
                  margin: [5, 0, 0, 0],
                  border: [0, 0, 0, 0]
                }, {},
                { // Barcode เลขที่เอกสาร
                  image: self.textToBase64Barcode(self.A5reportHd.RONo, 35),
                  width: 100,
                  // fillColor: '#DCDCCC',
                  alignment: 'left',
                  lineHeight: 0.8,
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                }
              ],
              [
                {
                  colSpan: 3,
                  text: subHeader,
                  alignment: 'right',
                  fontSize: 12,
                  lineHeight: 0.7
                  // fillColor: (subHeader === '' ? '#FFFFFF' : '#DCDCDC')
                },
                {},
                {}
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [10, 0, 10, 0],
            table: {
              widths: [120, 60, 120, 60],
              body: [
                // บรรทัดแรก
                [
                  {
                    colSpan: 2,
                    image: self.A5reportHd.OfficerName2Sign,
                    width: 20,
                    // height: 20,
                    alignment: 'center',
                    lineHeight: 0,
                    border: [0, 1, 0, 0],
                    margin: [0, 0, 0, 0]
                  }, {},
                  {
                    colSpan: 2,
                    image: self.A5reportHd.OfficerName3Sign,
                    width: 20,
                    // height: 20,
                    alignment: 'center',
                    lineHeight: 0,
                    border: [0, 1, 0, 0],
                    margin: [0, 0, 0, 0]
                  }, {}
                ],
                // บรรทัดสอง
                [
                  {
                    colSpan: 2,
                    text: 'Reported by : ' + self.A5reportHd.OfficerName2 + '\n(' + self.A5reportHd.ResultedDate + ')',
                    alignment: 'center',
                    font: 'THSarabunNew',
                    fontSize: 11,
                    lineHeight: 0.5,
                    bold: false,
                    // fillColor: '#eeeeee',
                    border: [0, 0, 0, 0]
                  }, {},
                  {
                    colSpan: 2,
                    text: 'Approved by : ' + self.A5reportHd.OfficerName3 + '\n(' + self.A5reportHd.ApprovedDate + ')',
                    alignment: 'center',
                    font: 'THSarabunNew',
                    fontSize: 11,
                    lineHeight: 0.5,
                    bold: false,
                    // fillColor: '#eeeeee',
                    border: [0, 0, 0, 0]
                  }, {}
                ],
                [
                  {
                    colSpan: 3,
                    text: 'L=Result below reference interval, H=Result above reference interval, R=Repeat',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 7,
                    lineHeight: 0.4,
                    margin: [0, -5, 0, 0]
                  }, '', '',
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 7,
                    lineHeight: 0.4,
                    margin: [0, -5, 0, 0]
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          // font: 'THPrompt',
          // fontSize: 10,
          // lineHeight: 0.6
          font: 'THSarabunNew',
          fontSize: 14,
          lineHeight: 0.6
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition).open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // ----------- (V.) รูปแบบใบแสดงผลเป็นฟอร์ม A5 (แนวนอน) => COLS : Method/Specimen/NormalValue ---------- //
    //   09.09.2566 นครนายก (ต้นเรื่อง) : เพิ่มจำนวนบรรทัดต่อหน้า/ลดขนาดFont/ลดLinespace/ย่อFooter
    //   28.09.2566 : ใช้ฟอนต์หนา Prompt.ttf
    // NOT WORK ไม่แสดงเลย
    createA5PdfForm1ToScreen_A5PBold_smFooter () {
      var pageMarginsTop = 140
      if (this._vitalSignText === '') { pageMarginsTop = 125 }
      //  ---------------------------------- //
      var PatNamePrn = this.A5reportHd.PatName
      var PatLNamePrn = this.A5reportHd.PatLName
      var PrefixNamePrn = this.A5reportHd.PrefixName
      if (this.nameIdx === 2) {
        PatNamePrn = this.A5reportHd.PatName2
        PatLNamePrn = this.A5reportHd.PatLName2
        PrefixNamePrn = this.A5reportHd.PrefixName2
      }

      var DOBPrn = ''
      if (this.optDOB) {
        DOBPrn = '  DOB: ' + this.A5reportHd.BirthDate
      }
      // ==================================== //
      // ข้อความลายน้ำชื่อคลินิก
      var strWatermark = ''
      var colorWatermark = 'gray'
      if (this.A5reportHd.Cancel === 1 || this.A5reportHd.Cancel === '1') {
        strWatermark = 'ยกเลิก CANCELED'
        colorWatermark = 'red'
      } else {
        if (this.optWatermark) {
          strWatermark = this.globalCorpInfo.name + ' '
        }
      }
      // ==================================== //
      var logoBase64 = this.getBase64Image(this.$refs.imageid)
      var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint_MasterDtlA5P_smFooter')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        pageSize: 'A5',
        // pageOrientation: 'landscape',
        pageMargins: [10, pageMarginsTop, 10, 60],
        watermark: { text: strWatermark, color: colorWatermark, opacity: 0.2, bold: true, italics: true },
        header: {
          margin: [10, 10, 10, 5],
          table: {
            widths: [50, 220, 100],
            body: [
              // บรรทัดแรก
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 3,
                  image: logoBase64,
                  width: 50,
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                },
                // Header ชื่อคลินิก
                {
                  text: self.globalCorpInfo.name,
                  bold: true,
                  colSpan: 2,
                  fontSize: 10,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                }, {}
              ],
              // บรรทัดสอง
              [
                {},
                {
                  text: self.globalCorpInfo.name2,
                  bold: true,
                  colSpan: 2,
                  fontSize: 8,
                  lineHeight: 0.5,
                  fillColor: '#eeeeee'
                }, {}
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                        self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.tel1 + ' ' + self.globalCorpInfo.tel2 +
                        (self.globalCorpInfo.fax !== '' ? ' Fax: ' + self.globalCorpInfo.fax : '') +
                        (self.globalCorpInfo.email1 !== '' ? ' Email: ' + self.globalCorpInfo.email1 + ' ' + self.globalCorpInfo.email2 : ''),
                  bold: false,
                  colSpan: 2,
                  fontSize: 8,
                  lineHeight: 0.7,
                  fillColor: '#eeeeee'
                }, {}
              ],
              // ข้อมูลใบสั่งตรวจ
              [
                {
                  text: ['Name : ' + PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn +
                    '  Sex: ' + this.arrSex[this.A5reportHd.Sex] +
                    '\n Age: ' + this.A5reportHd.AgeYears + '.' + this.A5reportHd.AgeMonths + '.' + this.A5reportHd.AgeDays + ' years' +
                    DOBPrn +
                    (this.A5reportHd.IDNo === '' ? '' : '\n ID No.: ' + this.A5reportHd.IDNo) +
                    (this.A5reportHd.PassportNo === '' ? '' : ' Passport No.: ' + this.A5reportHd.PassportNo) +
                    (this.A5reportHd.Country === '' ? '' : ' / ' + this.A5reportHd.Country) +
                    '\n Clinic: ' + this.A5reportHd.ReqClinicName +
                    '\n LAB No.: ' + this.A5reportHd.RONo + '    Date: ' + this.A5reportHd.DocDate + ' ' + this.A5reportHd.DocTime],
                  colSpan: 2,
                  bold: false,
                  fontSize: 8,
                  lineHeight: 0.8,
                  // bold: true,
                  // fontSize: 12,
                  // lineHeight: 0.6,
                  // fillColor: '#DCDCCC',
                  margin: [5, 0, 0, 0],
                  border: [0, 0, 0, 0]
                }, {},
                { // Barcode เลขที่เอกสาร
                  image: self.textToBase64Barcode(self.A5reportHd.RONo, 35),
                  width: 100,
                  // fillColor: '#DCDCCC',
                  alignment: 'left',
                  lineHeight: 0.8,
                  border: [0, 0, 0, 0],
                  margin: [0, 0, 0, 0]
                }
              ],
              [
                {
                  colSpan: 3,
                  text: 'Vital signs :' + this._vitalSignText,
                  fontSize: 7,
                  alignment: 'left',
                  margin: [5, 0, 0, 0],
                  lineHeight: 0.7
                  // fillColor: '#DCDCDC'
                },
                {}, {}
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [10, 0, 10, 0],
            table: {
              widths: [120, 60, 120, 60],
              body: [
                // บรรทัดแรก
                [
                  {
                    colSpan: 2,
                    image: self.A5reportHd.OfficerName2Sign,
                    width: 20,
                    // height: 20,
                    alignment: 'center',
                    lineHeight: 0,
                    border: [0, 1, 0, 0],
                    margin: [0, 0, 0, 0]
                  }, {},
                  {
                    colSpan: 2,
                    image: self.A5reportHd.OfficerName3Sign,
                    width: 20,
                    // height: 20,
                    alignment: 'center',
                    lineHeight: 0,
                    border: [0, 1, 0, 0],
                    margin: [0, 0, 0, 0]
                  }, {}
                ],
                // บรรทัดสอง
                [
                  {
                    colSpan: 2,
                    text: 'Reported by : ' + self.A5reportHd.OfficerName2 + '\n(' + self.A5reportHd.ResultedDate + ')',
                    alignment: 'center',
                    font: 'THSarabunNew',
                    fontSize: 11,
                    lineHeight: 0.5,
                    bold: false,
                    // fillColor: '#eeeeee',
                    border: [0, 0, 0, 0]
                  }, {},
                  {
                    colSpan: 2,
                    text: 'Approved by : ' + self.A5reportHd.OfficerName3 + '\n(' + self.A5reportHd.ApprovedDate + ')',
                    alignment: 'center',
                    font: 'THSarabunNew',
                    fontSize: 11,
                    lineHeight: 0.5,
                    bold: false,
                    // fillColor: '#eeeeee',
                    border: [0, 0, 0, 0]
                  }, {}
                ],
                [
                  {
                    colSpan: 3,
                    text: 'L=Result below reference interval, H=Result above reference interval, R=Repeat',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 7,
                    lineHeight: 0.4,
                    margin: [0, -5, 0, 0]
                  }, '', '',
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 7,
                    lineHeight: 0.4,
                    margin: [0, -5, 0, 0]
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THPrompt',
          fontSize: 10,
          lineHeight: 0.6
          // font: 'THPrompt', // 'THSarabunNew',
          // fontSize: 14,
          // lineHeight: 0.6
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    viewResultRO (event, row) {
      // ========== Highlight row =========== //
      if (event.target.parentNode.nodeName !== 'TR') { // ต้องคลิกที่ <TD> เพื่อทำ HighLight แถว
        return
      }
      // แถบสี row ที่คลิก
      this.getSelectedRow(event, row)
      // ==================================== //
      // console.log(row)
      this.$emit('onViewResultEvent', row)
    },
    // แสดงแถบสีว่า เลือก row นี้
    getSelectedRow (event, row) {
      // console.log('row Index :')
      // console.log(event.target.parentNode.rowIndex)
      this.index = event.target.parentNode.rowIndex
      var table = document.getElementById('myLabPrintTable')
      for (var i = 1; i < table.rows.length; i++) {
        table.rows[i].style.backgroundColor = 'white'
        table.rows[i].style.color = 'black'
      }
      table.rows[this.index].style.backgroundColor = 'DeepSkyBlue'
      table.rows[this.index].style.color = 'white'
    }
  }
}
</script>

<style scoped>
img {
    float: left;
    width:  100px;
    height: 100px;
    object-fit: cover;
}
</style>
